import DateFnsUtils from '@date-io/date-fns';
import AssignmentIcon from '@material-ui/icons/Assignment';
import SearchIcon from '@material-ui/icons/Search';
import ChatIcon from '@material-ui/icons/Chat';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import { getAuthorizedUser, moneyFormat } from 'src/utils/Common';
import { useMailOrbitEnabled } from 'src/utils/mailorbitFeature';
import ThumbsUpDownIcon from '@material-ui/icons/ThumbsUpDown';
import FreeBreakfastIcon from '@material-ui/icons/FreeBreakfast';
import AllInboxIcon from '@material-ui/icons/AllInbox';
import QuestionAnswerIcon from '@material-ui/icons/QuestionAnswer';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import PermPhoneMsgIcon from '@material-ui/icons/PermPhoneMsg';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import EditIcon from '@material-ui/icons/Edit';
import { createTheme } from '@material-ui/core/styles';
import CaseOwnerSearch from 'src/components/Selects/CaseOwnerSearch';
import {
  Container,
  Avatar,
  TableRow,
  TableCell,
  Backdrop,
  Table,
  TableHead,
  TableBody,
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Breadcrumbs,
  Button,
  ButtonGroup,
  Card,
  TableContainer,
  Checkbox,
  CardActionArea,
  CardActions,
  CardContent,
  CardHeader,
  Chip,
  FormGroup,
  FormControl,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Link,
  List,
  ListItemSecondaryAction,
  ListItem,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  Snackbar,
  Switch,
  TextField,
  Typography,
  Menu,
  Select,
  InputLabel
} from '@material-ui/core';
import 'date-fns';
import clsx from 'clsx';
import {
  getConsumerScreen,
  getConsumerAddressScreen,
  setConsumerScreen,
  setConsumerAddressScreen,
  getUser
} from 'src/utils/Common';
import { getFilteredTasksRequest, setTask, setTasksFilterModel } from '../../store/actions/taskActions';
import { green, red } from '@material-ui/core/colors';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AttachmentIcon from '@material-ui/icons/Attachment';
import BusinessCenterIcon from '@material-ui/icons/BusinessCenter';
import BusinessCenterRoundedIcon from '@material-ui/icons/BusinessCenterRounded';
import CloseIcon from '@material-ui/icons/Close';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import HomeIcon from '@material-ui/icons/Home';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NextWeekIcon from '@material-ui/icons/NextWeek';
import NextWeekRoundedIcon from '@material-ui/icons/NextWeekRounded';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import SaveIcon from '@material-ui/icons/Save';
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SendOutlinedIcon from '@material-ui/icons/SendOutlined';
import VideogameAssetIcon from '@material-ui/icons/VideogameAsset';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import PropTypes, { array } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useCooldown } from 'src/hooks/useCooldown';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { connect, useDispatch, useSelector } from 'react-redux';
import { communicationActions, CreateOutboundPhoneCall } from 'src/store/slices/communicationSlice';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import validator from 'validator';
import DisplayField from '../../components/DisplayField';
import AppReasonSearch from '../../components/Selects/AppReasonSearch';
import DistributorSearch from 'src/components/Selects/DistributorSearch'
import ProductWorkCaseSearch from '../../components/Selects/ProductWorkCaseSearch';
import RetailerSearch from '../../components/Selects/RetailerSearch';
import ImageIcon from '@material-ui/icons/Image';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import Autocomplete from '@material-ui/lab/Autocomplete';
import {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
} from '../../store/actions';
import ReactFlagsSelect from 'react-flags-select';
import SmsIcon from '@material-ui/icons/Sms';
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import InstagramIcon from '@material-ui/icons/Instagram';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { DataGrid } from '@material-ui/data-grid';
import SearchBar from 'material-ui-search-bar';
import { sc } from 'src/utils/Common';
import Moment from 'moment';
import OmniExcelReport from 'src/components/ExcelExport'
import { FcAddressBook, FcAutomotive, FcGoogle, FcSearch } from 'react-icons/fc';
import { MdPlace } from 'react-icons/md';
import CreateIcon from '@material-ui/icons/Create';
import InformationSurvey from 'src/views/WorkOrder/InformationSurvey';
import AssertInsertDialog from 'src/views/Overview/AssetInsertDialog';
import AssertInsertDaysDialog from 'src/views/Overview/AssetInsertDaysDialog';
import rawCountries from 'src/views/Overview/rawCountries'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Zoom from "@material-ui/core/Zoom";
import Fab from "@material-ui/core/Fab";
import UpIcon from "@material-ui/icons/KeyboardArrowUp";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import OmniChannel from "src/components/OmniChannel/index"
import EmailThreadDialog from "src/components/Email2Case/EmailThreadDialog"
import { maskStringData, maskPhoneData } from 'src/MaskData'
import { options as languageList } from 'src/components/SelectLanguage';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import SendIcon from '@material-ui/icons/Send';
import CancelIcon from '@material-ui/icons/Cancel';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import SearchComponent from 'src/components/RecentSearch/SearchComponent';
import { FaAddressBook, FaSearchLocation } from 'react-icons/fa';
import SplitSearchButton from 'src/components/SplitSearchButton';
import ForConsumer from '../MaterialOrder2/Create/ForConsumer';
import AddIcon from '@material-ui/icons/Add';
import ProductListPage from "src/components/ValueProposition/ProductListPage";
import ValueProposition from "src/components/ValueProposition/index";
import { customerActions, customerThunks } from '../../store/slices/customerSlice'
import ConsentViewPopup from './ConsentDialog';

const useStyles = makeStyles(theme => ({
  rightToRepairConfirmModal: {
    zIndex: theme.zIndex.modal + 1
  },
  rightToRepairConfirmPaper: {
    width: 380,
    maxWidth: 'calc(100vw - 32px)'
  },
  rightToRepairConfirmTitle: {
    fontSize: 18,
    fontWeight: 600,
    lineHeight: 1.3
  },
  rightToRepairConfirmMessage: {
    fontSize: 14,
    lineHeight: 1.45,
    color: theme.palette.text.secondary
  },
  rootTopBar: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    paddingTop: 20,
    paddingLeft: 20,
    paddingBottom: 20,
    paddingRight: 20
  },
  fabGreen: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600]
    }
  },
  fabBlue: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(10),
    color: theme.palette.common.white,
    backgroundColor: '#0078d4',
    "&:hover": {
      backgroundColor: '#106ebe'
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
  inputTopBar: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButtonTopBar: {
    padding: 10
  },
  dividerTopBar: {
    height: 28,
    margin: 4
  },
  cover: {
    height: '140'
  },
  avatarAtanan: {
    backgroundColor: red[500]
  },
  avatar1Atanan: {
    backgroundColor: green[500]
  },
  valueAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchAtanan: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconAtanan: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputAtanan: {
    flexGrow: 1
  },
  pageStyleAtanan: {
    display: 'flex',
    padding: '2px 4px'
  },
  inputAtanan: {
    marginLeft: theme.spacing(1),
    flex: 1
  },
  iconButtonAtanan: {
    padding: 10
  },
  fieldsAtanan: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  actions: {
    justifyContent: 'flex-end'
  },

  cardscontent: {
    minHeight: 500,
    minWidth: 400
  },
  cardsInfoMax: {
    // maxHeight: 230,
    minHeight: 200
  },
  cardsMax: {
    maxHeight: 230,
    minHeight: 230,
  },
  cardsMaxM: {
    maxHeight: 230,
    minHeight: 230,
    position: 'relative',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: '#F5F5F5',
    }
  },
  cardsAssetMax: {
    maxHeight: 550,
    minHeight: 550
  },
  cardsContentMax: {
    maxHeight: 180,
    minHeight: 180
  },
  cardsMaxF: {
    // maxHeight: 230,
    minHeight: 350
  },
  cardsContentMax: {
    maxHeight: 180,
    minHeight: 150
  },
  cardsContentMaxF: {
    // maxHeight: 180,
    minHeight: 300
  },

  cardscontent: {
    minHeight: 350
  },
  cards: {
    minHeight: 630
    // maxHeight: 500,
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  cardArddress: {
    minHeight: 340,
    maxHeight: 340
  },
  fab: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    backgroundColor: '#A9B388',
    transition: 'background-color 0.3s, box-shadow 0.3s',
    '&:hover': {
      backgroundColor: '#5F6F52',
      boxShadow: theme.shadows[16],
      transform: 'scale(1.1)'
    },
    display: 'none',
  },
  fabVisible: {
    display: 'block',
  }
}));
const siyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale
};



const DefaultWorkCase = {
  ConsumerId: 0,
  ProductId: 0,
  ProductionYear: 0,
  ProductionMonth: 0,
  SerialNr: '',
  Product: '',
  SKU: '',
  RightToRepairConsent: false,
  OnSiteOperation: 0,
  WarrantyTypeId: 0,
  IssueId: 1,
  Issue: '',
  RetailerId: 0,
  Retailer: '',
  DistributorId: 1,
  Distributor: '',
  StatusId: 1,
  Comment: '',
  WarrantyDate: null,
  PotentialLiabiltiy: 0,
  AppointmentDate: moment()
    .startOf('day')
    .add(1, 'days')
    .add(12, 'hours')
    .format('YYYY-MM-DD hh:mm'),
  AppointmentEndDate: moment()
    .startOf('day')
    .add(1, 'days')
    .add(13, 'hours')
    .format('YYYY-MM-DD hh:mm')
};

const DefaultGdprValue = {
  ConsumerId: 0,
  Sms: false,
  Email: false,
  Phone: false,
  Whatsapp: false,
  SocialMedia: false,
  Message: false,
  EmployeeId: 0,
  MarketingSms: false,
  MarketingEmail: false,
  MarketingPhone: false,
  MarketingWhatsapp: false,
  MarketingSocialMedia: false,
  MarketingMessage: false,
  ThirdSms: false,
  ThirdEmail: false,
  ThirdPhone: false,
  ThirdWhatsapp: false,
  ThirdSocialMedia: false,
  ThirdMessage: false
};




function AssignedJob({
  className,
  AtananIsler,
  handleRefresh,
  loading,
  setTask,
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials,
  readonly,
  tasks,
  ReceiptNo,
  row,
  authorizedUser
}) {
  const classes = useStyles();
  const SessionUser = getUser();
  const { t } = useTranslation('overview');

  const [Required, setRequired] = React.useState(false);
  const [singlePopUp, setSinglePopUp] = useState(false);
  const [RequiredAddress, setRequiredAddress] = useState(false);

  const [SnackbarOpen, setSnackbarOpen] = useState(false);
  //const caseStatusListSelector = useSelector((state) => state.jobControl.CaseStatusList);
  const [singleWorkOrderId, setSingleWorkOrderId] = useState(0);
  const [savedWorkOrderId, setSaveWorkOrderId] = useState(0);
  const [RequiredWorkCase, setRequiredWorkCase] = useState(false);

  const [GoogleAddressSearchResult, setGoogleAddressSearchResult] = useState(
    []
  );
  const [ExperianAddressSearchResult, setExperianAddressSearchResult] = useState(
    []
  );

  useEffect(() => {
    const formControlElement = document.querySelector('.react-tel-input .form-control');

    if (formControlElement && formControlElement.style.width !== "100%") {
      formControlElement.style.width = "100%";
    }
  }, [classes.formControl]);

  useEffect(() => {
    if (requestFailed) {
      resetTaskCooldown();
    }
  }, [requestFailed]);


  const [
    requiredForInternalNotes,
    setRequiredForInternalNotes
  ] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const locale = localStorage.getItem('i18nextLng');
  const [IssueTypeId, setIssueTypeId] = React.useState(1);
  const [addressGoogleSearch, setaddressGoogleSearch] = React.useState('');
  const [TaskOpenDay, setTaskOpenDay] = React.useState(0);
  const [CountryDataControl, setCountryDataControl] = React.useState({});
  const [OpenMaterialOrder, setOpenMaterialOrder] = useState(false);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [StatusData, setStatusData] = useState([]);
  const [PotentialLiabiltiy, setPotentialLiabiltiy] = useState(true);

  const [rejectDescription, setRejectDescription] = useState('');
  const [changeStatus, setChangeStatus] = useState();
  const [workCaseFeedBacks, setWorkCaseFeedBacks] = useState([]);
  const [anchorElScreen, setAnchorElScreen] = React.useState(null);
  const [anchorElAddressScreen, setAnchorElAddressScreen] = React.useState(
    null
  );
  const [employeeTextSearch, setemployeeTextSearch] = useState('');
  const [stateMobile, setStateMobile] = React.useState({
    top: false
  });
  const [autoGoogleSearch, setAutoGoogleSearch] = useState(false);
  const retailerControlTenantId = [68];

  const tasksFilterModel = useSelector((state) => state.tasksNewReducer.filterModel);
  const TasksData = useSelector((state) => state.tasksNewReducer.response?.tasksScreenResult);
  const TasksScreenData = useSelector((state) => state.tasksNewReducer.response?.tasksScreenResult);
  const detailedExcelData = useSelector((state) => state.tasksNewReducer.response?.excelDetailedDatas)
  const isGetTaskRequestSending = useSelector((state) => state.tasksNewReducer.isRequestSending)
  const requestFailed = useSelector((state) => state.tasksNewReducer.requestFailed)
  const { isOnCooldown: isTaskCooldownActive, remainingSeconds: taskRemainingSeconds, triggerCooldown: triggerTaskCooldown, triggerCooldownByDateRange: triggerTaskCooldownByDateRange, resetCooldown: resetTaskCooldown } = useCooldown('GetTasksDataDetail')

  const dispatch = useDispatch();

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setStateMobile({ ...stateMobile, [anchor]: open });
  };


  const [insertAssetDaysPopup, setInsertAssetDaysPopup] = useState(false)
  const [insertAssetPopup, setInsertAssetPopup] = useState(false)
  var phoneRef;
  const openScreen = Boolean(anchorElScreen);
  const openAddressScreen = Boolean(anchorElAddressScreen);


  const DefaultConsumerValue = {
    SearchId: 0,
    Search: '',
    LanguageCode: '',
    EmployeeId: '',
    Phones: [],
    Addresses: [
      {
        AddressType: '',
        Address: '',
        State: '',
        AddressItem: '',
        Apartment: '',
        City: '',
        Country: '',
        District: '',
        DoorNr: '',
        Latitude: 0,
        Longitude: 0,
        Neighborhood: '',
        PostCode: '',
        Region: '',
        Street: '',
        PrimaryAddress: true,
        AddressTypeId: 1,
        AddressId: 0
      }
    ],
    Title: '',
    FirstName: '',
    MiddleName: '',
    LastName: '',
    Email: '',
    Active: true,
    ConsumerId: 0,
    CustomerTypeId: 0,
    InsurancePlanNumber: '',
    ReferralNumber: '',
    WorkCaseCount: 0,
    AssetCount: 0,
    FeedBackCount: 0,
    CreateEmployee: "",
    UpdateEmployee: "",
    UpdateDate: "",
    CreateDate: "",
    PreferredLanguage: authorizedUser?.TenantLangCode,
    UserLegalEntity: "",
  };


  const [state, setState] = React.useState({
    IdNrScreen: true,
    TaxOfficeScreen: true,
    TaxIdScreen: true,
    ExceptIdScreen: true,
    InsurancePlanNumberScreen: true,
    ReferralNumberScreen: true
  });

  const [stateAddress, setStateAddress] = React.useState({
    StateScreen: true,
    RegionScreen: true,
    ApartmentScreen: true,
    DoorNrScreen: true,
    PostCodeScreen: true,
    LongitudeScreen: true,
    LatitudeScreen: true,
    MapSearchScreen: true,
    AddressScreen: true
  });

  const [modelCode, setModelCode] = useState('');
  const incomingPhoneNumber = useSelector((state) => state.communication.incomingPhoneNumber);
  const phoneChannel = useSelector((state) => state.communication.phoneChannel);
  // Outbound call butonu TopBar'daki Phone Integration ile aynı koşulda gösterilir
  const isPhoneIntegrationEnabled = phoneChannel && phoneChannel.TenantId === SessionUser.TenantId;

  const SaveIssue = (ids) => {
    if (!rejectDescription || !changeStatus) {
      setRequired(true);
      return
    }



    setSinglePopUp(false);
    confirmAlert({
      message: t('lblConfirm'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => handleSaveIssue(ids)
        },
        {
          label: t('Hayir'),
          onClick: () => {
          }
        }
      ]
    });
  };


  const handleSaveIssue = (ids) => {
    const dict = {
      Ids: ids,
      StatusId: changeStatus.Id,
      RejectDescription: rejectDescription,
      EmployeeId: SessionUser.TechnicianId,
      Status: changeStatus.FieldText,
      PotentialLiabiltiy: PotentialLiabiltiy === 1 ? 1 : 0
    };
    setChangeStatus('')
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios.post('/SetTaskStatusByIssue', dict, config).then((response) => {
      const ResponseData = response.data;
    });
    setRejectDescription();
    setSnackbarOpen(true);
    setPotentialLiabiltiy();
    setresponseMessage({
      ErrorCode: 10,
      ErrorDescription: t('SuccessfulOperation')
    });
    setUyariTip('success');

  };


  const handleChangeScreen = event => {
    var Control = { ...state };
    setState({ ...state, [event.target.name]: event.target.checked });
    var Control1 = { ...Control, [event.target.name]: event.target.checked };
    setConsumerScreen(Control1);
  };

  const handleChangeAddressScreen = event => {
    var Control = { ...stateAddress };
    setStateAddress({
      ...stateAddress,
      [event.target.name]: event.target.checked
    });
    var Control1 = { ...Control, [event.target.name]: event.target.checked };
    setConsumerAddressScreen(Control1);
  };

  const {
    IdNrScreen,
    TaxOfficeScreen,
    TaxIdScreen,
    ExceptIdScreen,
    InsurancePlanNumberScreen,
    ReferralNumberScreen
  } = state;

  const {
    StateScreen,
    RegionScreen,
    ApartmentScreen,
    DoorNrScreen,
    PostCodeScreen,
    LongitudeScreen,
    LatitudeScreen,
    MapSearchScreen,
    AddressScreen
  } = stateAddress;

  const [jobSearchPopup, setJobSearchPopup] = useState(false);
  const [LoadingControl, setLoadingControl] = useState(false);
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [ConfirmTitle, setConfirmTitle] = useState('');
  const [ConfirmDescription, setConfirmDescription] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [StartDateSearch, setStartDateSearch] = useState(pastWeek());
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [scroll, setScroll] = React.useState('paper');
  const [secretNotePopUp, SetSecretNotePopUp] = useState(false);
  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);

  var today = new Date();
  const [StartDate, setStartDate] = useState(new Date(today));
  const [EndDate, setEndDate] = useState(new Date(today));
  const [SearchList, setSearchList] = useState({});
  const [openChooseDate, setopenChooseDate] = useState(false);
  const history = useHistory();
  const mailOrbitEnabled = useMailOrbitEnabled();
  //const [SearchType, setSearchType] = useState(1);
  const [TopBarValue, setTopBarValue] = React.useState(-1);
  const [SecretNoteData, setSecretNoteData] = useState([]);
  const [ManuelSmsData, setManuelSmsData] = useState([]);
  const [emailError, setEmailError] = useState('');
  const [ValidControlColor, setValidControlColor] = useState(false);
  const [isButtonDisabled, setisButtonDisabled] = React.useState(false);
  const [RequiredWorkCaseComment, setRequiredWorkCaseComment] = useState(false);
  const [newtel, setNewTel] = useState('');
  const [countryCode, setCountryCode] = useState('');
  const [PhoneTypes, setPhoneTypes] = useState([]);
  const [AddressTypes, setAddressTypes] = useState([]);
  const [consumerTitleData, setConsumerTitleData] = useState([]);
  const [VulnerabilitiesData, setVulnerabilitiesData] = useState([]);
  const [VulnerabilitiesId, setVulnerabilitiesId] = useState(0);
  const [PlaceData, setPlaceData] = useState([]);
  const [WarrantyData, setWarrantyData] = useState([]);
  const [pendingRightToRepairWarrantyTypeId, setPendingRightToRepairWarrantyTypeId] = useState(null);
  const [autoSelectedRightToRepairWarrantyTypeId, setAutoSelectedRightToRepairWarrantyTypeId] = useState(null);
  const [AddressIndex, setAddressIndex] = useState(0);
  const [phoneRefreshKey, setPhoneRefreshKey] = useState(0);
  const [ParamPhonesType, setParamPhonesType] = useState(PhoneTypes[0]);
  const [formData, setFormdata] = useState(DefaultConsumerValue);
  const [AddressPopup, setAddressPopup] = useState(false);
  const [SecretNote, setSecretNote] = useState('');
  const [AddressCount, setAddressCount] = useState(0);
  const [WorkCasePopup, setWorkCasePopup] = useState(false);
  const [Assets, setAssets] = useState([]);
  const [AssetPopup, setAssetPopup] = useState(false);
  const [rightToRepairLoadingAsset, setRightToRepairLoadingAsset] = useState(null);
  const [rightToRepairConfirmationAsset, setRightToRepairConfirmationAsset] = useState(null);
  const [CustomerTypeData, setCustomerTypeData] = useState([]);
  const DefaultCustomerTypeId = CustomerTypeData.some(x => x.Id === 1) ? 1 : 0;
  const [RegionData, setRegionData] = useState([]);
  const [CityData, setCityData] = useState([]);
  const [DistrictData, setDistrictData] = useState([]);
  const [NeighborhoodData, setNeighborhoodData] = useState([]);
  const [PostCodeData, setPostCodeData] = useState([]);
  const [searched, setSearched] = useState('');
  const [Smssearched, setSmsSearched] = useState('');
  const [Rows, setRows] = useState('');
  const [initialRows, setinitialRows] = useState('');
  const [SmsRows, setSmsRows] = useState('');
  // const [Districtfiltered, setDistrictFiltered] = useState(false);
  // const [PostCodefiltered, setPostCodeFiltered] = useState(false);

  const [ServiceShopData, SetServiceShopData] = useState([]);
  const [serviceShopId, setServiceShopId] = useState(SessionUser.ServiceShopId);
  const [openFeedbackPopup, setOpenFeedbackPopup] = useState(false);
  const [openFeedbackDetailPopUp, setOpenFeedbackDetailPopup] = useState(false);
  const [openSmsDetailPopUp, setOpenSmsDetailPopup] = useState(false);
  const [saveControl, setSaveControl] = useState(false);
  const [feedback, setFeedback] = useState([]);
  const [OmniChannelDialog, setOmniChannelDialog] = useState(false)
  const [emailThreadDialogOpen, setEmailThreadDialogOpen] = useState(false)
  const [openMaterialOrdersPopUp, setOpenMaterialOrdersPopUp] = useState(false);
  const [workCaseNumber, setWorkCaseNumber] = useState(0);
  const [ValuePropositionDialog, setValuePropositionDialog] = useState(false);
  const [legalEntityLoaded, setLegalEntityLoaded] = useState(false);
  const [legalEntityFilter, setLegalEntityFilter] = useState('ALL');

  const legalEntityOptions = [
    { value: 'ALL', label: 'ALL' },
    { value: 'BEKO', label: 'BEKO' },
    //{ value: 'Beko + European Appliance', label: 'Beko + European Appliances' },
    { value: 'European Appliances', label: 'European Appliances' },
    //{ value: 'UNKNOWN', label: 'UNKNOWN' }
  ];

  const DefaultAdressSearchValue = {
    TenantId: SessionUser.TenantId,
    Region: '',
    City: '',
    District: '',
    PostCode: '',
    Neighborhood: ''
  };
  const [addressSearch, setAddressSearch] = useState(DefaultAdressSearchValue);
  const [addressSearchResult, setAddressSearchResult] = useState([]);
  const [StatusSeacrh, setStatusSeacrh] = useState(0);

  const [consumerActivePassive, setconsumerActivePassive] = useState(
    t('lblActive')
  );
  const [
    consumerAddressPrimarySecondary,
    setconsumerAddressPrimarySecondary
  ] = useState(t('lblPrimary'));

  const columns = [
    { field: 'lblWorkCaseId', headerName: t('lblWorkCaseID'), width: 150 },
    { field: 'lblWorkOrderId', headerName: t('lblWorkOrderID'), width: 170 },
    { field: 'lblServiceCode', headerName: t('lblServiceShopCode'), width: 150 },
    { field: 'lblServiceShop', headerName: t('lblServiceShop'), width: 200 },
    { field: 'lblWarrantyDate', headerName: t('lblWarrantyDate'), width: 200 },
    { field: 'lblOpenDays', headerName: t('lblOpenDays'), width: 200, sortComparator: (v1, v2) => {
      const n1 = parseInt(String(v1).trim()) || 0;
      const n2 = parseInt(String(v2).trim()) || 0;
      return n1 - n2;
    } },
    { field: 'lblWarrantyType', headerName: t('lblWarrantyType'), width: 200 },
    { field: 'lblStatus', headerName: t('lblStatus'), width: 200 },
    { field: 'lblAppointmentDate', headerName: t('lblAppointmentDate'), width: 200 },
    { field: 'lblStatusNote', headerName: t('lblStatusNote'), width: 200 },
    { field: 'lblCallCenterNote', headerName: t('lblCallCenterNote'), width: 200 },
    {
      field: 'lblRejectDescription',
      headerName: t('lblRejectDescription'),
      width: 200
    },
    {
      field: 'lblSpecialNote',
      headerName: t('lblSpecialNote'),
      width: 200
    },
    {
      field: 'lblFinalNote',
      headerName: t('lblFinalNote'),
      width: 200
    },
    { field: 'lblCustomer', headerName: t('lblConsumer'), width: 150 },
    {
      field: 'CustomerCity',
      headerName: t('lblCustomerCity'),
      width: 200
    },
    { field: 'lblUrgentCustomer', headerName: t('lblUrgentCustomer'), width: 150 },
    { field: 'lblBrand', headerName: t('lblBrand'), width: 150 },
    { field: 'lblProductGroup', headerName: t('lblProductGroup'), width: 150 },
    { field: 'lblSerialNumber', headerName: t('lblSerialNumber'), width: 150 },
    { field: 'lblProductCode', headerName: t('lblProductCode'), width: 150 },
    { field: 'lblProduct', headerName: t('lblProduct'), width: 250 },
    { field: 'lblCallDate', headerName: t('lblCallDate'), width: 150 },
    { field: 'lblRepairDate', headerName: t('lblRepairDate'), width: 150 },
    { field: 'lblTechnician', headerName: t('lblTechnician'), width: 150 },
    { field: 'lblRetailer', headerName: t('lblRetailer'), width: 150 },
    { field: 'lblApplicationType', headerName: t('lblApplicationType'), width: 150 },
    { field: 'lblMaterialOrderList', headerName: t('lblMaterialOrderList'), width: 200 },
    { field: 'lblLabourPrice', headerName: t('lblLabourPrice'), width: 150 },
    { field: 'lblMaterialPrice', headerName: t('lblMaterialPrice'), width: 150 },
    { field: 'lblTransportPrice', headerName: t('lblTransportPrice'), width: 150 },
    { field: 'lblExtraPrice', headerName: t('lblExtraPrice'), width: 150 },
    { field: 'lblTotalPrice', headerName: t('lblTotalPrice'), width: 150 },
    { field: 'lblCreateUser', headerName: t('lblCreateUser'), width: 150 },
    { field: 'lblUpdateUser', headerName: t('lblUpdateUser'), width: 150 },
    { field: 'lblLastWorkOrder', headerName: t('lblLastWorkOrder'), width: 150 },
    { field: 'lblPostalCode', headerName: t('lblPostalCode'), width: 150 }

  ];

  const addressSearchResultColumns = [
    { field: 'Id', headerName: 'Id', width: 120 },
    { field: 'Region', headerName: t('lblRegion'), width: 120 },
    { field: 'City', headerName: t('lblCity'), width: 200 },
    { field: 'District', headerName: t('lblDistrict'), width: 200 },
    { field: 'PostCode', headerName: t('lblPostCode'), width: 120 },
    { field: 'Neighborhood', headerName: t('lblNeighborhood'), width: 120 }
  ];


  const [WorkCaseData, setWorkCaseData] = useState([]);
  const [NewWorkCaseData, setNewWorkCaseData] = useState(DefaultWorkCase);
  const [GdprData, setGdprData] = useState(DefaultGdprValue);
  const [InformationData, setInformationData] = useState([]);
  const [SmsInformationData, setSmsInformationData] = useState([]);
  const [SmsDetailData, setSmsDetailData] = useState([]);

  const [filteredIsler, setFilteredIsler] = useState(AtananIsler);
  const [NewWorkCasePopup, setNewWorkCasePopup] = useState(false);
  const [CaseOwnerName, setCaseOwnerName] = useState('')
  const [CaseOwnerId, setCaseOwnerId] = useState('')
  const [WorkOrderPopup, setWorkOrderPopup] = useState(false);
  const [ConsumerFilePopup, setConsumerFilePopup] = useState(false);
  const [GdprPopup, setGdprPopup] = useState(false);
  const [GdprPopupNew, setGdprPopupNew] = useState(false);
  const [AnonymyzePopup, setAnonymyzePopup] = useState(false);
  const [InformationPopup, setInformationPopup] = useState(false);
  const [SmsInformationPopup, setSmsInformationPopup] = useState(false);
  const [InformationDetailPopup, setInformationDetailPopup] = useState(false);
  const [workOrderId, setWorkOrderId] = useState();
  const [infoServiceShopId, setInfoServiceShopId] = useState();
  const [WorkOrderData, setWorkOrderData] = useState([]);
  const [Files, setFiles] = useState([]);
  const [selectedWarrantyType, setSelectedWarrantyType] = useState([]);
  const [newAssetChosen, setNewAssetChosen] = useState(false);
  const [assetChosen, setAssetChosen] = useState(false);
  const [warrantyDateDisable, setWarrantyDateDisable] = useState(false);
  const [DisabledControl, setDisabledControl] = useState(false);
  const [CountryData, setCountryData] = useState([]);
  const [NpsLowScoreCount, setNpsLowScoreCount] = useState([]);
  const [ServiceShopSelected, setServiceShopSelected] = useState(null);
  const search = '';
  const [caseStatusList, setCaseStatusList] = useState([]);
  const SearchStr = sessionStorage.getItem('SearhResult');
  const [selected, setSelected] = useState(
    SessionUser.TenantCode.toUpperCase()
  );
  const [addressSearchPopup, setAddressSearchPopup] = useState(false);
  const [GoogleAddressSearchPopup, setGoogleAddressSearchPopup] = useState(
    false
  );

  const [feedbackDataList, setFeedbackDataList] = useState([]);
  const [npsLowScoreDataList, setNpsLowScoreDataList] = useState([]);

  const [feedbackList, setFeedbackList] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [smsData, setSmsData] = useState(null);
  const [selectedPhone, setSelectedPhone] = useState([])
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const searchCaseOwner = '';
  const [consumerMaterialOrders, setConsumerMaterialOrders] = useState([]);
  const [fabVisible, setFabVisible] = useState(false);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const LegalEntityTenantIds = [46, 49, 52, 37, 56, 117, 80, 12, 53, 51, 78, 54, 64, 11];

  const LegalEntityTenantOptionMap = {
    37: { value: 'HITACHI', label: 'HITACHI' },
    56: { value: 'HITACHI', label: 'HITACHI' },
    51: { value: 'HITACHI', label: 'HITACHI' },
    78: { value: 'HITACHI', label: 'HITACHI' },
  };

  const extraOption = LegalEntityTenantOptionMap[SessionUser.TenantId];
  if (extraOption) {
    legalEntityOptions.push(extraOption);
  }

  const setCaseOwner = param => {
    setCaseOwnerName(param.Dsc)
    setCaseOwnerId(param.Id)
  };

  const handleUpdateDateChange = (e) => {
    const DateValue = moment(e).format('YYYY.MM.DD');
    setFormdata({ ...formData, UpdateDate: DateValue });
  }

  const handleCreateDateChange = (e) => {
    const DateValue = moment(e).format('YYYY.MM.DD');
    setFormdata({ ...formData, CreateDate: DateValue });
  }

  const requiredWarrantyTypesRussia = [1, 2, 3, 16, 17];

  function isWarrantyDateRequired() {
    return (
      SessionUser.IsIhpTenant &&
      requiredWarrantyTypesRussia.includes(Number(NewWorkCaseData.WarrantyTypeId))
    );
  }

  useEffect(() => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2) {
      setDisabledControl(true);
    }
  }, [SessionUser.Role]);
  useEffect(() => {
    setCaseStatusList([]);
    if (Required) {
      setSaveControl(false);
    }
  }, [Required]);
  useEffect(() => {
    setLoading2(true);
    GetDistrictData("0", "0");
    GetPostCode('0', '0', '0');
    setLoading2(false);
  }, []);

  useEffect(() => {
    if (autoGoogleSearch) {
      SearchGoogleAddress();
    }
  }, [autoGoogleSearch])

  useEffect(() => {
    if (incomingPhoneNumber) {
      setNewTel(incomingPhoneNumber);
      setCountryCode(SessionUser.TenantCode);
      SetCountry(SessionUser.TenantCode.toUpperCase(), AddressIndex);
      dispatch(communicationActions.clearIncomingPhoneNumber());
    }
  }, [incomingPhoneNumber]);

  const StartDatehandleChange = value => {
    var Deger = moment(value).format('YYYY-MM-DD');
    setStartDate(Deger);
    sessionStorage.removeItem('StartDate');
    sessionStorage.setItem('StartDate', Deger);
  };

  const SetWarrantyDate = value => {
    var DateValue = moment(value).format('YYYY-MM-DD');

    setNewWorkCaseData({ ...NewWorkCaseData, WarrantyDate: DateValue });
  };

  const handleClickScreen = event => {
    setAnchorElScreen(event.currentTarget);
  };

  const handleClickAddressScreen = event => {
    setAnchorElAddressScreen(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElScreen(null);
  };
  const handleAddressClose = () => {
    setAnchorElAddressScreen(null);
  };



  const setAppointmentData = value => {
    var DateValue = moment(value).format('YYYY-MM-DD HH:mm');
    var PresentDate = moment(new Date()).format('YYYY-MM-DD HH:mm');
    var EndDateValue = moment(value)
      .add(1, 'hours')
      .format('YYYY-MM-DD HH:mm');
    if (DateValue < PresentDate) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Please make sure you select the appointment date correctly!')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    } else {
      setNewWorkCaseData({
        ...NewWorkCaseData,
        AppointmentDate: DateValue,
        AppointmentEndDate: EndDateValue
      });
    }
  };

  const EndDatehandleChange = value => {
    var Deger = moment(value).format('YYYY-MM-DD');
    setEndDate(Deger);
    sessionStorage.removeItem('EndDate');
    sessionStorage.setItem('EndDate', Deger);
  };

  const handleRefreshDate = e => {
    setopenChooseDate(false);
    handleRefresh();
  };

  const GetServiceShopRequest = () => {
    axios
      .get('/GetServiceShopRequest/')
      .then(response => {
        if (response.data.length > 0) {
          var Data = response.data;
          var allServiceShop = { ServiceShopId: 0, Dsc: t('lblAllServiceShop') };
          var subServiceShopControlNew = [...Data, allServiceShop];
          SetServiceShopData(subServiceShopControlNew.sort((a, b) => (a.ServiceShopId > b.ServiceShopId ? 1 : -1)));
        }
      })
      .catch(error => { });
  };

  const GetManuelSmsEmailTemplate = () => {
    setLoading2(true);
    axios
      .get('/GetManuelSmsEmailTemplate/')
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setManuelSmsData([]);
        } else {
          setManuelSmsData(ResponseData);
        }
        setLoading2(false);
      })
      .catch(error => {
        setManuelSmsData([]);
        setLoading2(false);
      });
  };

  const handleOutboundCall = (phoneNumber) => {
    confirmAlert({
      message: t('lblOutboundCallConfirm'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => {
            dispatch(CreateOutboundPhoneCall({ consumerId: formData.ConsumerId, phoneNumber }))
              .unwrap()
              .then((result) => {
                const isFailed = !(typeof result === 'string' && result.startsWith('Call initiated'));
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t(isFailed ? 'lblOutboundCallFailed' : 'lblOutboundCallStarted')
                });
                setUyariTip(isFailed ? 'error' : 'success');
                setUyari(true);
              })
              .catch(() => {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblOutboundCallFailed')
                });
                setUyariTip('error');
                setUyari(true);
              });
          }
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleClickMap = (event, Latitude, Longitude) => {
    window.open(process.env.REACT_APP_MAP_URL + Latitude + ',' + Longitude);
    event.persist();
  };

  const handleSearchEngineClick = (options, selectedIndex) => {

    //google set from below -> manual sorry
    if (selectedIndex == 1) {
      SearchGoogleAddress();
    }
    else if (selectedIndex == 0)//Experian for UK (for now?..)
    {
      SearchWithExperianMulesoft();
    }
  };

  const GetSecretNote = SearchId => {
    setLoading2(true);
    axios
      .get('/GetConsumerSecretNote/' + SearchId)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setSecretNoteData([]);
        } else {
          setSecretNoteData(ResponseData);
        }
        setLoading2(false);
      })
      .catch(error => {
        setSecretNoteData([]);
        setLoading2(false);
      });
  };

  const validateEmail = event => {
    var email = event.target.value;
    if (validator.isEmail(email) || email === '') {
      setEmailError('');
      setValidControlColor(false);
    } else {
      setEmailError('Enter valid Email!');
      setValidControlColor(true);
    }
    setFormdata({ ...formData, Email: event.target.value });
  };

  function pastWeek() {
    var today = new Date();
    var pastWeek = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - 7
    );
    return pastWeek;
  }

  function closeInserAssetDaysPopup() {
    setInsertAssetDaysPopup(false)
  }

  function handleOnChange(value, country) {
    setNewTel(value);
    setCountryCode(country.dialCode);
    SetCountry(country.countryCode.toUpperCase(), AddressIndex);
  }

  function handleOnAdd() {
    if (SessionUser.TenantId === 68) {
      const phoneNumber = newtel.slice(countryCode.length);
      if (phoneNumber.length !== 10) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('The phone number must be 10 digits long.')
        });
        setUyariTip('error');
        setUyari(true);
        setRequired(true);
        return;
      }
    }
    axios
      .get('/CheckPhoneNumber/' + newtel)
      .then(response => {
        let ResponseData = response.data;
        // If the user select CustomerType 'Return' as customerType (9 or 10)
        // There will be a an exception in which 
        // we wont check if the user have already that phone number
        if (formData.CustomerTypeId == 9 || formData.CustomerTypeId == 10 || SessionUser.TenantId == 53 || SessionUser.TenantId == 12) {
          ResponseData = ""
        }
        if (ResponseData.length !== 0) {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription:
              ' Id: ' + ResponseData[0].ConsumerId + ' ' +
              ResponseData[0].Title + ' ' +
              ResponseData[0].FirstName + ' ' +
              ResponseData[0].MiddleName + ' ' +
              ResponseData[0].LastName
          });
          // if (ResponseData.ErrorCode === 10) {
          //   history.push('/overview');
          // }
          setUyariTip('error');
          setUyari(true);
          setRequired(true);
          return;
        }
        else {
          if (
            newtel === '' ||
            newtel === undefined ||
            ParamPhonesType === 0 ||
            ParamPhonesType === undefined ||
            ParamPhonesType === ''
          ) {
            setresponseMessage({
              ErrorCode: 10,
              ErrorDescription: t('lblMustFieldControl')
            });
            setUyariTip('error');
            setUyari(true);
            setRequired(true);
            return;
          }
          var PhonesData = [];
          if (formData.Phones?.length > 0)
            PhonesData = [...formData.Phones];

          var PhoneType = PhoneTypes.filter(item => item.Id === ParamPhonesType);
          var Data = {
            PhoneId: 0,
            Phone: newtel,
            PhoneTypeId: ParamPhonesType,
            PhoneType: PhoneType[0].Dsc
          };
          PhonesData.push(Data);
          setFormdata({ ...formData, Phones: PhonesData });
          setNewTel(countryCode);
        }
      })
      .catch(error => {
      });
  }

  function handleOnAddressAdd() {
    if (formData.ConsumerId === 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }

    const selected = formData.Addresses;
    var filteredIndex = selected.findIndex(x => x.AddressId === 0);

    if (filteredIndex > -1) {
      selected.splice(filteredIndex, 1);
      setFormdata({ ...formData, Addresses: selected });
    }

    var PrimaryControl = true;

    var ControlAddress = formData.Addresses.filter(
      x => x.PrimaryAddress === true
    );

    if (ControlAddress.length > 0) {
      PrimaryControl = false;
    }

    var AddressesData = [...formData.Addresses];
    var Data = {
      AddressType: '',
      Address: '',
      State: '',
      AddressItem: '',
      Apartment: '',
      City: '',
      Country: SessionUser.TenantCode.toUpperCase(),
      District: '',
      DoorNr: '',
      Latitude: 0,
      Longitude: 0,
      Neighborhood: '',
      PostCode: '',
      Region: '',
      Street: '',
      PrimaryAddress: PrimaryControl,
      AddressTypeId: 1,
      AddressId: 0
    };
    AddressesData.push(Data);

    setFormdata({ ...formData, Addresses: AddressesData });
    setAddressIndex(AddressesData.length - 1);
  }
  const isMatchingSearch = (field) =>
    typeof field === 'string' && field.toLowerCase().includes(employeeTextSearch.toLowerCase());

  const filteredTasksData = TasksScreenData.filter((task) =>
    isMatchingSearch(task.lblCreateUser) ||
    isMatchingSearch(task.lblUpdateUser) ||
    isMatchingSearch(task.lblTechnician)
  );
  const GetPhoneTypes = () => {
    var phoneData = sessionStorage.getItem('phoneTypeData');
    if (phoneData !== undefined && phoneData !== null && JSON.parse(phoneData)[0].LanguageCode == localStorage.getItem('i18nextLng')) {
      setPhoneTypes(JSON.parse(phoneData));
      setParamPhonesType(JSON.parse(phoneData)[0].Id);
    }
    else {
      axios
        .get(`/GetPhoneTypes`)
        .then(response => {
          if (response.data.length > 0) {
            setPhoneTypes(response.data);
            var jsonData = JSON.stringify(response.data);
            sessionStorage.setItem('phoneTypeData', jsonData);
            setParamPhonesType(response.data[0].Id);
          }
        })
        .catch(error => { });
    }
  };
  const GetCustomerType = () => {
    axios
      .get(`/GetCustomerType`)
      .then(response => {
        if (response.data.length > 0) {
          setCustomerTypeData(response.data);
          const defaultType = response.data.find(x => x.Id === 1);
          if (defaultType) {
            setFormdata(prev => ({
              ...prev,
              CustomerTypeId: prev.CustomerTypeId === 0 ? defaultType.Id : prev.CustomerTypeId
            }));
          }
        }
      })
      .catch(error => { });
  };
  const GetPlace = () => {
    axios
      .get(`/GetPlace`)
      .then(response => {
        if (response.data.length > 0) {
          setPlaceData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetWarranty = () => {
    axios
      .get(`/GetSiriusWarrantyType`)
      .then(response => {
        if (response.data.length > 0) {
          setWarrantyData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetAddressTypes = () => {
    axios
      .get(`/GetAddressTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setAddressTypes(response.data);
        }
      })
      .catch(error => { });
  };
  const GetVulnerabilitiesData = () => {
    axios
      .get(`/GetVulnerabilities`)
      .then(response => {
        if (response.data.length > 0) {
          setVulnerabilitiesData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetConsumerTitlesData = () => {
    axios
      .get(`/GetConsumerTitles`)
      .then(response => {
        if (response.data.length > 0) {
          setConsumerTitleData(response.data);
        }
      })
      .catch(error => { });
  };
  const GetCountryData = () => {
    axios
      .get(`/GetCountryList`)
      .then(response => {
        if (response.data.length > 0) {
          setCountryData(response.data);
        }
      })
      .catch(error => { });
  };


  function handleChangeAddressId(event, index) {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }

    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[index], AddressTypeId: Value };
    Data[index] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
  }

  function handleChangeCountry(event, index) {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.innerText;
    }
    if (Value != null || Value != undefined)
      Value = CountryData.find(q => q.CountryName === Value);

    var Data = [...formData.Addresses];
    var CountryItem = { ...Data[index], Country: Value };
    Data[index] = CountryItem;
    setFormdata({ ...formData, Addresses: Data });
  }

  function handleChangeAddress(event, index) {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[index], [event.target.id]: Value };
    Data[index] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
  }

  function handleChangeAddressSearch(event) {

    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }

    setAddressSearch({ ...addressSearch, [event.target.id]: Value });
  }

  useEffect(() => {
    setFormdata(formData);
    // handleConsumerWorkCase(0);
  }, [formData]);

  const ControlSearch = sessionStorage.getItem('AddNewCustomer');

  var phoneTypeData = [];
  if (PhoneTypes.length === 0) {
    var storagePhoneData = sessionStorage.getItem('phoneTypeData');
    if (storagePhoneData) {
      phoneTypeData = JSON.parse(storagePhoneData);
      GetPhoneTypes();
    }
  }
  var isNewCustomer = false;

  useEffect(() => {
    if (ControlSearch !== undefined && ControlSearch !== null &&
      (PhoneTypes.length > 0 || phoneTypeData.length > 0)) {
      isNewCustomer = true;
      GetSecretNote(0);

      // rawCountries PhoneInput componenti içindeki rawCountries.js'in bu projenin içine kopyalamasından alınıyor
      var countryDialCode = rawCountries
      countryDialCode = countryDialCode.filter(x => x[2] == SessionUser.TenantCode)[0]

      setFormdata({
        ...DefaultConsumerValue,
        CustomerTypeId: DefaultCustomerTypeId,
        Phones: [
          {
            PhoneTypeId: PhoneTypes[0].Id,
            PhoneType: PhoneTypes[0].Dsc,
            PhoneId: 0,
            Phone: CountryDataControl?.dialCode ? CountryDataControl?.dialCode + ControlSearch : countryDialCode[3] + ControlSearch
          }
        ]
      });
      setAddressIndex(0);
      setVulnerabilitiesId(0);
      sessionStorage.removeItem('AddNewCustomer');
      sessionStorage.removeItem('SearhResult');
      sessionStorage.removeItem('ConsumerId');
      setRequired(false);
    }
  }, [ControlSearch]);

  useEffect(() => {
    var Control = sessionStorage.getItem('UserTypeControl');
    var Control1 = 0;
    if (Control === undefined || Control === null) {
      sessionStorage.setItem('UserTypeControl', SessionUser.UserType);
      Control1 = SessionUser.UserType;
    }
    if (Control1 === 1) {
      setJobSearchPopup(true);
    }
    var ConsumerScreenLocal = getConsumerScreen();
    var ConsumerAddressScreenLocal = getConsumerAddressScreen();

    if (ConsumerScreenLocal !== null) {
      setState(ConsumerScreenLocal);
    }
    if (ConsumerAddressScreenLocal !== null) {
      setStateAddress(ConsumerAddressScreenLocal);
    }
  }, []);

  const DeletePhoneItem = (event, Phone) => {
    const selectedChangePhones = formData.Phones;
    var filteredIndex = selectedChangePhones.findIndex(x => x.Phone === Phone);
    selectedChangePhones.splice(filteredIndex, 1);
    setFormdata({ ...formData, Phones: selectedChangePhones });
  };
  const setAddressPopupEdit = (event, row, index) => {
    setAddressIndex(index);
    setAddressPopup(false);
    GetDistrictDataForPopUp(row.City, row.regionName == "" ? "0" : row.regionName);
    GetPostCode(row.regionName == "" ? "0" : row.regionName, row.City, '0');
  };

  const getAddressHeader = row => {
    var Label = t('lblPrimary');
    if (row.PrimaryAddress === true) {
      Label = t('lblPrimary');
    } else {
      Label = t('lblSecondary');
    }
    var ReturnValue = (
      <Chip
        style={{ color: row.PrimaryAddress === true ? 'green' : 'red' }}
        icon={<HomeIcon />}
        label={Label}
      />
    );
    return ReturnValue;
  };

  const GetConsumerAssetsData = () => {
    setLoading2(true);
    axios
      .get('/GetConsumerAssets/' + formData.ConsumerId)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setAssets([]);
        } else {
          setAssets(ResponseData);
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetConsumerFileData = () => {
    setLoading2(true);
    axios
      .get('/GetConsumerFiles/' + formData.ConsumerId + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setFiles([]);
        } else {
          setFiles(ResponseData);
        }
        setLoading2(false);
        setConsumerFilePopup(true);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetConsumerAssets = () => {
    setLoading2(true);
    axios
      .get('/GetConsumerAssets/' + formData.ConsumerId)
      .then(response => {
        const ResponseData = response.data;
        if (ResponseData.length === 0) {
          setAssets([]);
        } else {
          setAssets(ResponseData);
        }
        setAssetPopup(true);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const SetAssetRightToRepairConsent = asset => {
    setRightToRepairLoadingAsset(asset);
    const request = {
      ConsumerId: formData.ConsumerId,
      ProductId: asset.ProductId,
      ProductCode: asset.ProductCode,
      ProductionYear: asset.ProductionYear,
      ProductionMonth: asset.ProductionMonth,
      SerialNr: asset.SerialNr,
      Barcode: asset.Barcode,
      WarrantyTypeId: asset.WarrantyId,
      RetailerId: asset.RetailerId
    };

    axios
      .post('/SetAssetRightToRepairConsent', request, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        const responseData = response.data;
        if (String(responseData?.ErrorCode) === '0') {
          setAssets(currentAssets =>
            currentAssets.map(currentAsset =>
              currentAsset === asset
                ? { ...currentAsset, RightToRepairConsent: true }
                : currentAsset
            )
          );
          return;
        }

        setresponseMessage({
          ErrorCode: responseData?.ErrorCode || 10,
          ErrorDescription: responseData?.ErrorDescription || t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
      })
      .catch(() => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
      })
      .finally(() => {
        setRightToRepairLoadingAsset(null);
      });
  };

  const ConfirmAssetRightToRepairConsent = asset => {
    if (!asset.RightToRepairEligible || asset.RightToRepairConsent || rightToRepairLoadingAsset === asset) {
      return;
    }

    setRightToRepairConfirmationAsset(asset);
  };
  const handleChangeAddressPrimary = (event, AddressIndex) => {
    var Value;
    if (event.target.type === 'checkbox') {
      Value = event.target.checked;
    } else {
      Value = event.target.value;
    }
    var Data = [...formData.Addresses];

    if (Data.length === 1) {
      Value = true;
    }

    if (Value == false) {
      setresponseMessage({
        ErrorCode: '10',
        ErrorDescription: t('lblPrimaryAddressWarning')
      });
      setUyari(true);
      setUyariTip('warning');
      return;
    }

    Data.forEach(item => {
      item.PrimaryAddress = false;
    });

    var AddressItem = { ...Data[AddressIndex], [event.target.id]: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    if (Value) {
      setconsumerAddressPrimarySecondary(t('lblPrimary'));
    } else {
      setconsumerAddressPrimarySecondary(t('lblSecondary'));
    }
  };
  const handleConsumerWorkCase = (value) => {
    var ControlServiceShopId = SessionUser.ServiceShopId === null ? 0 : SessionUser.ServiceShopId;
    setLoading2(true);
    setLegalEntityFilter('ALL');
    axios
      .get(`/GetConsumerWorkCase/` + formData.ConsumerId + '/' + ControlServiceShopId + '/' + SessionUser.Role)
      .then(response => {
        if (response.data.length > 0) {
          setWorkCaseData(response.data);
          setinitialRows(response.data);
          if (!legalEntityLoaded && response.data[0]?.LegalEntity) {
            // SessionStorage'a kaydet
            sessionStorage.setItem('LegalEntity', response.data[0].LegalEntity);
            setFormdata(prevFormData => ({
              ...prevFormData,
              LegalEntity: response.data[0].LegalEntity
            }));
            setLegalEntityLoaded(true);
          }

          if (value === 0) {
            setWorkCasePopup(false);
          } else {
            setWorkCasePopup(true);
          }
        }
        //setWorkCaseNumber(response.data.length);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const getCaseStatus = () => {
    setLoading2(true);
    axios
      .get(`/GetCaseStatus`)
      .then(response => {
        if (response.data.length > 0) {
          setCaseStatusList(response.data);
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };



  const SetOpenSinglePage = (item) => {
    setOpenFeedbackPopup(false);
    setLoading2(true);
    setWorkCaseFeedBacks([]);
    axios.get(`/GetWorkCaseFeedbacks/${item.WorkCaseId}`)
      .then(response => {
        if (response.data.length > 0) {
          setWorkCaseFeedBacks(response.data);
          setSinglePopUp(true);

          setRequired(false);
          setSingleWorkOrderId(item.WorkCaseId);
          setPotentialLiabiltiy(Boolean(item.PotentialLiabiltiy));
          setRejectDescription('')
          setChangeStatus([]);

          setSinglePopUp(true);
          setLoading2(false);
        }
        else {
          setWorkCaseFeedBacks([]);
          setSingleWorkOrderId(item.WorkCaseId);
          setPotentialLiabiltiy(Boolean(item.PotentialLiabiltiy));
          setSinglePopUp(true);

          setRequired(false);
          setLoading2(false);
        }
      })
      .catch(error => { });
    setLoading2(false);
  }
  const SaveCompensation = (ReceiptNo) => {
    const dataBody = {
      WorkOrderId: ReceiptNo,
    };
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetCompensationForPotentialLiability', dataBody, dataConfig)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        if (res[0].ErrorCode === 0) {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('success_message')
          });
          setUyariTip('success');
          setUyari(true);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: res[0].ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        setUyari(true);
      });
  }

  const handlePotentialLiabiltiy = event => {
    event.persist();
    var PotentialLiabiltiy = 0;
    if (event.target.checked) {
      PotentialLiabiltiy = 1;
    } else {
      PotentialLiabiltiy = 0;
    }

    let job = NewWorkCaseData;
    job = {
      ...job,
      PotentialLiabiltiy: PotentialLiabiltiy
    };
    setNewWorkCaseData(job);
  };


  const setIssue = param => {
    var Data = { ...NewWorkCaseData };
    setRequiredWorkCase(false);
    setRequiredWorkCaseComment(false);
    Data.Issue = param.Dsc;
    Data.IssueId = param.Id;
    Data.Comment = param.Dsc + '  ';
    setIssueTypeId(param.Type);
    setNewWorkCaseData(Data);
  };
  const setRetailer = param => {
    var Data = { ...NewWorkCaseData };
    Data.Retailer = param.Dsc;
    Data.RetailerId = param.Id;
    setNewWorkCaseData(Data);
  };
  const setDistributor = param => {
    var Data = { ...NewWorkCaseData };
    Data.Distributor = param.Dsc;
    Data.DistributorId = param.Id;
    setNewWorkCaseData(Data)
  };
  const setProduct = param => {
    var Data = { ...NewWorkCaseData };
    Data.Product = param.Dsc;
    Data.ProductId = param.Id;
    Data.SKU = param.ModelCode;
    setModelCode(param?.ModelCode);
    setNewWorkCaseData(Data);
    setNewAssetChosen(param.Id > 0);
  };

  useEffect(() => {
    if (SearchStr?.length > 0 && !isNewCustomer) {
      const SearchJson = SearchStr ? JSON.parse(SearchStr) : '';
      setSearchList(SearchJson);
      setFormdata(SearchJson);
      GetSecretNote(SearchJson.ConsumerId);
      if (SearchJson.Addresses[AddressIndex]?.City) {
        GetDistrictDataForPopUp(SearchJson.Addresses[AddressIndex]?.City, SearchJson.Addresses[AddressIndex]?.Region);

        if (SearchJson.Addresses[AddressIndex]?.District) {
          GetNeighborhood(
            SearchJson.Addresses[AddressIndex]?.City,
            SearchJson.Addresses[AddressIndex]?.District
          );
          if (SearchJson.Addresses[AddressIndex]?.Region) {
            GetPostCode(
              SearchJson.Addresses[AddressIndex]?.Region,
              SearchJson.Addresses[AddressIndex]?.City,
              SearchJson.Addresses[AddressIndex]?.District
            );
          }
        }
      }
    }
  }, [SearchStr, phoneRefreshKey]);

  useEffect(() => {
    const handlePhoneNavigate = () => {
      setPhoneRefreshKey(k => k + 1);
    };
    window.addEventListener('phoneNavigateToCustomer', handlePhoneNavigate);
    return () => window.removeEventListener('phoneNavigateToCustomer', handlePhoneNavigate);
  }, []);

  useEffect(() => {
    const handlePhoneCreate = () => {
      sessionStorage.removeItem('SearhResult');
      sessionStorage.removeItem('ConsumerId');
      setSearchList(null);
      setFormdata({ ...DefaultConsumerValue });
      setAddressIndex(0);
      setVulnerabilitiesId(0);
      setRequired(false);
    };
    window.addEventListener('phoneCreateCustomer', handlePhoneCreate);
    return () => window.removeEventListener('phoneCreateCustomer', handlePhoneCreate);
  }, []);

  useEffect(() => {
    GetRegionRequest();
    GetServiceShopRequest();
    GetPhoneTypes();
    GetAddressTypes();
    GetVulnerabilitiesData();
    GetConsumerTitlesData();
    GetPlace();
    getCaseStatus();
    GetWarranty();
    GetCountryData();
    GetCustomerType();
  }, [locale]);

  useEffect(() => {
    setRows(WorkCaseData);
  }, [WorkCaseData]);
  useEffect(() => {
    const stored = sessionStorage.getItem('SearhResult');
    if (!stored) return;
    try {
      const result = JSON.parse(stored);
      // GetSearchMain’den gelen WorkCaseCount’u burada alıyoruz
      if (result.WorkCaseCount !== undefined && result.WorkCaseCount !== null) {
        setWorkCaseNumber(result.WorkCaseCount);
      }
    } catch (e) {
      console.error('SearhResult parse error', e);
    }
  }, []);
  useEffect(() => {
    axios
      .get('/GetSiriusCloseStatus')
      .then(response => {
        const Deger = response.data;
        if (Deger.length > 0) {
          var allServiceShop = { StatusId: 0, FieldText: t('lblAllStatus') };
          var subServiceShopControlNew = [...Deger];
          subServiceShopControlNew.push(allServiceShop)
          setStatusData(subServiceShopControlNew.sort((a, b) => (a.StatusId > b.StatusId ? 1 : -1)));
          var Value = Deger.filter(x => x.MobileStatusId === 1);
          setStatusSeacrh(Value[0].StatusId);
        }

        setLoadingControl(false);
      })
      .catch(error => {
        setLoadingControl(false);
      });
    //setSonDurum(SonlandirData[0]?.LatestStatus || '0');
  }, [SessionUser.ServiceShopId]);

  const GetRegionRequest = () => {
    setLoading2(true);
    axios
      .get('/GetRegionRequest/')
      .then(response => {
        setRegionData(response.data);
        if (response.data.length == 1) {
          GetCityRequest();
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetCity = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], Region: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });

    if (RegionData.includes(newInputValue)) {
      GetCityRequestByRegion(newInputValue);
    } else {
      changeRegionAndCityData(selected);
    }
  };

  const GetCityRequestByRegion = regionName => {
    setLoading2(true);
    axios
      .get('/GetCityRequestByRegion/' + regionName)
      .then(response => {
        setCityData(response.data);

        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetCityRequest = () => {
    setLoading2(true);
    axios
      .get('/GetCityRequest/')
      .then(response => {
        setCityData(response.data);

        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetCityRequestByDistrict = districtName => {
    setLoading2(true);
    axios
      .get('/GetCityRequestByDistrict/' + districtName)
      .then(response => {
        setCityData(response.data);

        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  // const GetCityRequestByDistrictbyPostCode  = PostCode =>  {
  //   setLoading2(true);
  //   axios
  //     .get('/GetCityRequestByPostCode/'+PostCode)
  //     .then(response => {
  //       setCityData(response.data);

  //       setLoading2(false);
  //     })
  //     .catch(error => {
  //       setLoading2(false);
  //     });
  // };

  const GetDistrictRequest = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], City: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    //if (!CityData.includes(newInputValue)) {
    var Data = [...formData.Addresses];
    if (Data[AddressIndex].District != "") {
      var AddressItem = { ...Data[AddressIndex], District: '', PostCode: '', Neighborhood: '' };
      Data[AddressIndex] = AddressItem;
      setFormdata({ ...formData, Addresses: Data });
    }
    //}
    if (CityData.includes(newInputValue)) {
      GetPostCode(AddressItem.Region == "" ? "0" : AddressItem.Region, newInputValue, '0');
      GetDistrictData(newInputValue, AddressItem.Region == "" ? "0" : AddressItem.Region);
      GetNeighborhood(newInputValue, '0')
    }

  };

  const GetDistrictData = (cityName, regionName) => {
    setLoading2(true);
    axios
      .get('/GetDistrictRequest/' + cityName + '/' + regionName)
      .then(response => {
        setDistrictData(response.data);
        var Data = [...formData.Addresses];
        if (Data[AddressIndex].District != "") {
          var AddressItem = { ...Data[AddressIndex], District: '', PostCode: '', Neighborhood: '' };
          Data[AddressIndex] = AddressItem;
          setFormdata({ ...formData, Addresses: Data });
        }
        setLoading2(false);
        return response.data;
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetDistrictDataForPopUp = (cityName, regionName) => {
    setLoading2(true);
    axios
      .get('/GetDistrictRequest/' + cityName + '/' + regionName)
      .then(response => {
        setDistrictData(response.data);
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  // const GetDistrictDatabyPostCode = PostCode => {
  //   setLoading2(true);
  //   axios
  //     .get('/GetDistrictRequestByPostCode/' + PostCode)
  //     .then(response => {
  //       setDistrictData(response.data);

  //       setLoading2(false);
  //       return response.data;



  //     })
  //     .catch(error => {
  //       setLoading2(false);
  //     });
  // };
  const ChangeDistrict = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], District: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });

    Data = [...formData.Addresses];
    if (Data[AddressIndex].PostCode != "") {
      var AddressItem = { ...Data[AddressIndex], PostCode: '' };
      Data[AddressIndex] = AddressItem;
      setFormdata({ ...formData, Addresses: Data });
    }
    if (Data[AddressIndex].Neighborhood != "") {
      var AddressItem = { ...Data[AddressIndex], Neighborhood: '' };
      Data[AddressIndex] = AddressItem;
      setFormdata({ ...formData, Addresses: Data });
    }

    // if (DistrictData.includes(newInputValue)  ) {
    //   if(!PostCodefiltered){
    //   GetNeighborhood(AddressItem.City, AddressItem.District);
    //   GetPostCode(AddressItem.Region==""?"0":AddressItem.Region, AddressItem.City==""?"0":AddressItem.City, AddressItem.District);
    //   GetCityRequestByDistrict(AddressItem.District);
    //   setDistrictFiltered(true);
    //   }
    // }
    // else{

    //   setDistrictFiltered(false );
    //   GetCityRequest();
    //   GetPostCode('0', '0', '0');
    // }
    if (DistrictData.includes(newInputValue)) {
      GetNeighborhood(AddressItem.City, newInputValue);
      GetPostCode(AddressItem.Region == "" ? "0" : AddressItem.Region, AddressItem.City == "" ? "0" : AddressItem.City, newInputValue);
    }

  };

  const ChangeNeighborhood = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], Neighborhood: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
  };

  const GetNeighborhood = (cityName, DistrictName) => {
    if (DistrictName === '') {
      DistrictName = '0';
    }
    if (cityName === '') {
      cityName = '0';
    }

    axios
      .get('/GetNeighborhoodsRequest/' + cityName + '/' + DistrictName)
      .then(response => {
        if (response.data === null || response.data[0] === null || response.data.length === 0) {
          setNeighborhoodData([]);
        } else {
          setNeighborhoodData(response.data);
        }
      })
      .catch(error => { });
  };

  const ChangePostCode = (event, AddressIndex, newInputValue) => {
    var Value = newInputValue;
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[AddressIndex], PostCode: Value };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    // if (PostCodeData.includes(newInputValue) ) {
    //   if(!Districtfiltered && !AddressItem.City){
    //   GetCityRequestByDistrictbyPostCode(AddressItem.PostCode);
    //   GetDistrictDatabyPostCode(AddressItem.PostCode);

    //   var Data = [...formData.Addresses]; 
    //   var AddressItem = { ...Data[0], City: '',District: '' };
    //   Data[0] = AddressItem;
    //   setFormdata({ ...formData, Addresses: Data });

    //   setPostCodeFiltered(true);
    //   }
    // }
    // else{

    //   setPostCodeFiltered(false );
    //   GetCityRequest();
    //   GetDistrictData("");
    // }

  };

  const GetPostCode = (regionName, cityName, DistrictName) => {
    if (!regionName) {
      regionName = '0'
    }
    setLoading2(true);
    axios
      .get('/GetPostCodeRequest/' + regionName + '/' + cityName + '/' + DistrictName)
      .then(response => {
        let result = []
        if (response.data != '') {
          response.data.map(x => result.push(x.PostCode))
          setPostCodeData(result);
          setLoading2(false);
        }
        else {
          setPostCodeData([]);
          setLoading2(false);
        }

      })
      .catch(error => { setLoading2(false); });
  };

  const closeSinglePopUp = () => {
    setSinglePopUp(false);
    setOpenFeedbackPopup(true);
  };

  const handleSendCostumerSecretNote = () => {
    setRequiredForInternalNotes(true);
    setSecretNote('');
    if (
      formData.ConsumerId === 0 ||
      formData.ConsumerId === undefined ||
      VulnerabilitiesId === 0
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }
    if (SecretNote.length === 0) {
      setresponseMessage({
        ErrorCode: '10',
        ErrorDescription: t('yorum_yaziniz')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    }

    const data = {
      ConsumerId: formData.ConsumerId,
      EmployeeId: parseInt(SessionUser.TechnicianId) || 1,
      SecretNote: SecretNote || '',
      VulnerabilitiesId: VulnerabilitiesId || 0
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading2(true);
    axios
      .post('/SetConsumerSecretNote', data, config)
      .then(response => {
        setLoading2(false);
        let ResponseData = response.data;
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        } else {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          GetSecretNote(formData.ConsumerId);
        }
      })
      .catch(error => {
        setLoading2(false);
        setresponseMessage({
          ErrorCode: '10',
          ErrorDescription: t('Error') + error.message
        });
        setUyariTip('error');
        setUyari(true);
      });
  };
  const NewAddressCheck = () => {
    let uyari = false;
    if (
      formData.Addresses[AddressIndex]?.City?.length > 0
    ) {
      if (
        //  formData.Addresses[AddressIndex]?.AddressItem?.length === 0 ||
        formData.Addresses[AddressIndex]?.City?.length === 0
      ) {
        uyari = true;
      }
    }
    return uyari;
  };
  const SaveConsumer = () => {
    let uyari = false;
    if (formData.Phones.length === 0) {
      if (
        newtel === '' ||
        newtel === undefined ||
        ParamPhonesType === 0 ||
        ParamPhonesType === undefined ||
        ParamPhonesType === '' ||
        newtel.length === countryCode.length
      ) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        uyari = true;
        setRequired(true);
      } else {
        var PhoneType = PhoneTypes.filter(item => item.Id === ParamPhonesType);

        axios
          .get('/CheckPhoneNumber/' + newtel)
          .then(response => {
            let ResponseData = response.data;
            // If the user select CustomerType 'Return' as customerType (9 or 10)
            // There will be a an exception in which 
            // we wont check if the user have already that phone number
            if (formData.CustomerTypeId == 9 || formData.CustomerTypeId == 10 || SessionUser.TenantId == 53 || SessionUser.TenantId == 12) {
              ResponseData = ""
            }
            if (ResponseData.length !== 0) {
              setresponseMessage({
                ErrorCode: 10,
                ErrorDescription:
                  ' Id: ' + ResponseData[0].ConsumerId + ' ' +
                  ResponseData[0].Title + ' ' +
                  ResponseData[0].FirstName + ' ' +
                  ResponseData[0].MiddleName + ' ' +
                  ResponseData[0].LastName
              });
              setUyariTip('error');
              setUyari(true);
              setRequired(true);
              if (ResponseData.ErrorCode === 10) {
                history.push('/overview');
              }
            }

            else {
              var Data = {
                PhoneId: 0,
                Phone: newtel,
                PhoneTypeId: ParamPhonesType,
                PhoneType: PhoneType[0].Dsc
              };
              formData.Phones.push(Data);
              setNewTel(countryCode);

              if (emailError) {
                uyari = true;
              }
              if (NewAddressCheck()) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblMustFieldControl')
                });
                setUyariTip('error');
                uyari = true;
                setRequiredAddress(true);
              }

              if (
                // formData.Title === 0 ||
                formData.CustomerTypeId === 0 ||
                // formData.FirstName.length === 0 ||
                formData.LastName.length === 0
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblMustFieldControl')
                });
                setUyariTip('error');
                uyari = true;
                setRequired(true);
              }

              if (SessionUser.TenantId == 49 && (formData.Addresses[AddressIndex]?.PostCode?.length === 0 || formData.Addresses[AddressIndex]?.PostCode == undefined)) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('Check PostCode')
                });
                setUyariTip('error');
                uyari = true;
                setRequired(true);
              }

              if (uyari) {
                setUyari(true);
                return;
              }
              else {
                if (
                  // formData.Title === 0 ||
                  formData.CustomerTypeId === 0 ||
                  // formData.FirstName.length === 0 ||
                  formData.LastName.length === 0
                ) {
                  setresponseMessage({
                    ErrorCode: 10,
                    ErrorDescription: t('lblMustFieldControl')
                  });
                  setUyariTip('error');
                  uyari = true;
                  setRequired(true);
                }

                if (SessionUser.TenantId == 49 && (formData.Addresses[AddressIndex]?.PostCode?.length === 0 || formData.Addresses[AddressIndex]?.PostCode == undefined)) {
                  setresponseMessage({
                    ErrorCode: 10,
                    ErrorDescription: t('Check PostCode')
                  });
                  setUyariTip('error');
                  uyari = true;
                  setRequired(true);
                }

                if (uyari) {
                  setUyari(true);
                  return;
                }
                setSaveControl(false);
                confirmAlert({
                  message: t('lblConfirm'),
                  buttons: [
                    {
                      label: t('Evet'),
                      onClick: () => SaveConsumerYes()
                    },
                    {
                      label: t('Hayir'),
                      onClick: () => {
                        return;
                      }
                    }
                  ]
                });
              }
            }
          })
      }
    }
    else {
      setSaveControl(false);
      if (
        // formData.Title === 0 ||
        formData.CustomerTypeId === 0 ||
        // formData.FirstName.length === 0 ||
        formData.LastName.length === 0

      ) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblMustFieldControl')
        });
        setUyariTip('error');
        uyari = true;
        setRequired(true);
      }

      if (SessionUser.TenantId == 49 && (formData.Addresses[AddressIndex]?.PostCode?.length === 0 || formData.Addresses[AddressIndex]?.PostCode == undefined)) {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('Check PostCode')
        });
        setUyariTip('error');
        uyari = true;
        setRequired(true);
      }

      if (uyari) {
        setUyari(true);
        return;
      }
      confirmAlert({
        message: t('lblConfirm'),
        buttons: [
          {
            label: t('Evet'),
            onClick: () => SaveConsumerYes()
          },
          {
            label: t('Hayir'),
            onClick: () => {
              return;
            }
          }
        ]
      });
    }
  };
  const SaveConsumerYes = () => {
    const dataBody = { ...formData };
    dataBody.EmployeeId = SessionUser.TechnicianId;

    if (dataBody.Country === '') {
      dataBody.Country = SessionUser.TenantCode;
    }

    dataBody.Addresses = dataBody.Addresses.map(address => {
      // Eğer Type 0 ise, kopyasını oluşturup Type'ı 1 yap
      if (address.AddressTypeId === 0) {
        return { ...address, AddressTypeId: 1 };
      }
      // Type 0 değilse değişiklik yapma
      return address;
    });

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetConsumer', dataBody, dataConfig)
      .then(response => {
        var ResponseData = response.data[0];
        if (ResponseData.ErrorCode === '0') {
          setFormdata(ResponseData);
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: t('success_message')
          });
          setAddressIndex(
            ResponseData.Addresses.length > AddressIndex ? AddressIndex : 0
          );
          setUyariTip('success');
          setUyari(true);
          sessionStorage.removeItem('SearhResult');
          sessionStorage.setItem('SearhResult', JSON.stringify(ResponseData));
          sessionStorage.removeItem('ConsumerId');
          sessionStorage.setItem('ConsumerId', ResponseData.ConsumerId);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };
  const SaveWorkCase = () => {
    setisButtonDisabled(true);
    let uyari = false;
    const ControlIssueTypeId = [3, 4, 5, 2, 11];
    const ControlRegistrationIssue = [7, 10, 14];
    // const ControlIssueTypeId = [3, 4, 5, 2, 7, 10, 11];
     const dummyProducts = [
      1000000, 1000001, 1000002, 1000003, 1000004, 
      1000005, 1000006, 1000007, 1000008, 1000009, 
      1000010, 1000011, 1000012, 1000013, 1000014, 
      1000015, 1000016, 1000017, 1000018, 1000019, 
      1000020, 1000021, 1000022, 1000023, 1000024
    ];
    
    if (
      retailerControlTenantId.includes(SessionUser.TenantId) && (NewWorkCaseData.RetailerId === 0 ||
        NewWorkCaseData.RetailerId === undefined ||
        NewWorkCaseData.Retailer === "" ||
        NewWorkCaseData.Retailer === undefined
      )
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: 'Retailer field is required'
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if (ControlRegistrationIssue.includes(parseInt(IssueTypeId)) && NewWorkCaseData.SerialNr != undefined && NewWorkCaseData.SerialNr.length <= 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblSerialNumberControl')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }
    if (ControlRegistrationIssue.includes(parseInt(IssueTypeId)) && NewWorkCaseData.WarrantyDate === null) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblWarrantyDateControl')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }
    if (ControlRegistrationIssue.includes(parseInt(IssueTypeId)) && (NewWorkCaseData.SerialNr === '9900000199' || dummyProducts.includes(parseInt(NewWorkCaseData.ProductId)))) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblDummySerialNumber')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if ((SessionUser.TenantId == 52 || SessionUser.TenantId == 11) && (NewWorkCaseData.DistributorId == undefined || NewWorkCaseData.DistributorId == 1)) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Please select Distributor')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }

    if (formData.ConsumerId === 0 || formData.ConsumerId === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequired(true);
      uyari = true;
    }
    //CRM'DE İŞ EMRİ OLUŞTURURKEN ADRES ZORUNLU OLMAMALI


    if (NewWorkCaseData.WarrantyDate && !moment(NewWorkCaseData.WarrantyDate).isValid()) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }
    if (
      (NewWorkCaseData.ProductId === 0 ||
        NewWorkCaseData.ProductId === undefined) &&
      !ControlIssueTypeId.includes(parseInt(IssueTypeId))
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }
    if (
      (NewWorkCaseData.IssueId === 0 ||
        NewWorkCaseData.IssueId === undefined) &&
      !ControlIssueTypeId.includes(parseInt(IssueTypeId))
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }
    if (
      (NewWorkCaseData.WarrantyTypeId === 0 ||
        NewWorkCaseData.WarrantyTypeId === undefined) &&
      !ControlIssueTypeId.includes(parseInt(IssueTypeId)) &&
      !ControlRegistrationIssue.includes(parseInt(IssueTypeId))
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }

    if (
      NewWorkCaseData.Comment === '' ||
      NewWorkCaseData.Comment === undefined
    ) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCaseComment(true);
      uyari = true;
    }
    if (isWarrantyDateRequired() && !NewWorkCaseData.WarrantyDate) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setRequiredWorkCase(true);
      uyari = true;
    }
    if (uyari) {
      setUyari(true);
      setisButtonDisabled(false);
      return;
    }
    const dataBody = { ...NewWorkCaseData };
    dataBody.EmployeeId = SessionUser.TechnicianId;
    dataBody.ConsumerId = formData.ConsumerId;
    dataBody.Source = 1;
    dataBody.CaseOwnerId = CaseOwnerId?.toString();

    dataBody.Barcode = NewWorkCaseData.SerialNr ? NewWorkCaseData.SKU + NewWorkCaseData.SerialNr : null;

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetWorkCase', dataBody, dataConfig)
      .then(response => {
        var ResponseData = response.data;
        if (ResponseData.ErrorCode === "1000") {
          setresponseMessage({
            ErrorCode: 1000,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
        else {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          setNewWorkCaseData(DefaultWorkCase);
          if (IssueTypeId === 7 || IssueTypeId === 10 || IssueTypeId === 14) {
            //Asset'e eklenecekler için asset count sessionı güncelleniyor
            var AssetCountParam = formData.AssetCount;
            const Assetcounter = sessionStorage.getItem('SearhResult');
            let jsonAssetcounter = JSON.parse(Assetcounter);
            jsonAssetcounter['AssetCount'] = AssetCountParam + 1;
            sessionStorage.setItem(
              'SearhResult',
              JSON.stringify(jsonAssetcounter)
            );
          }

          if (IssueTypeId === 3 || IssueTypeId === 4 || IssueTypeId === 5 || IssueTypeId === 7 || IssueTypeId === 10 || IssueTypeId === 14) {
            var FeedBackCountParam = formData.FeedBackCount;
            const Feedbackcounter = sessionStorage.getItem('SearhResult');
            let jsonFeedbackcounter = JSON.parse(Feedbackcounter);
            jsonFeedbackcounter['FeedBackCount'] = FeedBackCountParam + 1;
            sessionStorage.setItem(
              'SearhResult',
              JSON.stringify(jsonFeedbackcounter)
            );
            setTimeout(() => {
              setUyari(false);
              setTimeout(() => {
                setresponseMessage({
                  ErrorDescription: "Feedback created"
                });
                setUyariTip('info');
                setUyari(true);
              }, 300);
            }, 3000);

          }
          else {
            var WorkCaseCountParam = formData.WorkCaseCount ?? 0;
            const Workcasecounter = sessionStorage.getItem('SearhResult');
            let jsonWorkcasecounter = JSON.parse(Workcasecounter);
            jsonWorkcasecounter['WorkCaseCount'] = WorkCaseCountParam + 1;
            sessionStorage.setItem(
              'SearhResult',
              JSON.stringify(jsonWorkcasecounter)
            );
          }

          setNewWorkCasePopup(false);
          if (IssueTypeId === 7 || IssueTypeId === 10 || IssueTypeId === 14) {
            setSaveWorkOrderId(ResponseData.WorkOrderId)
            // setInsertAssetPopup(true)
            // setFormdata({ ...formData, AssetCount: formData.AssetCount + 1 });
            setFormdata({
              ...formData,
              FeedBackCount: formData.FeedBackCount + 1,
              AssetCount: formData.AssetCount + 1
            });
          }
          else if (IssueTypeId === 3 || IssueTypeId === 4 || IssueTypeId === 5) {
            setFormdata({ ...formData, FeedBackCount: formData.FeedBackCount + 1 });
          }
          else {
            setFormdata({ ...formData, WorkCaseCount: WorkCaseCountParam + 1 });
          }
          if (!ControlIssueTypeId.includes(parseInt(IssueTypeId)) && !ControlRegistrationIssue.includes(parseInt(IssueTypeId))) {
            sessionStorage.removeItem('WorkOrderId');
            sessionStorage.setItem('WorkOrderId', ResponseData.WorkOrderId);
            getTasksRequest(ResponseData.WorkOrderId);
            history.push(`/WorkOrder/${ResponseData.WorkOrderId}/summary`);
          }

          if (NewWorkCaseData.PotentialLiabiltiy == 1) {
            SaveCompensation(ResponseData.WorkOrderId);
          }

        }

      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });

    setTimeout(() => setisButtonDisabled(false), 10000);
  };

  const SetWorkOrderDetail = (event, row) => {
    getTasksRequest(row.WorkOrderId);
    history.push(`/WorkOrder/${row.WorkOrderId}/summary`);
  };

  function SetWorkOrderTaskDetail(Selected) {
    const rowIndex = Selected.rowIds[0] - 1;
    var Search = TasksData[rowIndex].lblWorkOrderId;

    axios
      .get('/GetConsumerByWorkOrderId/' + Search + '/' + SessionUser.ServiceShopId + '/' + SessionUser.Role)
      .then(res => {
        const response = JSON.stringify(res.data[0]);
        if (response === undefined) {

        } else {
          sessionStorage.removeItem('SearhResult');
          sessionStorage.setItem('SearhResult', response);
          sessionStorage.removeItem('ConsumerId');
          sessionStorage.setItem('ConsumerId', res.data[0].ConsumerId);
          getTasksRequest(Search);
          history.push(`/WorkOrder/${Search}/summary`);
        }

      })
      .catch(err => { });

  };

  function handleCloseDialog() {
    setOpenMaterialOrder(false);
    setValuePropositionDialog(false);
  }

  const SaveWorkOrder = WorkCaseId => {
    const dataBody = {
      WorkCaseId: WorkCaseId,
      EmployeeId: SessionUser.TechnicianId
    };
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetWorkOrder', dataBody, dataConfig)
      .then(response => {
        var ResponseData = response.data[0];
        if (ResponseData.ErrorCode === 0) {
          setresponseMessage({
            ErrorCode: ResponseData.ErrorCode,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('success');
          setUyari(true);
          setWorkCasePopup(false);
          sessionStorage.removeItem('WorkOrderId');
          sessionStorage.setItem('WorkOrderId', ResponseData.WorkOrderId);
          getTasksRequest(ResponseData.WorkOrderId);
          history.push(`/WorkOrder/${ResponseData.WorkOrderId}/summary`);
        } else {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: ResponseData.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
        }
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const SaveGdpr = () => {
    GdprData.ConsumerId = formData.ConsumerId;
    GdprData.EmployeeId = SessionUser.TechnicianId;
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SetGdprRequest', GdprData, dataConfig)
      .then(response => {
        setUyariTip('success');
        setUyari(true);
        setGdprPopup(false);
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const CustomerAnonymyze = () => {

    var ConsumerId = formData.ConsumerId;
    var EmployeeId = SessionUser.TechnicianId;

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .get(`/CustomerAnonymyze/${ConsumerId}/${EmployeeId}`, dataConfig)
      .then(response => {
        setUyariTip('success');
        setUyari(true);
        setAnonymyzePopup(false);
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
  };

  const GetWorkCaseDetailOrder = item => {
    setWorkOrderData(item.WorkOrders);
    setWorkCasePopup(false);
    setWorkOrderPopup(true);
  };

  const setNewWorkCaseAssets = item => {
    if (item != null) {
      const rightToRepairWarrantyTypeId = Boolean(item.RightToRepairConsent) && Number(item.RightToRepairWarrantyTypeId) > 0
        ? Number(item.RightToRepairWarrantyTypeId)
        : null;
      const shouldClearAutoSelectedWarranty = autoSelectedRightToRepairWarrantyTypeId !== null &&
        autoSelectedRightToRepairWarrantyTypeId !== rightToRepairWarrantyTypeId;

      setPendingRightToRepairWarrantyTypeId(rightToRepairWarrantyTypeId);
      if (shouldClearAutoSelectedWarranty) {
        setAutoSelectedRightToRepairWarrantyTypeId(null);
        setSelectedWarrantyType(0);
        setNewWorkCaseData(currentData =>
          currentData.WarrantyTypeId === autoSelectedRightToRepairWarrantyTypeId
            ? { ...currentData, WarrantyTypeId: 0 }
            : currentData
        );
      }

      setModelCode(item.ProductCode);
      setAssetChosen(true);
      setLoading2(true);
      axios
        .get(
          '/GetAssetWarrantyDate/' +
          item.ProductId +
          '/' +
          item.ProductionYear +
          '/' +
          item.ProductionMonth +
          '/' +
          item.SerialNr +
          '/' +
          item.WarrantyId
        )
        .then(response => {

          setNewWorkCaseData(currentData => ({
            ...currentData,
            ProductId: item.ProductId,
            SKU: item.ProductCode,
            WarrantyDate: response.data != null && response.data != "" && response.data != undefined
              ? moment(response.data).format('YYYY.MM.DD')
              : moment(item.WarrantyDate).format('YYYY.MM.DD'),
            ProductionYear: item.ProductionYear,
            ProductionMonth: item.ProductionMonth,
            SerialNr: item.SerialNr,
            Retailer: item.Retailer,
            RetailerId: item.RetailerId,
            RightToRepairConsent: Boolean(item.RightToRepairConsent)
          }));
          setWarrantyDateDisable(true);
          setLoading2(false);
        })
        .catch(error => {
          setLoading2(false);
        });
    } else {
      setPendingRightToRepairWarrantyTypeId(null);
      setAutoSelectedRightToRepairWarrantyTypeId(null);
      setSelectedWarrantyType(0);
      setWarrantyDateDisable(false);
      setAssetChosen(false);
      setNewWorkCaseData(DefaultWorkCase);
    }
  };

  const SendSms = () => {
    var header = ManuelSmsData.filter(x => x.Id == smsData)[0]

    const data = {
      MessageHeader: header,
      PhoneList: selectedPhone,
      ConsumerId: formData.ConsumerId,
      ServiceShopId: SessionUser.ServiceShopId,
      WorkOrderId: ReceiptNo
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/SendManuelSms', data, config)
      .then(response => {
        setUyariTip('success');
        setUyari(true);
      })
      .catch(error => {
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: 'Something went wrong!..'
        });
        setUyariTip('error');
        setUyari(true);
      });
    setSelectedPhone([])
  }

  const ConfirmSendSMS = () => {
    // @TODO: selectedPhone lenghti 0'dan büyük olmalı
    // Headerda dolu olması
    if (selectedPhone.length > 0 && smsData > 0 && smsData !== null) {
      confirmAlert({
        message: t('lblConfirm'),
        buttons: [
          {
            label: t('Evet'),
            onClick: () => SendSms()
          },
          {
            label: t('Hayir'),
            onClick: () => {
              setSmsData(null);
              setSelectedPhone([]);
              return;
            }
          }
        ]
      });
    } else {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: 'Please select sms header and phone number!'
      });
      setUyariTip('error');
      setUyari(true);
      setSmsInformationPopup(true);
    }
  }

  function selectPhone(value) {
    const data = {
      Id: value.PhoneId,
      Phone: value.Phone
    }
    const tmpPhone = [...selectedPhone]
    var index = selectedPhone.findIndex(x => x.Id == data.Id)
    if (index == -1) {
      tmpPhone.push(data)
      setSelectedPhone(tmpPhone)
    }
    else {
      tmpPhone.splice(index, 1)
      setSelectedPhone(tmpPhone)
    }
  }


  const handleFileOpen = (event, Id, FileName) => {
    setLoading2(true);
    const config = {
      responseType: 'blob'
    };
    let newWindow = window.open();
    axios
      .get('/FileImportExport/SiriusFileDetail/' + Id, config)
      .then(response => {
        // openBlob(response.data, FileName);
        var fileURL = URL.createObjectURL(response.data);
        newWindow.location = fileURL;
        newWindow.document.title = FileName;
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const DeleteCostumerSecretNote = Id => {
    SetSecretNotePopUp(false);
    confirmAlert({
      message: t('lblConfirm'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => DeleteCostumerSecretNoteYes(Id)
        },
        {
          label: t('Hayir'),
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const DeleteCostumerSecretNoteYes = Id => {
    setLoading2(true);
    axios
      .get('/DeleteConsumerSecretNote/' + Id)
      .then(response => {
        GetSecretNote(formData.ConsumerId);
        setLoading2(false);
        SetSecretNotePopUp(true);
      })
      .catch(error => {
        setLoading2(false);
      });
  };
  const handleChangeStatusSearch = event => {
    setStatusSeacrh(event.target.value);
  };

  const handleChangeServiceShopSearch = event => {
    setServiceShopId(event.target.value);
  };

  const handleTasksInputChange = e => {
    const { name, value } = e.target;

    dispatch(setTasksFilterModel({ name, value }));
  }

  const handleChangeServiceShopId = value => {
    setServiceShopSelected(value);
    setServiceShopId(value.ServiceShopId);
  };

  const SetCountry = (code, index) => {
    setSelected(code);
    var Data = [...formData.Addresses];
    var AddressItem = { ...Data[index], Country: code };
    Data[index] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
  };

  function changeRegionAndCityData(cityCode) {
    axios
      .get('/GetRegionRequestByCountryCode/' + cityCode)
      .then(response => {
        if (
          response.data.length == 0 ||
          (response.data.length == 1 && !response.data[0])
        ) {
          setRegionData([]);
          axios
            .get('/GetCityRequestByCountryCode/' + cityCode)
            .then(response2 => {
              if (
                response2.data.length == 0 ||
                (response2.data.length == 1 && !response2.data[0])
              ) {
                setCityData([]);
              } else {
                setCityData(response2.data);
                GetDistrictData("", "");
              }
              setLoading2(false);
            })
            .catch(error => {
              setLoading2(false);
            });
        } else {
          setCityData([]);
          setRegionData(response.data);
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  }

  const GetGdpr = () => {
    if (formData.ConsumerId === 0 || formData.ConsumerId === undefined) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblMustFieldControl')
      });
      setUyariTip('error');
      setUyari(true);
      setRequired(true);
      return;
    }
    setGdprPopupNew(true);
    // axios
    //   .get('/GetGdprRequest/' + formData.ConsumerId)
    //   .then(response => {
    //     setGdprData(response.data);
    //     setGdprPopup(true);
    //     setLoading2(false);
    //   })
    //   .catch(error => {
    //     setLoading2(false);
    //   });
  };

  // bileşen içinde bir yardımcı
  const highlightBeko = (text) => {
    if (!text) return null;
    return text.split(/(beko)/i).map((part, i) =>
      part.toLowerCase() === 'beko'
        ? <span key={i} style={{ color: '#1976d2', fontWeight: 'bold' }}>BEKO</span>
        : <React.Fragment key={i}>{part}</React.Fragment>
    );
  };

  const getLegalEntityColor = (text) => {
    if (!text) return '#FF6B6B';
    const known = ['beko', 'european appliances'];
    return known.some(k => text.toLowerCase().includes(k)) ? '#FF6B6B' : '#2E7D32';
  };



  const GetConsumerSmsInformation = () => {
    axios
      .get('/GetConsumerSmsInformation/' + formData.ConsumerId)
      .then(response => {
        setSmsInformationData(response.data);
        setSmsRows(response.data);
        setSmsInformationPopup(true);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const GetConsumerSmsDetail = (item) => {
    axios
      .get('/GetConsumerSmsDetail/' + item.Id)
      .then(response => {
        setSmsDetailData(response.data);

        setOpenSmsDetailPopup(true);
        //setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };


  const handleClose2 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const GetConsumerInformation = () => {
    axios
      .get('/GetConsumerInformation/' + formData.ConsumerId)
      .then(response => {
        setInformationData(response.data);
        setInformationPopup(true);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const applyWarrantyTypeId = warrantyTypeId => {
    const warrantyType = WarrantyData.find(x => Number(x.WarrantyId) === Number(warrantyTypeId));
    if (!warrantyType) {
      return false;
    }

    const data = warrantyType.WarrantyId;
    if (warrantyType.WarrantyGroupId === 6) {
      const today = moment(new Date()).format('YYYY-MM-DD');
      setWarrantyDateDisable(true);
      setNewWorkCaseData(currentData => ({
        ...currentData,
        WarrantyTypeId: data,
        WarrantyDate: today
      }));
    } else {
      setWarrantyDateDisable(false);
      setNewWorkCaseData(currentData => ({
        ...currentData,
        WarrantyTypeId: data
      }));
    }

    setSelectedWarrantyType(data);
    return true;
  };

  const handleChangeWarrantyTypeId = e => {
    setPendingRightToRepairWarrantyTypeId(null);
    setAutoSelectedRightToRepairWarrantyTypeId(null);
    applyWarrantyTypeId(e.target.value);
  };

  useEffect(() => {
    if (!pendingRightToRepairWarrantyTypeId || WarrantyData.length === 0) {
      return;
    }

    if (applyWarrantyTypeId(pendingRightToRepairWarrantyTypeId)) {
      setAutoSelectedRightToRepairWarrantyTypeId(pendingRightToRepairWarrantyTypeId);
    }

    setPendingRightToRepairWarrantyTypeId(null);
  }, [pendingRightToRepairWarrantyTypeId, WarrantyData]);


  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };


  const GetTasksData = () => {
    if (isTaskCooldownActive) {
      setResponseType('warning');
      setResponseDsc(t('lblCooldownWait', { seconds: taskRemainingSeconds }));
      setOpenSnackbar(true);
      return;
    }
    // setTasksData([]);
    // setTasksScreenData([]);
    // setDetailedExcelData([])
    setLoading2(true);
    const dateDifference = moment(EndDateSearch).diff(moment(StartDateSearch), 'days');

    if (dateDifference > 90) {
      setLoading2(false);
      return;
    }

    var StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    var EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    var statu = [];
    selectedValues.map((i) => {
      statu.push(i.StatusId)
    });
    var taskScreenResult = []
    var tmpTaskOpenDay = TaskOpenDay == undefined || TaskOpenDay == null ? 0 : TaskOpenDay
    triggerTaskCooldownByDateRange(StartDateSearch, EndDateSearch);
    var result = dispatch(getFilteredTasksRequest(tasksFilterModel))
    // axios
    //   .get(
    //     '/GetTasksDataDetail/' +
    //     serviceShopId +
    //     '/' +
    //     statu.toString() +
    //     '/' +
    //     StartDate +
    //     '/' +
    //     EndDate +
    //     '/' +
    //     tasksFilterModel.openCase +
    //     '/' +
    //     tmpTaskOpenDay
    //   )
    //   .then(response => {
    //     const ResponseData = response.data;
    //     if (ResponseData.length === 0) {
    //       setTasksData([]);
    //     } else {

    //       for (var i = 0; i < ResponseData.length; i++) {
    //         var tmp = {
    //           id: i + 1,
    //           lblWorkCaseId: ResponseData[i].WorkCaseId,
    //           lblWorkOrderId: ResponseData[i].id,
    //           lblServiceCode: ResponseData[i].ServiceCode,
    //           lblServiceShop: ResponseData[i].ServiceShop,
    //           lblWarrantyDate: Moment(ResponseData[i].WarrantyDate).format('DD/MM/YYYY'),
    //           lblWarrantyType: ResponseData[i].WarrantyType,
    //           lblOpenDays: ResponseData[i].OpenDays,
    //           lblStatus: ResponseData[i].Status,
    //           lblStatusNote: ResponseData[i].StatusNote,
    //           lblCallCenterNote: ResponseData[i].CallCenterNote,
    //           lblRejectDescription: ResponseData[i].RealRejectReason,
    //           lblSpecialNote: ResponseData[i].SpecialNote,
    //           lblFinalNote: ResponseData[i].FinalNote,
    //           lblUrgentCustomer: ResponseData[i].UrgentCustomer === 1 ? 'URGENT' : '',
    //           lblCustomer: maskStringData(ResponseData[i].Consumer[0]?.Search),
    //           CustomerCity: ResponseData[i].Consumer[0]?.Addresses[0]?.City,
    //           CustomerAddress: maskStringData(ResponseData[i].Consumer[0]?.Addresses[0]?.Address) && '',
    //           CustomerPhone: ResponseData[i].Consumer[0]?.Phones ? maskPhoneData(ResponseData[i].Consumer[0]?.Phones[0]?.Phone) : '',
    //           lblBrand: ResponseData[i].Brand,
    //           lblProductGroup: ResponseData[i].ProductGroup,
    //           lblSerialNumber: ResponseData[i].SerialNumber === '000000' || ResponseData[i].SerialNumber === '000000000' ? '' : ResponseData[i].SerialNumber,
    //           lblProductCode: ResponseData[i].ProductCode,
    //           lblProduct: ResponseData[i].Product,
    //           lblCallDate: Moment(ResponseData[i].OpenDate).format('DD/MM/YYYY HH:mm'),
    //           lblRepairDate: ResponseData[i].RepairDate ? Moment(ResponseData[i].RepairDate).format('DD/MM/YYYY HH:mm') : '',
    //           lblTechnician: ResponseData[i].Technician,
    //           lblRetailer: ResponseData[i].Retailer,
    //           lblApplicationType: ResponseData[i].Issue,
    //           lblMaterialOrderList: ResponseData[i].MaterialOrderId,
    //           lblLabourPrice: moneyFormat(ResponseData[i].LabourPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //           lblMaterialPrice: moneyFormat(ResponseData[i].MaterialPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //           lblTransportPrice: moneyFormat(ResponseData[i].TransportPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //           lblExtraPrice: moneyFormat(ResponseData[i].ExtraPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //           lblTotalPrice: moneyFormat(ResponseData[i].TotalPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //           lblCreateUser: ResponseData[i].CreateUser,
    //           lblUpdateUser: ResponseData[i].UpdateUser,
    //           lblLastWorkOrder: ResponseData[i].IsThisLastWorkOrder,
    //           lblAppointmentDate: ResponseData[i].AppointmentDate
    //         }
    //         taskScreenResult.push(tmp)
    //       }

    //       var result = []
    //       for (var i = 0; i < ResponseData.length; i++) {
    //         if (ResponseData[i].WorkOrderDetails.length === 0) {
    //           var tmp = {
    //             lblWorkCaseId: ResponseData[i].WorkCaseId,
    //             lblWorkOrderId: ResponseData[i].id,
    //             lblServiceCode: ResponseData[i].ServiceCode,
    //             lblServiceShop: ResponseData[i].ServiceShop,
    //             lblWarrantyDate: Moment(ResponseData[i].WarrantyDate).format('DD/MM/YYYY'),
    //             lblOpenDays: ResponseData[i].OpenDays,
    //             lblWarrantyType: ResponseData[i].WarrantyType,
    //             lblStatus: ResponseData[i].Status,
    //             lblStatusNote: ResponseData[i].StatusNote,
    //             lblCallCenterNote: ResponseData[i].CallCenterNote,
    //             lblRejectDescription: ResponseData[i].RealRejectReason,
    //             lblSpecialNote: ResponseData[i].SpecialNote,
    //             lblFinalNote: ResponseData[i].FinalNote,
    //             lblUrgentCustomer: ResponseData[i].UrgentCustomer === 1 ? 'URGENT' : '',
    //             lblCustomer: maskStringData(ResponseData[i].Consumer[0]?.Search),
    //             CustomerCity: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
    //               ResponseData[i].Consumer[0]?.Addresses[0]?.City : '',
    //             CustomerAddress: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
    //               maskStringData(ResponseData[i].Consumer[0]?.Addresses[0]?.Address) : '',
    //             CustomerPhone: ResponseData[i].Consumer[0]?.Phones ? maskPhoneData(ResponseData[i].Consumer[0]?.Phones[0]?.Phone) : '',
    //             lblBrand: ResponseData[i].Brand,
    //             lblSerialNumber: ResponseData[i].SerialNumber === '000000' || ResponseData[i].SerialNumber === '000000000' ? '' : ResponseData[i].SerialNumber,
    //             lblProductGroup: ResponseData[i].ProductGroup,
    //             lblProductCode: ResponseData[i].ProductCode,
    //             lblProduct: ResponseData[i].Product,
    //             lblCallDate: Moment(ResponseData[i].OpenDate).format('DD/MM/YYYY HH:mm'),
    //             lblRepairDate: ResponseData[i].RepairDate ? Moment(ResponseData[i].RepairDate).format('DD/MM/YYYY HH:mm') : '',
    //             lblTechnician: ResponseData[i].Technician,
    //             lblRetailer: ResponseData[i].Retailer,
    //             lblApplicationType: ResponseData[i].Issue,
    //             lblMaterialOrderList: ResponseData[i].MaterialOrderId,
    //             // LabourPrice: moneyFormat(ResponseData[i].LabourPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //             // MaterialPrice: moneyFormat(ResponseData[i].MaterialPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //             // TransportPrice: moneyFormat(ResponseData[i].TransportPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //             // ExtraPrice: moneyFormat(ResponseData[i].ExtraPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //             // TotalPrice: moneyFormat(ResponseData[i].TotalPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //             lblCreateUser: ResponseData[i].CreateUser,
    //             lblUpdateUser: ResponseData[i].UpdateUser,
    //             lblLastWorkOrder: ResponseData[i].IsThisLastWorkOrder,
    //             lblDefectName: '',
    //             lblMaterialType: '',
    //             lblMaterialName: '',
    //             lblMaterialCode: '',
    //             lblVatRate: '',
    //             lblPrice: '',
    //             lblPriceWithVat: '',
    //             lblDiscountPrice: '',
    //             lblCurrencyId: '',
    //             lblQuantity: '',
    //             lblProjectCode: ResponseData[i].ProjectCode,
    //             lblAppointmentDate: ResponseData[i].AppointmentDate
    //           }
    //           result.push(tmp)
    //         }
    //         else {
    //           for (var j = 0; j < ResponseData[i].WorkOrderDetails.length; j++) {
    //             var tmp = {
    //               lblWorkCaseId: ResponseData[i].WorkCaseId,
    //               lblWorkOrderId: ResponseData[i].id,
    //               lblServiceCode: ResponseData[i].ServiceCode,
    //               lblServiceShop: ResponseData[i].ServiceShop,
    //               lblWarrantyDate: Moment(ResponseData[i].WarrantyDate).format('DD/MM/YYYY'),
    //               lblOpenDays: ResponseData[i].OpenDays,
    //               lblWarrantyType: ResponseData[i].WarrantyType,
    //               lblStatus: ResponseData[i].Status,
    //               lblStatusNote: ResponseData[i].StatusNote,
    //               lblCallCenterNote: ResponseData[i].CallCenterNote,
    //               lblRejectDescription: ResponseData[i].RealRejectReason,
    //               lblSpecialNote: ResponseData[i].SpecialNote,
    //               lblFinalNote: ResponseData[i].FinalNote,
    //               lblUrgentCustomer: ResponseData[i].UrgentCustomer === 1 ? 'URGENT' : '',
    //               lblCustomer: maskStringData(ResponseData[i].Consumer[0]?.Search),
    //               CustomerCity: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
    //                 ResponseData[i].Consumer[0]?.Addresses[0]?.City : '',
    //               CustomerAddress: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
    //                 maskStringData(ResponseData[i].Consumer[0]?.Addresses[0]?.Address) : '',
    //               CustomerPhone: ResponseData[i].Consumer[0]?.Phones ? maskPhoneData(ResponseData[i].Consumer[0]?.Phones[0]?.Phone) : '',
    //               lblBrand: ResponseData[i].Brand,
    //               lblSerialNumber: ResponseData[i].SerialNumber === '000000' || ResponseData[i].SerialNumber === '000000000' ? '' : ResponseData[i].SerialNumber,
    //               lblProductGroup: ResponseData[i].ProductGroup,
    //               lblProductCode: ResponseData[i].ProductCode,
    //               lblProduct: ResponseData[i].Product,
    //               lblCallDate: Moment(ResponseData[i].OpenDate).format('DD/MM/YYYY HH:mm'),
    //               lblRepairDate: ResponseData[i].RepairDate ? Moment(ResponseData[i].RepairDate).format('DD/MM/YYYY HH:mm') : '',
    //               lblTechnician: ResponseData[i].Technician,
    //               lblRetailer: ResponseData[i].Retailer,
    //               lblApplicationType: ResponseData[i].Issue,
    //               lblMaterialOrderList: ResponseData[i].MaterialOrderId,
    //               // LabourPrice: moneyFormat(ResponseData[i].LabourPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //               // MaterialPrice: moneyFormat(ResponseData[i].MaterialPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //               // TransportPrice: moneyFormat(ResponseData[i].TransportPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //               // ExtraPrice: moneyFormat(ResponseData[i].ExtraPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //               // TotalPrice: moneyFormat(ResponseData[i].TotalPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
    //               lblCreateUser: ResponseData[i].CreateUser,
    //               lblUpdateUser: ResponseData[i].UpdateUser,
    //               lblLastWorkOrder: ResponseData[i].IsThisLastWorkOrder,
    //               //WorkOrderDetailId: ResponseData[i].WorkOrderDetails[j].Id,
    //               //DefectId: ResponseData[i].WorkOrderDetails[j].DefectId,
    //               lblDefectName: ResponseData[i].WorkOrderDetails[j].DefectName,
    //               lblMaterialType: ResponseData[i].WorkOrderDetails[j].MaterialType === 1 ? 'Labour' :
    //                 ResponseData[i].WorkOrderDetails[j].MaterialType === 2 ? 'Material' :
    //                   ResponseData[i].WorkOrderDetails[j].MaterialType === 3 ? 'Transport' :
    //                     ResponseData[i].WorkOrderDetails[j].MaterialType === 4 ? 'Extra' : '',
    //               lblMaterialName: ResponseData[i].WorkOrderDetails[j].MaterialName,
    //               lblMaterialCode: ResponseData[i].WorkOrderDetails[j].MaterialCode,
    //               lblVatRate: ResponseData[i].WorkOrderDetails[j].VatRate,
    //               lblPrice: ResponseData[i].WorkOrderDetails[j].Price != undefined || ResponseData[i].WorkOrderDetails[j].Price != null ? moneyFormat(ResponseData[i].WorkOrderDetails[j].Price, SessionUser.TenantCode, SessionUser.CurrencyUnit) : 0,
    //               lblPriceWithVat: ResponseData[i].WorkOrderDetails[j].Price != undefined || ResponseData[i].WorkOrderDetails[j].Price != null ? moneyFormat(ResponseData[i].WorkOrderDetails[j].Price + (ResponseData[i].WorkOrderDetails[j].Price * ResponseData[i].WorkOrderDetails[j].VatRate), SessionUser.TenantCode, SessionUser.CurrencyUnit) : 0,
    //               lblDiscountPrice: ResponseData[i].WorkOrderDetails[j].DiscountPrice,
    //               lblCurrencyId: ResponseData[i].WorkOrderDetails[j].CurrencyId,
    //               lblQuantity: ResponseData[i].WorkOrderDetails[j].Quantity,
    //               lblProjectCode: ResponseData[i].ProjectCode,
    //               lblAppointmentDate: ResponseData[i].AppointmentDate
    //             }
    //             result.push(tmp)
    //           }
    //         }
    //       }

    //       setTasksScreenData(taskScreenResult)
    //       setDetailedExcelData(result)
    //       setTasksData(ResponseData);
    //     }
    //     setLoading2(false);
    //   })
    //   .catch(error => {
    //     setTasksData([]);
    //     setTasksScreenData(taskScreenResult)
    //     setLoading2(false);
    //   });
  };

  const DeleteAddress = Id => {
    const selected = formData.Addresses;
    var filteredIndex = selected.filter(x => x.AddressId === Id);
    var ControlAddress = filteredIndex.filter(x => x.PrimaryAddress === true);
    if (ControlAddress.length > 0) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('lblAddressPrimaryError')
      });
      setUyariTip('error');
      setUyari(true);
      return;
    } else {
      setAddressPopup(false);
      confirmAlert({
        message: t('lblConfirm'),
        buttons: [
          {
            label: t('Evet'),
            onClick: () => DeleteAddressYes(Id)
          },
          {
            label: t('Hayir'),
            onClick: () => {
              return;
            }
          }
        ]
      });
    }
  };

  const DeleteAddressYes = Id => {
    setLoading2(true);
    axios
      .get('/DeleteAddress/' + Id)
      .then(response => {
        const selected = formData.Addresses;
        var filteredIndex = selected.findIndex(
          x => parseInt(x.AddressId) === parseInt(Id)
        );
        if (filteredIndex > -1) {
          selected.splice(filteredIndex, 1);
          setFormdata({ ...formData, Addresses: selected });
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const SearchGoogleAddress = () => {
    setLoading2(true);
    setExperianAddressSearchResult([]);
    setGoogleAddressSearchResult([]);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    var Request = {
      Address: addressGoogleSearch
    };
    axios
      .post('/GoogleSearchLocation', Request, dataConfig)
      .then(response => {
        if (response.data.length === 0) {
          setGoogleAddressSearchResult([]);
        } else {
          setGoogleAddressSearchResult(response.data);
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const SearchWithExperianMulesoft = () => {
    setLoading2(true);
    setGoogleAddressSearchResult([]);
    setExperianAddressSearchResult([]);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    var Request = {
      CountryCode: SessionUser.TenantCode,
      Address: addressGoogleSearch
    };
    axios
      .post('/SearchWithDoorNumber', Request, dataConfig)
      .then(response => {
        if (response.data.length === 0) {
          setExperianAddressSearchResult([]);
        }
        else {

          if (Array.isArray(response.data[0].QAPicklist?.PicklistEntry)) {
            setExperianAddressSearchResult(
              response.data[0]?.QAPicklist?.PicklistEntry?.map(w => {
                return {
                  PartialAddress: w.PartialAddress,
                  PostCode: w.Postcode,
                };
              }));
          }
          else {
            var responseData = [
              {
                PartialAddress: response.data[0]?.QAPicklist?.PicklistEntry?.PartialAddress,
                PostCode: response.data[0]?.QAPicklist?.PicklistEntry?.Postcode,
              }];
            setExperianAddressSearchResult(responseData);
          }
        }
        setLoading2(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const SearchAddress = () => {
    setAddressSearchResult([]);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
      .post('/SearchLocation', addressSearch, dataConfig)
      .then(response => {
        if (response.data.length === 0) {
          setAddressSearchResult([]);
        } else {
          setAddressSearchResult(
            response.data.map(w => {
              return {
                id: w.Id,
                Region: w.Region,
                City: w.City,
                District: w.District,
                PostCode: w.PostCode,
                Neighborhood: w.Neighborhood
              };
            })
          );
        }
      })
      .catch(error => { });
  };

  const SetAdressWithSearchedResult = selectedRow => {
    const rowIndex = addressSearchResult.findIndex(
      x => parseInt(x.id) === parseInt(selectedRow)
    );
    const item = addressSearchResult[rowIndex];
    var Data = [...formData.Addresses];
    var AddressItem = {
      ...Data[AddressIndex],
      Region: item.Region,
      City: item.City,
      District: item.District,
      PostCode: item.PostCode,
      Neighborhood: item.Neighborhood
    };
    Data[AddressIndex] = AddressItem;
    setFormdata({ ...formData, Addresses: Data });
    setAddressSearchPopup(false);
  };

  const requestSearch = searchedVal => {
    const filteredRows = initialRows.filter(item =>
      sc(
        item.WorkCaseId +
        item.Status +
        item.CallDate +
        item.WarrantyType +
        item.Issue +
        item.ProductCode +
        item.Barcode +
        item.Product +
        (item.LegalEntity || ''),
        searchedVal
      )
    );

    if (legalEntityFilter !== 'ALL') {
      filteredRows = filteredRows.filter(item => item.LegalEntity === legalEntityFilter);

    }

    setWorkCaseData(filteredRows);
  };

  const handleLegalEntityFilterChange = (event) => {
    const selectedValue = event.target.value;
    setLegalEntityFilter(selectedValue);

    let filteredRows = initialRows;

    // Önce search filtresini uygula
    if (searched) {
      filteredRows = filteredRows.filter(item =>
        sc(
          item.WorkCaseId +
          item.Status +
          item.CallDate +
          item.WarrantyType +
          item.Issue +
          item.ProductCode +
          item.Barcode +
          item.Product +
          (item.LegalEntity || ''),
          searched
        )
      );
    }

    // Sonra LegalEntity filtresini uygula
    if (selectedValue !== 'ALL') {
      filteredRows = filteredRows.filter(item => item.LegalEntity === selectedValue);
    }

    setWorkCaseData(filteredRows);
  };

  const cancelSearch = () => {
    setSearched('');
    setLegalEntityFilter('ALL'); // Filtreyi de sıfırla
    requestSearch(searched);
  };

  const requestSmsSearch = searchedVal => {
    const filteredRows = SmsRows.filter(item =>
      sc(
        item.WorkOrderId +
        item.SendingAddress,
        searchedVal
      )
    );
    setSmsInformationData(filteredRows);
  };
  const cancelSmsSearch = () => {
    setSmsSearched('');
    requestSmsSearch(searched);
  };


  function openFeedbackPopupX() {
    if (formData.ConsumerId != 0) {

      setLoading2(true);
      const startDate = moment()
        .subtract(1, 'years')
        .format('DD.MM.yyyy');
      const endDate = moment().format('DD.MM.yyyy');
      axios
        .get(
          '/GetTasksDataCustomerFeedbackForServiceShop/' +
          formData.ConsumerId +
          '/' +
          startDate +
          '/' +
          endDate
        )
        .then(response => {
          setFeedbackDataList(response.data);
        })
        .catch(error => { });
      setLoading2(false);
      setOpenFeedbackPopup(true);
    }
  }

  const AddExperianAddressWithGoogleResponse = (searchAddress, experianPostCode) => {
    setLoading2(true);

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    var Request = {
      Address: experianPostCode + "," + searchAddress
    };
    axios
      .post('/GoogleSearchLocation', Request, dataConfig)
      .then(response => {

        if (response.status != 200) {
          alert("An error occured while matching Experian address data with google maps api." + response.statusText);

        } else {
          if (response?.data?.results.length > 0) {
            var matchedAddressData = response?.data?.results[0]; //taking first match from address string at start

            if (experianPostCode != null) {

              //check string match as postcode if address contains any and set matched address to that
              for (let addressItem of response?.data?.results) {
                var responseAddress = addressItem.formatted_address.replace(",", "");
                var containsPostCode = responseAddress.includes(experianPostCode);
                //if this loop contains address more than one matching experianPostCode, that will take first -> sorry no fuzzy matching or ngram similarity here..
                if (containsPostCode) {
                  matchedAddressData = addressItem;
                  break;
                }
              };
            }

            var formatted_address = searchAddress;
            var lang = matchedAddressData?.geometry?.location?.lat;
            var long = matchedAddressData?.geometry?.location?.lng;
            var placeId = matchedAddressData.place_id;

            AddAddress(formatted_address, lang, long, placeId, experianPostCode);
          }
          else {
            //burada experiandan gelen veri ile google üzerinde aramada sonuç bulamıyor. Google ile deniyoruz. Yine bulamaz ise uyarı verilip konu kapanacak.
            var retryMessage = "Could not get location information. Sirius will try get location information with another smart keywords automatically or you can cancel the request, try using PostCode information to search or you can try using Google Map search functionality.";

            if (window.confirm(retryMessage) == true) {
              AddExperianAddressWithGoogleResponse(addressGoogleSearch);
            } else {
              alert("Please search with postcode or try to use Google Tab to search.");
            }

          }

          setLoading2(false);
          setGoogleAddressSearchPopup(false);
          //video commit - ntt change management showing info - dont merge it
          //add address not async -> will not wait and dont want to change to add to get lang long from google..i wont use old school promise etc
        }

      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const AddAddress = (formatted_address, lat, lng, place_id, experianPostCode) => {
    setLoading2(true);
    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    var Request = {
      Address: place_id
    };
    axios
      .post('/GoogleSearchLocationDetail', Request, dataConfig)
      .then(response => {
        var postal_code = '';
        var No = '';
        var country = '';
        var Neighborhood = '';
        var Street = '';
        var DoorNr = '';
        var City = '';
        var District = '';
        var State = '';
        var Region = '';
        if (SessionUser.TenantId != 71 && SessionUser.TenantId != 16 && SessionUser.TenantId != 88 && SessionUser.TenantId != 115 && SessionUser.TenantId != 12) {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'subpremise') {
              DoorNr = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              District = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_4') {
              Neighborhood = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              No = item.long_name;
            }
          });
        }
        else if (SessionUser.TenantId == 16) // FOR UK MAPPING REQUEST CHANGED - GFSM-4860
        {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = experianPostCode == null ? item.long_name : experianPostCode;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'subpremise') {
              DoorNr = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              District = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_4') {
              Neighborhood = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              No = item.long_name;
            }
            if (item.types[0] === 'postal_town') {
              City = item.long_name;
            }

          });

        }
        else if (SessionUser.TenantId == 115) {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
          if (City == '' || City == null) {
            City = State
          }
        }
        else if (SessionUser.TenantId == 12 && SessionUser.TenantId == 53) {
          const streetComponents = {
            route: "",
            premise: "",
            street_number: "",
          };
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'postal_town') {
              District = item.long_name;
            }
            if (item.types[0] === 'route') {
              streetComponents.route = item.long_name;
            }
            if (item.types[0] === 'premise') {
              streetComponents.premise = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              streetComponents.street_number = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              Region = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
          Street = `${streetComponents.route} ${streetComponents.premise}/${streetComponents.street_number}`.trim();
          if (City == '' || City == null) {
            City = State
          }
        }
        else if (SessionUser.TenantId == 88) {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'locality') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              Region = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
          if (City == '' || City == null) {
            City = State
          }
        }
        else {
          response.data.result.address_components.forEach(item => {
            if (item.types[0] === 'postal_code') {
              postal_code = item.long_name;
            }
            if (item.types[0] === 'country') {
              country = item.long_name;
            }
            if (item.types[0] === 'route') {
              Street = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_2') {
              City = item.long_name;
            }
            if (item.types[0] === 'administrative_area_level_1') {
              State = item.long_name;
            }
            if (item.types[0] === 'street_number') {
              DoorNr = item.long_name;
            }
          });
        }
        var Data = [...formData.Addresses];
        var AddressItem = {
          ...Data[AddressIndex],
          AddressItem: formatted_address,
          Latitude: lat,
          Longitude: lng,
          PostCode: postal_code,
          Street: Street,
          Neighborhood: Neighborhood,
          District: District,
          City: City,
          Apartment: No,
          DoorNr: (SessionUser.TenantCode == "gb" && DoorNr?.length < 1) ? No : DoorNr,//Ask eren bout this "logic"..
          State: State,
          Region: Region
        };

        // formData.Addresses[AddressIndex]?.Region
        // formData.Addresses[AddressIndex]?.State
        Data[AddressIndex] = AddressItem;
        setFormdata({ ...formData, Addresses: Data });
        setLoading2(false);
        setGoogleAddressSearchPopup(false);
      })
      .catch(error => {
        setLoading2(false);
      });
  };

  const min = 0;
  const max = 365;

  const SetCountryData = (event, data) => {
    setCountryDataControl(data);
  };


  const GetWorkCaseFeedback = item => {
    setOpenFeedbackPopup(false);
    setLoading2(true);
    axios.get(`/GetWorkCaseFeedbacks/${item.WorkCaseId}`)
      .then(response => {
        if (response.data.length > 0) {
          setFeedback(response.data);
          setOpenFeedbackPopup(false);
          setOpenFeedbackDetailPopup(true);
          setLoading2(false);
        }
        else {
          setFeedback([]);
          setOpenFeedbackDetailPopup(true);
          setLoading2(false);
        }
      })
      .catch(error => { });
    setLoading2(false);
  };

  const GetFeedbackDesc = (item) => {
    axios.get(`/GetFeedbackDesc/${item.WorkCaseId}`)
      .then(response => {
        if (response.data.length > 0) {
          setFeedbackList(response.data);
          setOpenFeedbackDetailPopup(true);
        }
        else {

        }
      })
      .catch(error => { });
  };


  // Burada sms detail yapılacak
  const getNpsDetail = (Control, WorkOrderId, ServiceShopId) => {
    if (Control === 0) {
      return;
    }
    setInformationDetailPopup(true)
    setWorkOrderId(WorkOrderId)
    setInfoServiceShopId(ServiceShopId)
  }

  const setNewWorkCasePopupClose = () => {
    setNewWorkCasePopup(false);
    setisButtonDisabled(false);
  }

  const GetMaterialOrderFromConsumer = (consumerId) => {
    setConsumerMaterialOrders([]);
    axios
      .get(`/GetMaterialOrderFromConsumer/` + consumerId)
      .then(response => {

        if (response.data.length > 0) {
          setConsumerMaterialOrders(response.data);
          setOpenMaterialOrdersPopUp(true);
        } else {
          setConsumerMaterialOrders([]);
          setResponseType('error');
          setResponseDsc(t('lblNoMaterialOrders'));
          setOpenSnackbar(true);
        }
      })
      .catch(error => {
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true);
      });
  }

  const GetMaterialOrderFromOrderId = (row) => {
    axios
      .get(`/GetMaterialOrderFromOrderId/` + row.OrderId)
      .then(response => {
        const Response = response.data[0];
        if (response.data.length > 0) {
          handleRoute(Response);
        } else {
          setResponseType('error');
          setResponseDsc(t('lblError'));
          setOpenSnackbar(true);
        }
      })
      .catch(error => {
        setResponseType('error');
        setResponseDsc(t('lblError'));
        setOpenSnackbar(true);
      });
  };

  function handleRoute(value) {
    if (history && history.push && typeof history.push === 'function') {
      if (value.ShipToToConsumerId != 0) {
        history.push({ pathname: '/materialOrder2/Create/ForConsumer', state: value });
      } else if (value.ShipToToOtc != 0) {
        history.push({ pathname: '/materialOrder2/Create/ForOTC', state: value });
      } else {
        history.push({ pathname: '/materialOrder2/Create/ForPartner', state: value });
      }
    } else {
      console.error('history.push is not available. Application might crash.');
    }
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const changeCustomerType = (CustomerTypeId) => {


    // GFSM-6288
    dispatch(customerThunks.GetCustomerTypeTaxNumberMatching(({
      customerTypeId: CustomerTypeId
    }))).then((res) => {
      if (res.payload != null && res.payload.TaxNumber != null) {
        setFormdata({
          ...formData,
          TaxId: res.payload.TaxNumber,
          CustomerTypeId: CustomerTypeId,
          ExceptId: "1" // GFSM-6288
        })

      }
      else {
        setFormdata({
          ...formData,
          CustomerTypeId: CustomerTypeId
        })
      }
    })
  }

  return (
    <>
      <Breadcrumbs aria-label="breadcrumb">
        <Link color="inherit">Sirius</Link>
        <Typography color="textPrimary">{t('lblWorkCase')}</Typography>
      </Breadcrumbs>
      <Snackbar open={uyari} autoHideDuration={10000} onClose={uyariKapat}>
        <Alert
          onClose={uyariKapat}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <Backdrop className={classes.backdrop} open={isGetTaskRequestSending}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card className={clsx(classes.root, className)}>
        <Backdrop className={classes.backdrop} open={saveControl}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <BottomNavigation
          value={TopBarValue}
          className={classes.stickToBottom}
          onChange={(event, newValue) => {
            setTopBarValue(newValue);
            if (newValue === 0) {
              setSaveControl(true);
              //KAYDET
              if (formData.ConsumerId === undefined) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblMustFieldControl')
                });
                setUyariTip('error');
                setUyari(true);
                setRequired(true);
                return;
              }
              SaveConsumer();
            }
            if (newValue === 1) {
              //Yeni Müşteri
              GetSecretNote(0);
              setFormdata({ ...DefaultConsumerValue, CustomerTypeId: DefaultCustomerTypeId, Phones: [] });
              setAddressIndex(0);
              setVulnerabilitiesId(0);
              setNewTel(countryCode);
              sessionStorage.removeItem('SearhResult');
              sessionStorage.removeItem('ConsumerId');
              setRequired(false);
            }
            if (newValue === 2) {
              //Müşteri Adresleri
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              if (formData.Addresses.filter(x => x.AddressId > 0).length > 0) {
                setAddressPopup(true);
              }
            }
            if (newValue === 3) {
              //Müşteri WorkCaseleri
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              sessionStorage.removeItem('ConsumerId');
              sessionStorage.setItem('ConsumerId', formData.ConsumerId);
              handleConsumerWorkCase(1);
              // handleRefresh();
            }
            if (newValue === 4) {
              //Yeni WorkCase
              setNewWorkCaseData(DefaultWorkCase);
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              var Data = { ...NewWorkCaseData };
              Data.ConsumerId = formData.ConsumerId;
              Data.ProductId = 0;
              Data.Product = '';
              Data.IssueId = 0;
              Data.Issue = '';
              Data.Retailer = '';
              Data.RetailerId = 0;
              Data.RightToRepairConsent = false;
              Data.StatusId = 1;
              Data.WarrantyTypeId = 0;
              Data.Comment = '';
              GetConsumerAssetsData();
              setNewWorkCaseData(Data);
              setNewAssetChosen(false);
              setAssetChosen(false);
              setNewWorkCasePopup(true);
              setisButtonDisabled(false);
              setIssueTypeId(1);
            }
            if (newValue === 5) {
              //Assetler
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetConsumerAssets();
            }
            if (newValue === 6) {
              //Müşteriye ait dosyalar
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetConsumerFileData();
            }
            if (newValue === 7) {
              // GDPR
              GetGdpr();
            }
            if (newValue === 8) {
              // MaterialOrders
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetMaterialOrderFromConsumer(formData.ConsumerId);
            }
            if (newValue === 9) {
              // Tasks
              setJobSearchPopup(true);
            }
            if (newValue === 10) {

              if (SessionUser.ServiceShopId === 11740) {
                return;
              }
              // Feedback
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              openFeedbackPopupX();
            }

            if (newValue === 11) {
              // NPS

              if (SessionUser.ServiceShopId === 11740) {
                return;
              }


              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetConsumerInformation();
            }

            if (newValue === 12) {
              // Sms
              if (SessionUser.ServiceShopId === 11740) {
                return;
              }
              if (
                formData.ConsumerId === 0 ||
                formData.ConsumerId === undefined
              ) {
                setresponseMessage({
                  ErrorCode: 10,
                  ErrorDescription: t('lblCustomerWarning')
                });
                setUyariTip('error');
                setUyari(true);
                return;
              }
              GetManuelSmsEmailTemplate();
              GetConsumerSmsInformation();
            }
            if (newValue === 13) {
              if (SessionUser.TenantId === 82 || SessionUser.TenantId === 37) {
                if (
                  formData.ConsumerId === 0 ||
                  formData.ConsumerId === undefined
                ) {
                  setresponseMessage({
                    ErrorCode: 10,
                    ErrorDescription: t('lblCustomerWarning')
                  });
                  setUyariTip('error');
                  setUyari(true);
                  return;
                }
                setValuePropositionDialog(true)
              }
              else if (SessionUser.TenantId === 49 || SessionUser.TenantId === 12) {
                // Email2Case
                if (
                  formData.ConsumerId === 0 ||
                  formData.ConsumerId === undefined
                ) {
                  setresponseMessage({
                    ErrorCode: 10,
                    ErrorDescription: t('lblCustomerWarning')
                  });
                  setUyariTip('error');
                  setUyari(true);
                  return;
                }
                // SR-013: kapı açık tenant'ta eski dialog yerine yeni conversation görünümü (WorkOrder > E-mail)
                if (mailOrbitEnabled && ReceiptNo) {
                  history.push(`/WorkOrder/${ReceiptNo}/MailOrbitEmail`);
                  return;
                }
                setEmailThreadDialogOpen(true)
              }
              else {
                // OmniChannel
                if (
                  formData.ConsumerId === 0 ||
                  formData.ConsumerId === undefined
                ) {
                  setresponseMessage({
                    ErrorCode: 10,
                    ErrorDescription: t('lblCustomerWarning')
                  });
                  setUyariTip('error');
                  setUyari(true);
                  return;
                }
                setOmniChannelDialog(true)
              }
            }
          }}
          showLabels
        >
          <BottomNavigationAction label={t('lblSave')} icon={<SaveIcon />} />
          <BottomNavigationAction
            label={t('lblNewConsumer')}
            icon={<PersonAddIcon />}
            onClick={() => setNpsLowScoreCount(0)}
          />
          <BottomNavigationAction
            label={
              t('lblAddress') +
              ' (' +
              parseInt(
                formData.Addresses?.filter(x => x.AddressId > 0).length
              ) +
              ')'
            }
            icon={<LocationOnIcon />}
          />
          <BottomNavigationAction
            label={
              t('lblWorkCase') +
              ' (' +
              (formData.WorkCaseCount ?? 0) +
              ')'
            }
            icon={<BusinessCenterIcon />}
          />
          <BottomNavigationAction
            label={t('lblNewWorkCase')}
            icon={<NextWeekIcon />}
          />
          <BottomNavigationAction
            label={t('lblAssets') + ' (' + parseInt(formData?.AssetCount) + ')'}
            icon={<VideogameAssetIcon />}
          />
          <BottomNavigationAction
            label={t('lblFiles')}
            icon={<AttachmentIcon />}
          />
          <BottomNavigationAction
            label={t('lblGdpr')}
            icon={<AssignmentTurnedInIcon />}
          />
          <BottomNavigationAction
            label={t('lblMaterialOrders')}
            icon={<ShoppingCartIcon />}
          />
          <BottomNavigationAction
            label={t('lblTasks')}
            icon={<AssignmentIcon />}
          />
          <BottomNavigationAction
            label={t('lblFeedback') + ' (' + parseInt(formData?.FeedBackCount) + ')'}
            icon={<SettingsBackupRestoreIcon />}
          />
          <BottomNavigationAction
            label={t('lblNPS')}
            icon={<ThumbsUpDownIcon />}
          />
          <BottomNavigationAction
            label={t('lblSms')}
            icon={<SmsIcon />}
          />
          {SessionUser.TenantId === 82 || SessionUser.TenantId === 37 ? (
            <BottomNavigationAction
              label={t('lblValueProposition')}
              icon={<TouchAppIcon />}
            />
          ) : SessionUser.TenantId === 49 || SessionUser.TenantId === 12 ? (
            <BottomNavigationAction
              label={t('lblEmail2Case')}
              icon={<MailOutlineIcon />}
            />
          ) : (
            <BottomNavigationAction
              label={t('lblOmniChannel')}
              icon={<TouchAppIcon />}
            />
          )}
        </BottomNavigation>
      </Card>
      <Card>
        <CardHeader
          style={{ textAlign: 'left' }}
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>{formData.Search ? formData.Search : t('lblNewConsumer')}</span>
              {LegalEntityTenantIds.includes(SessionUser.TenantId) && formData.UserLegalEntity && (
                <span style={{
                  marginLeft: '10px',
                  fontSize: '14px',
                  color: getLegalEntityColor(formData.UserLegalEntity),
                  fontWeight: 'bold'
                }}>
                  - {highlightBeko(formData.UserLegalEntity)}

                </span>

              )}
            </div>
          }
        />
        <Divider />
        <CardContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} lg={5}>
              <Card className={classes.cards}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <CardHeader
                      style={{ textAlign: 'left' }}
                      title={t('lblPersonInfo')}
                      action={<Box p={2.5}></Box>}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CardHeader
                      style={{ textAlign: 'right' }}
                      title={
                        formData.ConsumerId == 0
                          ? 'Id: ' + 0
                          : 'Id: ' + formData.ConsumerId
                      }
                      action={
                        <Box p={0}>
                          <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={handleClickScreen}
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            id="long-menu"
                            anchorEl={anchorElScreen}
                            keepMounted
                            open={openScreen}
                            onClose={handleClose}
                          >
                            <FormControl component="fieldset">
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={IdNrScreen}
                                      onChange={handleChangeScreen}
                                      name="IdNrScreen"
                                    />
                                  }
                                  label={t('lblIdNr')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={TaxOfficeScreen}
                                      onChange={handleChangeScreen}
                                      name="TaxOfficeScreen"
                                    />
                                  }
                                  label={t('lblTaxOffice')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={TaxIdScreen}
                                      onChange={handleChangeScreen}
                                      name="TaxIdScreen"
                                    />
                                  }
                                  label={t('lblTaxId')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={ExceptIdScreen}
                                      onChange={handleChangeScreen}
                                      name="ExceptIdScreen"
                                    />
                                  }
                                  label={t('lblExceptId')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={InsurancePlanNumberScreen}
                                      onChange={handleChangeScreen}
                                      name="InsurancePlanNumberScreen"
                                    />
                                  }
                                  label={t('lblInsurancePlanNumber')}
                                />
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={ReferralNumberScreen}
                                      onChange={handleChangeScreen}
                                      name="ReferralNumberScreen"
                                    />
                                  }
                                  label={t('lblReferralNumber')}
                                />
                              </FormGroup>
                            </FormControl>
                          </Menu>
                        </Box>
                      }
                    />
                  </Grid>
                </Grid>
                <SearchComponent searchedValue={{
                  ConsumerId: formData.ConsumerId,
                  CustomerFullName: formData.FirstName + ' ' + formData.LastName,
                  City: formData.Addresses?.[0]?.City,
                  PostCode: formData.Addresses?.[0]?.PostCode
                }}
                  Valuekey="recentConsumerSearches"
                />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        // error={formData?.Title?.length > 0 ? false : Required}
                        label={t('lblTitle')}
                        autoComplete="no"
                        value={formData?.Title ? formData?.Title : ''}
                        id="Title"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            Title: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        {consumerTitleData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Dsc}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        id="CustomerTypeId"
                        required={SessionUser.TenantId === 79}
                        label={t('lblCustomerType')}
                        autoComplete="no"
                        error={formData.CustomerTypeId > 0 ? false : Required}
                        value={
                          CustomerTypeData[0]
                            ? formData.CustomerTypeId
                              ? formData.CustomerTypeId
                              : CustomerTypeData[0]
                            : ''
                        }
                        onChange={event =>
                          changeCustomerType(event.target.value)
                        }
                        variant="outlined"
                      >
                        {CustomerTypeData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Autocomplete
                        disablePortal
                        id="preferredLanguage"
                        getOptionLabel={(option) => option.name}
                        options={languageList}
                        onChange={(event, option) => {
                          setFormdata({
                            ...formData,
                            PreferredLanguage: option?.key
                          });
                        }}
                        value={languageList.find(l => l.key === formData.PreferredLanguage)}
                        renderInput={(params) => <TextField required  {...params}
                          variant="outlined" size="small"
                          fullWidth label={t('lblPreferredLanguage')}
                        />}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="FirstName"
                        autoComplete="no"
                        value={formData.FirstName ? formData.FirstName : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            FirstName: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblFirstName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="MiddleName"
                        value={formData.MiddleName ? formData.MiddleName : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            MiddleName: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblMiddleName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        error={formData.LastName.length > 0 ? false : Required}
                        required
                        id="LastName"
                        value={formData.LastName ? formData.LastName : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            LastName: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblLastName')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField
                        size="small"
                        id="IdNr"
                        style={{ display: IdNrScreen ? '' : 'none' }}
                        value={formData.IdNr ? formData.IdNr : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({ ...formData, IdNr: event.target.value })
                        }
                        fullWidth
                        label={t('lblIdNr')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField
                        size="small"
                        id="TaxOffice"
                        style={{ display: TaxOfficeScreen ? '' : 'none' }}
                        value={formData.TaxOffice ? formData.TaxOffice : ''}
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            TaxOffice: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblTaxOffice')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField
                        size="small"
                        id="TaxId"
                        style={{ display: TaxIdScreen ? '' : 'none' }}
                        autoComplete="no"
                        value={formData.TaxId ? formData.TaxId : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            TaxId: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblTaxId')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                      <TextField
                        size="small"
                        id="ExceptId"
                        style={{ display: ExceptIdScreen ? '' : 'none' }}
                        autoComplete="no"
                        value={formData.ExceptId ? formData.ExceptId : ''}
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            ExceptId: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblExceptId')}
                        variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField
                        size="small"
                        id="Email"
                        autoComplete="no"
                        value={formData.Email ? formData.Email : ''}
                        helperText={emailError}
                        error={ValidControlColor}
                        onChange={event => validateEmail(event)}
                        fullWidth
                        label={t('lblEmail')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="InsurancePlanNumber"
                        style={{
                          display: InsurancePlanNumberScreen ? '' : 'none'
                        }}
                        value={
                          formData.InsurancePlanNumber
                            ? formData.InsurancePlanNumber
                            : ''
                        }
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            InsurancePlanNumber: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblInsurancePlanNumber')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <TextField
                        size="small"
                        id="ReferralNumber"
                        style={{ display: ReferralNumberScreen ? '' : 'none' }}
                        value={
                          formData.ReferralNumber ? formData.ReferralNumber : ''
                        }
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            ReferralNumber: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblReferralNumber')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <TextField
                        size="small"
                        id="ExternalId"
                        disabled={true}
                        value={
                          formData.ExternalId ? formData.ExternalId : ''
                        }
                        autoComplete="no"
                        onChange={event =>
                          setFormdata({
                            ...formData,
                            ExternalId: event.target.value
                          })
                        }
                        fullWidth
                        label={t('lblExternalId')}
                        variant="outlined"
                      />
                    </Grid>
                    {/* Telefon Bölümü */}

                    <Grid item xs={12} sm={1} lg={1}>
                      <Box p={1}>
                        <AddBoxIcon onClick={handleOnAdd} />
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <TextField
                        size="small"
                        fullWidth
                        error={ParamPhonesType > 0 ? false : Required}
                        select
                        label={<> {t('lblSelectType')} <span>*</span> </>}
                        id="ParamPhonesType"
                        value={
                          PhoneTypes[0]
                            ? ParamPhonesType
                              ? ParamPhonesType
                              : PhoneTypes[0]
                                ? PhoneTypes[0].Id
                                : 1
                            : 1
                        }
                        onChange={event =>
                          setParamPhonesType(event.target.value)
                        }
                        variant="outlined"
                      >
                        {PhoneTypes.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={8} lg={8}>
                      <div style={{ position: 'relative' }}>
                        <PhoneInput
                          style={{ width: '100%' }}
                          country={SessionUser.TenantCode}
                          enableSearch={true}
                          onFocus={SetCountryData}
                          name={'phone'}
                          ref={phoneRef}
                          inputProps={{
                            name: 'phone',
                            required: true
                          }}
                          inputStyle={
                            Required & (formData?.Phones?.length === 0)
                              ? { borderColor: '#e53935' }
                              : { width: '100' }
                          }
                          containerStyle={{ textAlign: 'left' }}
                          countryCodeEditable={false}
                          masks={{mt: '.... ....'}}
                          value={newtel}
                          onChange={handleOnChange}
                        />
                        <div style={{
                          position: 'absolute',
                          right: '-1em',
                          top: '50%',
                          transform: 'translateY(-50%)'
                        }}> *
                        </div>
                      </div>
                    </Grid>
                    <Grid container item xs={12} spacing={1}>
                      {formData?.Phones?.map((item, index) => (
                        <Grid container item xs={12} spacing={1} key={index}>
                          <Grid item xs={12} sm={1} lg={1}>
                            <Box p={1}>
                              <DeleteForeverOutlinedIcon
                                style={{ color: 'black' }}
                                onClick={event =>
                                  DeletePhoneItem(event, item.Phone)
                                }
                              />
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={3} lg={3}>
                            <TextField
                              size="small"
                              fullWidth
                              value={item.PhoneType}
                              disabled={true}
                              variant="outlined"
                            ></TextField>
                          </Grid>
                          <Grid item xs={12} sm={5} lg={5}>
                            <PhoneInput
                              value={item.Phone}
                              // country={SessionUser.TenantCode}
                              disabled={true}
                              inputStyle={{ width: '100%' }}
                              containerStyle={{ textAlign: 'left' }}
                              masks={{mt: '.... ....'}}
                            // onChange={phone => this.setState({ phone })}
                            />
                          </Grid>
                          {isPhoneIntegrationEnabled && (
                            <Grid item xs={12} sm={1} lg={1}>
                              <Box p={1}>
                                <IconButton
                                  size="small"
                                  style={{ color: '#00cf07' }}
                                  title={item.Phone}
                                  onClick={() => handleOutboundCall(item.Phone)}
                                >
                                  <PermPhoneMsgIcon />
                                </IconButton>
                              </Box>
                            </Grid>
                          )}
                        </Grid>
                      ))}
                    </Grid>

                    {/* Telefon Bölümü */}
                    <Grid item xs={12}>
                      <Typography variant="h5" >
                        {t('lblLastUpdate')}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p" >
                        {t('lblCreateUser')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom> {(formData.CreateEmployee ? formData.CreateEmployee : '-')}
                      </Typography>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p">
                        {t('lblCreateDate')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom>
                        {formData.CreateDate ? moment(formData.CreateDate).format('DD/MM/YYYY HH:mm') : '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p">
                        {t('lblUpdateUser')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom>
                        {(formData.UpdateEmployee ? formData.UpdateEmployee : '-')}
                      </Typography>
                      <Typography variant="body2"
                        color="textSecondary"
                        component="p">
                        {t('lblUpdateDate')}
                      </Typography>
                      <Typography variant="body1"
                        component="h1" gutterBottom>
                        {formData.UpdateDate ? moment(formData.UpdateDate).format('DD/MM/YYYY HH:mm') : '-'}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={5}>
              <Card className={classes.cards}>
                <CardHeader
                  style={{
                    textAlign: 'left',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center'
                  }}
                  action={
                    <Grid container spacing={2}>
                      {SessionUser.TenantId !== 9 && (
                        <Grid
                          item
                          onClick={() => {
                            setGoogleAddressSearchPopup(true);
                            var addressItem = formData?.Addresses[AddressIndex]?.AddressItem;
                            if (addressItem) {
                              setaddressGoogleSearch(addressItem);
                              setAutoGoogleSearch(true);
                            }
                            else {
                              setaddressGoogleSearch('');
                              setGoogleAddressSearchResult([]);
                              setAutoGoogleSearch(false);
                            }

                          }}
                          style={{ display: MapSearchScreen ? '' : 'none' }}

                        >
                          <FormControlLabel
                            control={
                              <Box p={1}>
                                {
                                  SessionUser.TenantCode == "gb" ?
                                    <FaSearchLocation color="primary"></FaSearchLocation> :
                                    <FcGoogle color="primary"></FcGoogle>
                                }
                              </Box>
                            }
                            // label={t('Google') + 'Map' + t('lblSearch')}
                            label={
                              SessionUser.TenantCode == "gb"
                                ? t('lblMap') + t('lblSearch')
                                : t('Google') + 'Map' + t('lblSearch')
                            }
                            labelPlacement="end"
                          />
                        </Grid>
                      )}
                      <Grid item onClick={() => setAddressSearchPopup(true)}>
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <SearchIcon
                                color="primary"
                              ></SearchIcon>
                            </Box>
                          }
                          label={t('lblSearch')}
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item onClick={handleOnAddressAdd}>
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <AddBoxIcon
                                color="primary"

                              />
                            </Box>
                          }
                          label={t('lblNew')}
                          labelPlacement="end"
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Switch
                              color="primary"
                              checked={
                                formData.Addresses[AddressIndex]?.PrimaryAddress
                                  ? true
                                  : false
                              }
                              onChange={event =>
                                handleChangeAddressPrimary(event, AddressIndex)
                              }
                              name="PrimaryAddress"
                              id="PrimaryAddress"
                            />
                          }
                          labelPlacement="end"
                          label={consumerAddressPrimarySecondary}
                        />
                      </Grid>
                      <Grid item>
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <MoreVertIcon
                                color="primary"
                                onClick={handleClickAddressScreen}
                              />
                            </Box>
                          }
                          labelPlacement="start"
                        />
                        <Menu
                          id="long-menu"
                          anchorEl={anchorElAddressScreen}
                          keepMounted
                          open={openAddressScreen}
                          onClose={handleAddressClose}
                        >
                          <FormControl component="fieldset">
                            <FormGroup>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={MapSearchScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="MapSearchScreen"
                                  />
                                }
                                label={t('lblGoogleMapAddressSearch')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={StateScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="StateScreen"
                                  />
                                }
                                label={t('lblState')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={RegionScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="RegionScreen"
                                  />
                                }
                                label={t('lblRegion')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={ApartmentScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="ApartmentScreen"
                                  />
                                }
                                label={t('lblApartment')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={DoorNrScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="DoorNrScreen"
                                  />
                                }
                                label={t('lblDoorNr')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={PostCodeScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="PostCodeScreen"
                                  />
                                }
                                label={t('lblPostCode')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={LongitudeScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="LongitudeScreen"
                                  />
                                }
                                label={t('lblLongitude')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={LatitudeScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="LatitudeScreen"
                                  />
                                }
                                label={t('lblLatitude')}
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={AddressScreen}
                                    onChange={handleChangeAddressScreen}
                                    name="AddressScreen"
                                  />
                                }
                                label={t('AddressScreen')}
                              />
                            </FormGroup>
                          </FormControl>
                        </Menu>
                      </Grid>
                    </Grid>
                  }
                  title={t('lblAddress')}
                />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} lg={6}>
                      <ReactFlagsSelect
                        size="small"
                        selected={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Country === ''
                              ? selected
                              : formData.Addresses[AddressIndex]?.Country
                            : selected
                        }
                        searchable
                        id="Country"
                        name="Country"
                        onSelect={code => SetCountry(code, AddressIndex)}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        autoComplete="no"
                        id="AddressTypeId"
                        label={t('lblAddressType')}
                        value={
                          AddressTypes[0]
                            ? formData.Addresses[AddressIndex]?.AddressTypeId
                              ? formData.Addresses[AddressIndex]?.AddressTypeId
                              : 1
                            : 1
                        }
                        required={
                          NewAddressCheck() ? RequiredAddress : false
                        }
                        error={
                          NewAddressCheck()
                            ? formData.Addresses[AddressIndex]?.AddressTypeId
                              > 0
                              ? false
                              : RequiredAddress
                            : false
                        }
                        onChange={event =>
                          handleChangeAddressId(event, AddressIndex)
                        }
                        variant="outlined"
                      >
                        {AddressTypes.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="State"
                        style={{ display: StateScreen ? '' : 'none' }}
                        autoComplete="no"
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.State
                            : ''
                        }
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        fullWidth
                        label={t('lblState')}
                        variant="outlined"
                      />
                    </Grid>
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={6}>
                        <Autocomplete
                          size="small"
                          fullWidth
                          freeSolo={SessionUser?.TenantId !== 70}
                          autoSelect={SessionUser?.TenantId !== 70}
                          style={{ display: RegionScreen ? '' : 'none' }}
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.Region
                              : ''
                          }
                          options={RegionData}
                          onChange={(event, newValue) => {
                            GetCity(event, AddressIndex, newValue);
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblRegion')}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid> : null}

                    <Grid item xs={12} sm={6} lg={6}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        freeSolo={SessionUser?.TenantId !== 70}
                        autoSelect={SessionUser?.TenantId !== 70}
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.City
                            : ''
                        }
                        options={CityData}
                        onChange={(event, newValue) => {
                          GetDistrictRequest(event, AddressIndex, newValue);
                        }}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={t('lblCity')}
                            variant="outlined"
                            required={SessionUser.TenantId === 79 || (NewAddressCheck() ? RequiredAddress : false)}
                            error={
                              NewAddressCheck()
                                ? RequiredAddress : false
                            }
                          />
                        )}
                      />
                    </Grid>
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={6}>
                        <Autocomplete
                          size="small"
                          fullWidth
                          freeSolo
                          autoSelect
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.District
                              : ''
                          }
                          id="controllable-states-distict"
                          options={DistrictData}
                          getOptionLabel={option => option}
                          onChange={(event, newInputValue) => {
                            ChangeDistrict(event, AddressIndex, newInputValue);
                          }}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblDistrict')}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid> : null}
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={6}>
                        <Autocomplete
                          size="small"
                          fullWidth
                          id="Neighborhood"
                          freeSolo
                          autoSelect
                          options={NeighborhoodData}
                          getOptionLabel={option => option}
                          onChange={(event, newInputValue) =>
                            ChangeNeighborhood(event, AddressIndex, newInputValue)
                          }
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.Neighborhood
                              : ''
                          }
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblNeighborhood')}
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid> : null}

                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        id="Street"
                        autoComplete="no"
                        inputProps={{
                          maxLength: 40,
                        }}
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Street
                            : ''
                        }
                        fullWidth
                        label={t('lblStreet')}
                        variant="outlined"
                      />
                    </Grid>
                    {SessionUser.TenantId != 71 ?
                      <Grid item xs={12} sm={6} lg={4}>
                        <TextField
                          size="small"
                          id="Apartment"
                          style={{ display: ApartmentScreen ? '' : 'none' }}
                          autoComplete="no"
                          onChange={event =>
                            handleChangeAddress(event, AddressIndex)
                          }
                          value={
                            formData.Addresses
                              ? formData.Addresses[AddressIndex]?.Apartment
                              : ''
                          }
                          fullWidth
                          label={t('lblApartment')}
                          variant="outlined"
                        />
                      </Grid> : null}
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="DoorNr"
                        style={{ display: DoorNrScreen ? '' : 'none' }}
                        autoComplete="no"
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.DoorNr
                            : ''
                        }
                        fullWidth
                        label={t('lblDoorNr')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        id="PostCode"
                        style={{ display: PostCodeScreen ? '' : 'none' }}
                        freeSolo
                        autoSelect
                        options={PostCodeData}
                        onChange={(event, newInputValue) =>
                          ChangePostCode(event, AddressIndex, newInputValue)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.PostCode
                            : ''
                        }

                        getOptionLabel={option => option}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={t('lblPostCode')}
                            variant="outlined"
                            required={
                              NewAddressCheck() ? RequiredAddress : false
                            }
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={6} lg={12}>
                      <TextField
                        size="small"
                        multiline
                        rows={10}
                        fullWidth
                        id="AddressItem"
                        style={{ display: AddressScreen ? '' : 'none' }}
                        /*  error={
                            NewAddressCheck()
                              ? formData.Addresses[AddressIndex]?.AddressItem
                                ?.length > 0
                                ? false
                                : RequiredAddress
                              : false
                          }
                          required={NewAddressCheck() ? RequiredAddress : false} */
                        autoComplete="no"
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.AddressItem
                            : ''
                        }
                        label={t('lblAddress')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="Longitude"
                        style={{ display: LongitudeScreen ? '' : 'none' }}
                        autoComplete="no"
                        disabled
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Longitude
                            : ''
                        }
                        fullWidth
                        label={t('lblLongitude')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <TextField
                        size="small"
                        id="Latitude"
                        style={{ display: LatitudeScreen ? '' : 'none' }}
                        autoComplete="no"
                        disabled
                        onChange={event =>
                          handleChangeAddress(event, AddressIndex)
                        }
                        value={
                          formData.Addresses
                            ? formData.Addresses[AddressIndex]?.Latitude
                            : ''
                        }
                        fullWidth
                        label={t('lblLatitude')}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={12} sm={1} lg={1}>
                      <Box p={1}>
                        <LocationOnIcon
                          style={{
                            display: LatitudeScreen ? '' : 'none',
                            color: 'red'
                          }}
                          onClick={event =>
                            handleClickMap(
                              event,
                              formData.Addresses[AddressIndex]?.Latitude,
                              formData.Addresses[AddressIndex]?.Longitude
                            )
                          }
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={2}>
              <Card className={classes.cards}>
                <CardHeader
                  style={{ textAlign: 'left' }}
                  action={<Box p={2.5} />}
                  title={t('lblPersonInternalNote')}
                />
                <CardContent className={classes.cardscontent}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        autoComplete="no"
                        error={
                          VulnerabilitiesId > 0
                            ? false
                            : requiredForInternalNotes
                        }
                        label={t('lblPersonPrivateNote')}
                        value={VulnerabilitiesId}
                        onChange={event =>
                          setVulnerabilitiesId(event.target.value)
                        }
                        variant="outlined"
                      >
                        <MenuItem key={0} value={0}>
                          {t('lblSelectCategory')}
                        </MenuItem>
                        {VulnerabilitiesData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                      <TextField
                        size="small"
                        label={t('lblPersonInternalNote')}
                        autoComplete="no"
                        name="Note"
                        multiline
                        rows={6}
                        fullWidth
                        value={SecretNote}
                        onChange={event => setSecretNote(event.target.value)}
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} style={{ textAlign: 'left' }}>
                      <IconButton
                        className={classes.action}
                        color="inherit"
                        key="close"
                        onClick={() => SetSecretNotePopUp(true)}
                      >
                        <ChatIcon />
                      </IconButton>
                    </Grid>



                    <Grid item xs={6} sm={6} style={{ textAlign: 'right' }}>
                      <IconButton
                        className={classes.action}
                        color="inherit"
                        key="close"
                        onClick={handleSendCostumerSecretNote}
                      >
                        <SendOutlinedIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12} style={{ maxHeight: 300, overflow: 'scroll' }}>
                    <List className={classes.cardscontent}>
                      {SecretNoteData.map((log, index) => (
                        <div key={index}>
                          <ListItem alignItems="flex-start">
                            <ListItemText
                              primary={''}
                              secondary={
                                <React.Fragment>
                                  <Typography
                                    component="span"
                                    variant="body1"
                                    className={classes.inline}
                                    color="textPrimary"
                                  >
                                    {log.Vulnerabilities}
                                    <br></br>
                                    <b>{t('lblEmployee')}:</b>{' '}
                                    {log.UserSecretNote}
                                    <br></br>
                                    <b>{t('lblDate')}:</b>{' '}
                                    {log.Date === undefined
                                      ? ''
                                      : Moment(log.Date).format(
                                        'DD/MM/YYYY HH:mm'
                                      )}
                                    <br></br>
                                    <b>{t('lblComment')}:</b> {log.SecretNote}
                                  </Typography>
                                </React.Fragment>
                              }
                            />
                            <ListItemSecondaryAction>
                              <IconButton edge="end" aria-label="delete">
                                <DeleteForeverOutlinedIcon
                                  style={{ color: 'red' }}
                                  onClick={() =>
                                    DeleteCostumerSecretNote(log.Id)
                                  }
                                ></DeleteForeverOutlinedIcon>
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                          <Divider />
                        </div>
                      ))}
                    </List>
                  </Grid>
                </CardContent>
              </Card>
              <Dialog
                open={secretNotePopUp}
                fullWidth={true}
                maxWidth={'lg'}
                onClose={() => SetSecretNotePopUp(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {t('lblPersonInternalNote')}
                </DialogTitle>
                <DialogContent>
                  <Card>
                    <Grid item xs={12} sm={12} lg={12}>
                      <List className={classes.cardscontent}>
                        {SecretNoteData.map((log, index) => (
                          <div key={index}>
                            <ListItem alignItems="flex-start">
                              <ListItemText
                                primary={''}
                                secondary={
                                  <React.Fragment>
                                    <Typography
                                      component="span"
                                      variant="body1"
                                      className={classes.inline}
                                      color="textPrimary"
                                    >
                                      {log.Vulnerabilities}
                                      <br></br>
                                      <b>{t('lblEmployee')}:</b>{' '}
                                      {log.UserSecretNote}
                                      <br></br>
                                      <b>{t('lblDate')}:</b>{' '}
                                      {log.Date === undefined
                                        ? ''
                                        : Moment(log.Date).format(
                                          'DD/MM/YYYY HH:mm'
                                        )}
                                      <br></br>
                                      <b>{t('lblComment')}:</b> {log.SecretNote}
                                    </Typography>
                                  </React.Fragment>
                                }
                              />
                              <ListItemSecondaryAction>
                                <IconButton edge="end" aria-label="delete">
                                  <DeleteForeverOutlinedIcon
                                    style={{ color: 'red' }}
                                    onClick={() =>
                                      DeleteCostumerSecretNote(log.Id)
                                    }
                                  ></DeleteForeverOutlinedIcon>
                                </IconButton>
                              </ListItemSecondaryAction>
                            </ListItem>
                            <Divider />
                          </div>
                        ))}
                      </List>
                    </Grid>
                  </Card>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => SetSecretNotePopUp(false)}
                    className={classes.button}
                    endIcon={<CloseIcon />}
                  >
                    {t('lblClose')}
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </CardContent>
        {["top"].map((anchor) => (
          <React.Fragment key={anchor}>
            {/* Email2Case artık bottom navigation'da */}
            {/* <Zoom key="email" in={true} unmountOnExit>
              <Fab className={classes.fabBlue}
                onClick={() => setEmailThreadDialogOpen(true)}
                color={"inherit"}
                title="Email2Case">
                <MailOutlineIcon />
              </Fab>
            </Zoom> */}
            <Zoom key="primary" in={true} unmountOnExit>
              <Fab className={classes.fabGreen}
                onClick={toggleDrawer(anchor, true)}
                color={"inherit"}>
                <UpIcon />
              </Fab>
            </Zoom>
            <SwipeableDrawer
              anchor={anchor}
              open={stateMobile[anchor]}
              onClose={toggleDrawer(anchor, false)}
              onOpen={toggleDrawer(anchor, true)}
            >
              <div
                className={clsx(classes.list, {
                  [classes.fullList]: anchor === "top" || anchor === "bottom"
                })}
                style={{ height: "300px" }}
                role="presentation"
                onClick={toggleDrawer(anchor, false)}
                onKeyDown={toggleDrawer(anchor, false)}
              >
                <br />
                <br />
                <BottomNavigation
                  value={TopBarValue}
                  onChange={(event, newValue) => {
                    setTopBarValue(newValue);
                    if (newValue === 0) {
                      //KAYDET
                      if (formData.ConsumerId === undefined) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblMustFieldControl')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        setRequired(true);
                        return;
                      }
                      SaveConsumer();
                    }
                    if (newValue === 1) {
                      //Yeni Müşteri
                      GetSecretNote(0);
                      setFormdata({ ...DefaultConsumerValue, CustomerTypeId: DefaultCustomerTypeId, Phones: [] });
                      setAddressIndex(0);
                      setVulnerabilitiesId(0);
                      setNewTel(countryCode);
                      sessionStorage.removeItem('SearhResult');
                      sessionStorage.removeItem('ConsumerId');
                      setRequired(false);
                    }
                    if (newValue === 2) {
                      //Müşteri Adresleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      if (formData.Addresses.filter(x => x.AddressId > 0).length > 0) {
                        setAddressPopup(true);
                      }
                    }
                    if (newValue === 3) {
                      //Müşteri WorkCaseleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      sessionStorage.removeItem('ConsumerId');
                      sessionStorage.setItem('ConsumerId', formData.ConsumerId);
                      handleConsumerWorkCase(1);
                      // handleRefresh();
                    }
                    if (newValue === 4) {
                      //Yeni WorkCase
                      setNewWorkCaseData(DefaultWorkCase);
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      var Data = { ...NewWorkCaseData };
                      Data.ConsumerId = formData.ConsumerId;
                      Data.ProductId = 0;
                      Data.Product = '';
                      Data.IssueId = 0;
                      Data.Issue = '';
                      Data.Retailer = '';
                      Data.RetailerId = 0;
                      Data.RightToRepairConsent = false;
                      Data.StatusId = 1;
                      Data.WarrantyTypeId = 0;
                      Data.Comment = '';
                      GetConsumerAssetsData();
                      setNewWorkCaseData(Data);
                      setNewAssetChosen(false);
                      setAssetChosen(false);
                      setNewWorkCasePopup(true);
                      setisButtonDisabled(false);
                      setIssueTypeId(1);
                    }
                    if (newValue === 5) {
                      //Assetler
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerAssets();
                    }
                    if (newValue === 6) {
                      //Müşteriye ait dosyalar
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerFileData();
                    }
                    if (newValue === 7) {
                      // GDPR
                      GetGdpr();
                    }
                    if (newValue === 8) {
                      // Tasks
                      setJobSearchPopup(true);
                    }
                    if (newValue === 9) {

                      if (SessionUser.ServiceShopId === 11740) {
                        return;
                      }
                      // Feedback
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      openFeedbackPopupX();
                    }

                    if (newValue === 10) {
                      // NPS

                      if (SessionUser.ServiceShopId === 11740) {
                        return;
                      }


                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerInformation();
                    }

                    if (newValue === 11) {

                      if (SessionUser.ServiceShopId === 11740) {
                        return;
                      }
                      // Sms
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerSmsInformation();
                      GetManuelSmsEmailTemplate();
                    }
                    if (newValue === 12) {
                      if (SessionUser.TenantId === 82 || SessionUser.TenantId === 37) {
                        // ValueProposition
                        if (
                          formData.ConsumerId === 0 ||
                          formData.ConsumerId === undefined
                        ) {
                          setresponseMessage({
                            ErrorCode: 10,
                            ErrorDescription: t('lblCustomerWarning')
                          });
                          setUyariTip('error');
                          setUyari(true);
                          return;
                        }
                      }
                      else {
                        // OmniChannel
                        if (SessionUser.ServiceShopId === 11740) {
                          return;
                        }
                        if (
                          formData.ConsumerId === 0 ||
                          formData.ConsumerId === undefined
                        ) {
                          setresponseMessage({
                            ErrorCode: 10,
                            ErrorDescription: t('lblCustomerWarning')
                          });
                          setUyariTip('error');
                          setUyari(true);
                          return;
                        }
                      }

                    }

                  }}
                  showLabels
                >

                  <BottomNavigationAction label={t('lblSave')} icon={<SaveIcon />} />
                  <BottomNavigationAction
                    label={t('lblNewConsumer')}
                    icon={<PersonAddIcon />}
                    onClick={() => setNpsLowScoreCount(0)}
                  />
                  <BottomNavigationAction
                    label={
                      t('lblAddress') +
                      ' (' +
                      parseInt(
                        formData.Addresses?.filter(x => x.AddressId > 0).length
                      ) +
                      ')'
                    }
                    style={{ display: 'none' }}
                    icon={<LocationOnIcon />}
                  />
                  <BottomNavigationAction
                    label={
                      t('lblWorkCase') + ' (' + workCaseNumber + ')'
                    }
                    icon={<BusinessCenterIcon />}
                  />

                  <BottomNavigationAction
                    label={t('lblNewWorkCase')}
                    icon={<NextWeekIcon />}
                  />

                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={t('lblAssets') + ' (' + parseInt(formData?.AssetCount) + ')'}
                    icon={<VideogameAssetIcon />}
                  />

                  <BottomNavigationAction
                    label={t('lblFiles')}
                    style={{ display: 'none' }}
                    icon={<AttachmentIcon />}
                  />

                  <BottomNavigationAction
                    label={t('lblGdpr')}
                    style={{ display: 'none' }}
                    icon={<AssignmentTurnedInIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblMaterialOrders')}
                    style={{ display: 'none' }}
                    icon={<ShoppingCartIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblTasks')}
                    style={{ display: 'none' }}
                    icon={<AssignmentIcon />}
                  />
                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={t('lblFeedback') + ' (' + parseInt(formData?.FeedBackCount) + ')'}
                    icon={<SettingsBackupRestoreIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblNPS')}
                    style={{ display: 'none' }}
                    icon={<ThumbsUpDownIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblSms')}
                    style={{ display: 'none' }}
                    icon={<SmsIcon />}
                  />
                  {SessionUser.TenantId === 82 || SessionUser.TenantId === 37 ? (
                    <BottomNavigationAction
                      label={t('lblValueProposition')}
                      icon={<TouchAppIcon />}
                    />
                  ) : (
                    <BottomNavigationAction
                      label={t('lblOmniChannel')}
                      icon={<TouchAppIcon />}
                    />
                  )}
                </BottomNavigation>
                <br />
                <br />
                <Divider />
                <br />
                <br />
                <BottomNavigation
                  value={TopBarValue}
                  onChange={(event, newValue) => {
                    setTopBarValue(newValue);
                    if (newValue === 0) {
                      //KAYDET
                      if (formData.ConsumerId === undefined) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblMustFieldControl')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        setRequired(true);
                        return;
                      }
                      SaveConsumer();
                    }
                    if (newValue === 1) {
                      //Yeni Müşteri
                      GetSecretNote(0);
                      setFormdata({ ...DefaultConsumerValue, CustomerTypeId: DefaultCustomerTypeId, Phones: [] });
                      setAddressIndex(0);
                      setVulnerabilitiesId(0);
                      setNewTel(countryCode);
                      sessionStorage.removeItem('SearhResult');
                      sessionStorage.removeItem('ConsumerId');
                      setRequired(false);
                    }
                    if (newValue === 2) {
                      //Müşteri Adresleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      if (formData.Addresses.filter(x => x.AddressId > 0).length > 0) {
                        setAddressPopup(true);
                      }
                    }
                    if (newValue === 3) {
                      //Müşteri WorkCaseleri
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      sessionStorage.removeItem('ConsumerId');
                      sessionStorage.setItem('ConsumerId', formData.ConsumerId);
                      handleConsumerWorkCase(1);
                      // handleRefresh();
                    }
                    if (newValue === 4) {
                      //Yeni WorkCase
                      setNewWorkCaseData(DefaultWorkCase);
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      var Data = { ...NewWorkCaseData };
                      Data.ConsumerId = formData.ConsumerId;
                      Data.ProductId = 0;
                      Data.Product = '';
                      Data.IssueId = 0;
                      Data.Issue = '';
                      Data.Retailer = '';
                      Data.RetailerId = 0;
                      Data.RightToRepairConsent = false;
                      Data.StatusId = 1;
                      Data.WarrantyTypeId = 0;
                      Data.Comment = '';
                      GetConsumerAssetsData();
                      setNewWorkCaseData(Data);
                      setNewAssetChosen(false);
                      setAssetChosen(false);
                      setNewWorkCasePopup(true);
                      setisButtonDisabled(false);
                      setIssueTypeId(1);
                    }
                    if (newValue === 5) {
                      //Assetler
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerAssets();
                    }
                    if (newValue === 6) {
                      //Müşteriye ait dosyalar
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerFileData();
                    }
                    if (newValue === 7) {
                      // GDPR
                      GetGdpr();
                    }
                    if (newValue === 8) {
                      // Tasks
                      setJobSearchPopup(true);
                    }
                    if (newValue === 9) {

                      if (SessionUser.ServiceShopId === 11740) {
                        return;
                      }
                      // Feedback
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      openFeedbackPopupX();
                    }

                    if (newValue === 10) {
                      // NPS

                      if (SessionUser.ServiceShopId === 11740) {
                        return;
                      }


                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetConsumerInformation();
                    }

                    if (newValue === 11) {

                      if (SessionUser.ServiceShopId === 11740) {
                        return;
                      }
                      // Sms
                      if (
                        formData.ConsumerId === 0 ||
                        formData.ConsumerId === undefined
                      ) {
                        setresponseMessage({
                          ErrorCode: 10,
                          ErrorDescription: t('lblCustomerWarning')
                        });
                        setUyariTip('error');
                        setUyari(true);
                        return;
                      }
                      GetManuelSmsEmailTemplate();
                      GetConsumerSmsInformation();

                    }
                    if (newValue === 12) {
                      if (SessionUser.TenantId === 82 || SessionUser.TenantId === 37) {
                        // ValueProposition
                        if (
                          formData.ConsumerId === 0 ||
                          formData.ConsumerId === undefined
                        ) {
                          setresponseMessage({
                            ErrorCode: 10,
                            ErrorDescription: t('lblCustomerWarning')
                          });
                          setUyariTip('error');
                          setUyari(true);
                          return;
                        }
                      }
                      else {
                        // OmniChannel
                        if (SessionUser.ServiceShopId === 11740) {
                          return;
                        }
                        if (
                          formData.ConsumerId === 0 ||
                          formData.ConsumerId === undefined
                        ) {
                          setresponseMessage({
                            ErrorCode: 10,
                            ErrorDescription: t('lblCustomerWarning')
                          });
                          setUyariTip('error');
                          setUyari(true);
                          return;
                        }
                      }
                    }

                  }}
                  showLabels
                >

                  <BottomNavigationAction label={t('lblSave')}
                    style={{ display: 'none' }}
                    icon={<SaveIcon />} />
                  <BottomNavigationAction
                    label={t('lblNewConsumer')}
                    style={{ display: 'none' }}
                    icon={<PersonAddIcon />}
                    onClick={() => setNpsLowScoreCount(0)}
                  />
                  <BottomNavigationAction
                    label={
                      t('lblAddress') +
                      ' (' +
                      parseInt(
                        formData.Addresses?.filter(x => x.AddressId > 0).length
                      ) +
                      ')'
                    }
                    icon={<LocationOnIcon />}
                  />
                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={
                      t('lblWorkCase') + ' (' + workCaseNumber + ')'
                    }
                    icon={<BusinessCenterIcon />}
                  />

                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={t('lblNewWorkCase')}
                    icon={<NextWeekIcon />}
                  />

                  <BottomNavigationAction
                    label={t('lblAssets') + ' (' + parseInt(formData?.AssetCount) + ')'}
                    icon={<VideogameAssetIcon />}
                  />

                  <BottomNavigationAction
                    label={t('lblFiles')}

                    icon={<AttachmentIcon />}
                  />

                  <BottomNavigationAction
                    label={t('lblGdpr')}

                    icon={<AssignmentTurnedInIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblMaterialOrders')}
                    style={{ display: 'none' }}
                    icon={<ShoppingCartIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblTasks')}
                    style={{ display: 'none' }}
                    icon={<AssignmentIcon />}
                  />
                  <BottomNavigationAction
                    style={{ display: 'none' }}
                    label={t('lblFeedback') + ' (' + parseInt(formData?.FeedBackCount) + ')'}
                    icon={<SettingsBackupRestoreIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblNPS')}
                    style={{ display: 'none' }}
                    icon={<ThumbsUpDownIcon />}
                  />
                  <BottomNavigationAction
                    label={t('lblSms')}
                    style={{ display: 'none' }}
                    icon={<SmsIcon />}
                  />
                  {SessionUser.TenantId === 82 || SessionUser.TenantId === 37 ? (
                    <BottomNavigationAction
                      label={t('lblValueProposition')}
                      icon={<TouchAppIcon />}
                    />
                  ) : (
                    <BottomNavigationAction
                      label={t('lblOmniChannel')}
                      icon={<TouchAppIcon />}
                    />
                  )}
                </BottomNavigation>
              </div>
            </SwipeableDrawer>
          </React.Fragment>
        ))}
      </Card>
      <Dialog
        open={OpenMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <ForConsumer ConsumerPhone={formData && formData?.Phones?.length > 0 ? formData?.Phones[0].Phone : ''} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ConsumerFilePopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setConsumerFilePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblFiles')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {Files.length !== 0 ? Files.map((item, index) => (
              <Grid item xs={12} key={index}>
                {item.Files.map((Fileitem, index) => (
                  <Card className={classes.cardsMax}>
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {'Work Order Id : ' + item.WorkCaseId}{' '}
                        {'Work Case Id : ' + Fileitem.WorkOrderId}
                      </Typography>
                      <Typography>
                        <Chip
                          style={{
                            color: item.StatusId === 1 ? 'green' : 'red'
                          }}
                          icon={<BusinessCenterRoundedIcon />}
                          label={item.Status + ' ' + item.Issue}
                        />
                      </Typography>
                      <List className={classes.root}>
                        <ListItem
                          onClick={event =>
                            handleFileOpen(
                              event,
                              Fileitem.Id,
                              Fileitem.FileName
                            )
                          }
                        >
                          <ListItemAvatar>
                            <Avatar>
                              <ImageIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              Fileitem.WorkOrderId + '-' + Fileitem.FileName
                            }
                            secondary={
                              Fileitem.FileDate + ' ' + Fileitem.FileType
                            }
                          />
                        </ListItem>
                      </List>
                    </CardContent>
                  </Card>
                ))
                }
              </Grid>
            ))
              :
              <Grid item xs={12} >
                <Typography gutterBottom variant="h6" component="h1" style={{ textAlign: 'center' }}>
                  {t('lblNoAttachment')}
                  <IconButton
                    edge="end"
                  >
                    <FreeBreakfastIcon />
                  </IconButton>
                </Typography>
              </Grid>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => setConsumerFilePopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <ConsentViewPopup
        open={GdprPopupNew}
        setOpen={setGdprPopupNew}
        ConsumerId={formData.ConsumerId}
      />
      <Dialog
        open={GdprPopup}
        fullWidth={false}
        maxWidth={'lg'}
        onClose={() => setGdprPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'left' }}>
          {t('lblCommunicationPreferences')}
        </DialogTitle>


        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('lblService')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Sms}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Sms: event.target.checked
                          })
                        }
                        name="Sms"
                      />
                    }
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Email}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Email: event.target.checked
                          })
                        }
                        name="Email"
                      />
                    }
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Phone}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Phone: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.SocialMedia}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            SocialMedia: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Whatsapp}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Whatsapp: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <AllInboxIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.Message}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            Message: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>

        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('lblMarketing')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        name="Sms"
                        checked={GdprData.MarketingSms}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingSms: event.target.checked
                          })
                        }
                      />
                    }
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        name="Email"
                        checked={GdprData.MarketingEmail}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingEmail: event.target.checked
                          })
                        }
                      />
                    }
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingPhone}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingPhone: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingSocialMedia}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingSocialMedia: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingWhatsapp}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingWhatsapp: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <AllInboxIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.MarketingMessage}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            MarketingMessage: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>


        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('lblPartyMarketing')}
        </DialogTitle>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid item xs={12} container>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <SmsIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdSms}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdSms: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSms')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <EmailIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdEmail}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdEmail: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblEmail')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <PhoneIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdPhone}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdPhone: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPhone')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <InstagramIcon />
                  </IconButton>
                </Grid>

                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdSocialMedia}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdSocialMedia: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblSocialMedia')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <WhatsAppIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={GdprData.ThirdWhatsapp}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdWhatsapp: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblWhatsApp')}
                  />
                </Grid>
                <Grid item xs={6} sm={6} lg={1}>
                  <IconButton>
                    <AllInboxIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6} sm={6} lg={3}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary" checked={GdprData.ThirdMessage}
                        onChange={event =>
                          setGdprData({
                            ...GdprData,
                            ThirdMessage: event.target.checked
                          })
                        }
                        name="Phone"
                      />
                    }
                    label={t('lblPost')}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>

        <Dialog
          open={AnonymyzePopup}
          fullWidth={false}
          maxWidth={'lg'}
          onClose={() => setAnonymyzePopup(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ fontWeight: 'bold', fontSize: 'large' }}>
            {t('lblAttention')}
          </DialogTitle>
          <Container maxWidth="xl" spacing={1} style={{ fontWeight: 'bold', fontSize: 'large' }}>
            <Divider />
            {t('lblAnonymyze')}
          </Container>
          <DialogActions>

            <IconButton
              color="primary"
              aria-label="save"
              onClick={() => CustomerAnonymyze()}
              component="span"
            >
              <ThumbUpIcon />
            </IconButton>

            <IconButton
              color="primary"
              onClick={() => setAnonymyzePopup(false)}
              aria-label="upload picture"
              component="span"
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>
        </Dialog>

        <DialogActions>
          <IconButton
            color="primary"
            aria-label="save"
            onClick={() => setAnonymyzePopup(true)}
            component="span"
          >
            <DeleteForeverIcon />
          </IconButton>

          <IconButton
            color="primary"
            aria-label="save"
            onClick={() => SaveGdpr()}
            component="span"
          >
            <SaveOutlinedIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => setGdprPopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={jobSearchPopup}
        fullWidth={true}
        maxWidth={'xl'}
        scroll={scroll}
        onClose={() => setJobSearchPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblTaskManagement')}
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={3} lg={3}>
              <Autocomplete
                size="small"
                fullWidth
                autoSelect
                disableClearable
                disabled={DisabledControl}
                value={tasksFilterModel?.serviceShopId || null}
                options={ServiceShopData || []}
                getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                getOptionSelected={(option, value) => option.ServiceShopId === value.ServiceShopId}
                renderInput={(params) => <TextField {...params} label={t('lblServiceShop')} variant="outlined"
                />}
                onChange={(event, value) => {

                  let e = {
                    target: {
                      name: 'serviceShopId',
                      value: value
                    }
                  };

                  handleTasksInputChange(e);

                }}
              />

            </Grid>
            <Grid item xs={12} sm={3} lg={3}>
              <Autocomplete
                size='small'
                fullWidth
                multiple
                options={StatusData || []}
                disableCloseOnSelect
                id="StatusId"
                value={tasksFilterModel?.statusId || []}
                getOptionLabel={(option) => option.FieldText}
                onChange={(event, val) => {
                  setSelectedValues(val);

                  let e = {
                    target: {
                      name: 'statusId',
                      value: val
                    }
                  }

                  handleTasksInputChange(e);
                }}
                disabled={tasksFilterModel.openCase}
                renderOption={(option, { selected }) => (
                  <li value={option.StatusId}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.FieldText}
                  </li>
                )}
                renderInput={(params) => <TextField {...params} label={t('lblStatus')} variant='outlined' />}
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDatePicker
                    color="primary"
                    disabled={tasksFilterModel.openCase}
                    inputVariant="outlined"
                    id="StartDateSearch"
                    size="small"
                    invalidDateMessage={t('hatali_tarih')}
                    maxDateMessage={t('maxDateMessage')}
                    minDateMessage={t('minDateMessage')}
                    format='dd.MM.yyyy'
                    fullWidth
                    variant="outlined"
                    value={tasksFilterModel?.startDate}
                    onChange={e => {
                      handleChangeStartDateSearch(e);

                      let event = {
                        target: {
                          name: 'startDate',
                          value: e
                        }
                      };

                      handleTasksInputChange(event);
                    }}
                    maxDate={EndDateSearch}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDatePicker
                    color="primary"
                    size="small"
                    disabled={tasksFilterModel.openCase}
                    inputVariant="outlined"
                    id="EndDateSearch"
                    invalidDateMessage={t('hatali_tarih')}
                    maxDateMessage={t('maxDateMessage')}
                    minDateMessage={t('minDateMessage')}
                    format='dd.MM.yyyy'
                    fullWidth
                    variant="outlined"
                    value={tasksFilterModel?.endDate}
                    onChange={e => {
                      handleChangeEndDateSearch(e);

                      let event = {
                        target: {
                          name: 'endDate',
                          value: e
                        }
                      };

                      handleTasksInputChange(event);
                    }}
                    minDate={StartDateSearch}
                    maxDate={new Date(new Date(StartDateSearch).getTime() + 90 * 24 * 60 * 60 * 1000)} // max 90 days
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>
            </Grid>
            <Grid item xs={12} sm={1} lg={1} align="center">
              <FormControlLabel
                control={
                  <Switch
                    color="primary"
                    checked={tasksFilterModel?.openCase}
                    onChange={event => {
                      if (event.target.checked) {
                        let statuModel = [{ StatusId: 0, FieldText: t('lblAllStatus') }];
                        setSelectedValues(statuModel)

                        let eventForStatu = {
                          target: {
                            name: 'statusId',
                            value: statuModel
                          }
                        }

                        handleTasksInputChange(eventForStatu);
                      }
                      else {
                        setSelectedValues([])
                      }

                      let eventForOpenCase = {
                        target: {
                          name: 'openCase',
                          value: event.target.checked
                        }
                      };

                      handleTasksInputChange(eventForOpenCase);
                    }}
                    name="OpenCase"
                  />
                }
                label={t('lblOpenCase')}
              />
            </Grid>
            <Grid item xs={12} sm={1} lg={1}>
              <TextField
                size="small"
                fullWidth
                type="number"
                label={t('lblOpenDay')}
                autoComplete="no"
                disabled={tasksFilterModel.openCase ? false : true}
                value={tasksFilterModel?.openDay}
                inputProps={{ minlength: min, maxLength: max }}
                id="OpenDay"
                onChange={event => {
                  setTaskOpenDay(event.target.value);

                  let e = {
                    target: {
                      name: 'openDay',
                      value: event.target.value
                    }
                  };

                  handleTasksInputChange(e);
                }}
                variant="outlined"
              ></TextField>
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <Button
                variant="contained"
                size="small"
                color="primary"
                fullWidth
                onClick={GetTasksData}
                disabled={isTaskCooldownActive}
                endIcon={<SearchIcon />}
              >
                {isTaskCooldownActive ? t('lblCooldownButton', { seconds: taskRemainingSeconds }) : t('search')}
              </Button>
              {isTaskCooldownActive && (
                <Typography variant="caption" color="textSecondary" align="center" display="block" style={{ marginTop: 4 }}>
                  {t('lblCooldownWait', { seconds: taskRemainingSeconds })}
                </Typography>
              )}
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <OmniExcelReport JsonData={TasksScreenData} ButtonType={4} />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <OmniExcelReport JsonData={detailedExcelData} ButtonType={3} />
            </Grid>
            <Grid item xs={12} sm={3} lg={3} style={{ marginLeft: 'auto', textAlign: 'right' }}>
              <TextField
                size="small"
                fullWidth
                label={t('lblemployeeSearch')}
                variant="outlined"
                value={employeeTextSearch}
                onChange={(e) => setemployeeTextSearch(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogContent dividers={scroll === 'paper'} style={{ minHeight: 500 }}>
          <DataGrid
            rows={filteredTasksData}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            loading={isGetTaskRequestSending}
            density={'compact'}
            filter={true}
            onSelectionChange={(newSelection) => {
              SetWorkOrderTaskDetail(newSelection);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setJobSearchPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={NewWorkCasePopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setNewWorkCasePopupClose()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblNewWorkCase')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={6} lg={6}>
              <Card className={classes.root}>
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} lg={12}>
                      {/* TenantId 118 için SerialNumber, diğerleri için Status */}
                      {SessionUser.IsIhpTenant ? (
                        <TextField
                          size="small"
                          fullWidth
                          label={t('lblSerialNumber')}
                          id="SerialNr"
                          value={NewWorkCaseData.SerialNr ? NewWorkCaseData.SerialNr : ''}
                          onChange={event =>
                            setNewWorkCaseData({
                              ...NewWorkCaseData,
                              SerialNr: event.target.value
                            })
                          }
                          variant="outlined"
                        />
                      ) : (
                        <TextField
                          size="small"
                          fullWidth
                          select
                          label={t('lblStatus')}
                          id="StatusId"
                          value={NewWorkCaseData ? NewWorkCaseData.StatusId : 1}
                          onChange={event =>
                            setNewWorkCaseData({
                              ...NewWorkCaseData,
                              StatusId: event.target.value
                            })
                          }
                          variant="outlined"
                        >
                          <MenuItem key={1} value={1}>
                            {t('lblNotAssigned')}
                          </MenuItem>
                          {/* <MenuItem key={2} value={2}>
                            {t('lblClose')}
                          </MenuItem> */}
                        </TextField>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Autocomplete
                        id="ProductId"
                        options={Assets}
                        size="small"
                        autoSelect
                        getOptionLabel={p =>
                          p.ProductId
                            ? p.ProductCode +
                            '-' +
                            p.Product +
                            '-' +
                            p.ProductionYear +
                            '-' +
                            p.ProductionMonth +
                            '-' +
                            p.SerialNr +
                            '-' +
                            p.Warranty +
                            '-' +
                            p.WarrantyDate +
                            '-' +
                            p.Brand
                            : ''
                        }
                        getOptionSelected={(option, value) => option === value}
                        renderOption={option => (
                          <Box display="flex" alignItems="center">
                            {option.RightToRepairConsent && (
                              <Chip
                                label="R2R"
                                size="small"
                                style={{
                                  backgroundColor: green[600],
                                  color: '#fff',
                                  fontWeight: 600,
                                  marginRight: 8
                                }}
                              />
                            )}
                            {option.ProductCode +
                              '-' +
                              option.Product +
                              '-' +
                              option.ProductionYear +
                              '-' +
                              option.ProductionMonth +
                              '-' +
                              option.SerialNr +
                              '-' +
                              option.Warranty +
                              '-' +
                              option.WarrantyDate +
                              '-' +
                              option.Brand}
                          </Box>
                        )}
                        renderInput={params => (
                          <TextField
                            {...params}
                            label={t('lblAsset')}
                            variant="outlined"
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  {NewWorkCaseData.ProductId > 0 && NewWorkCaseData.RightToRepairConsent && (
                                    <Chip
                                      label="R2R"
                                      size="small"
                                      style={{
                                        backgroundColor: green[600],
                                        color: '#fff',
                                        fontWeight: 600,
                                        marginRight: 8
                                      }}
                                    />
                                  )}
                                  {params.InputProps.startAdornment}
                                </>
                              )
                            }}
                            error={
                              NewWorkCaseData?.ProductId > 0
                                ? false
                                : RequiredWorkCase
                            }
                            required
                          />
                        )}
                        onChange={(event, value) => {
                          setNewWorkCaseAssets(value);
                        }}
                        disabled={newAssetChosen}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <ProductWorkCaseSearch
                        setProduct={setProduct}
                        value={
                          {
                            Dsc: NewWorkCaseData.Product || '',
                            Id: NewWorkCaseData.ProductId || 0
                          } || ''
                        }
                        error={
                          NewWorkCaseData?.ProductId > 0
                            ? false
                            : RequiredWorkCase
                        }
                        disabled={assetChosen}
                        searchParam={search}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <AppReasonSearch
                        setIssue={setIssue}
                        value={
                          {
                            Dsc: NewWorkCaseData.Issue || '',
                            Id: NewWorkCaseData.IssueId || 0
                          } || ''
                        }
                        searchParam={search}
                        error={
                          NewWorkCaseData?.IssueId > 0
                            ? false
                            : RequiredWorkCase
                        }
                        modelCode={modelCode}
                      />
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              <Card className={classes.root}>
                <CardContent>
                  <Grid container spacing={1}>
                    <Grid item xs={6} sm={6} lg={6}>
                      <RetailerSearch
                        setRetailer={setRetailer}
                        value={
                          {
                            Dsc: NewWorkCaseData.Retailer || '',
                            Id: NewWorkCaseData.RetailerId || 0
                          } || ''
                        }
                        searchParam={search}
                      />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3}>
                      <DistributorSearch
                        setDistributor={setDistributor}
                        value={
                          {
                            Dsc: NewWorkCaseData.Distributor || '',
                            Id: NewWorkCaseData.DistributorId || 0
                          } || ''
                        }
                        searchParam={search}
                      />
                    </Grid>
                    <Grid item xs={3} sm={3} lg={3}>
                      <CaseOwnerSearch
                        sessionUser={(SessionUser?.Role === 3 || SessionUser?.Role === 4 || SessionUser?.Role === 5)}
                        setCaseOwner={setCaseOwner}
                        searchParam={searchCaseOwner}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        id="OnSiteOperation"
                        label={t('lblOnSiteOperation')}
                        value={
                          NewWorkCaseData ? NewWorkCaseData.OnSiteOperation : ''
                        }
                        onChange={event =>
                          setNewWorkCaseData({
                            ...NewWorkCaseData,
                            OnSiteOperation: event.target.value
                          })
                        }
                        variant="outlined"
                      >
                        {PlaceData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={6}>
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={NewWorkCaseData.PotentialLiabiltiy === 1 || 0}
                            onChange={handlePotentialLiabiltiy}
                            name="UrgentCustomer"
                          />
                        }
                        label={t('lblPotential')}
                      />
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        id="WarrantyTypeId"
                        required
                        label={t('lblWarranty')}
                        error={
                          NewWorkCaseData?.WarrantyTypeId > 0
                            ? false
                            : RequiredWorkCase
                        }
                        value={
                          NewWorkCaseData.WarrantyTypeId
                        }
                        onChange={event => {
                          handleChangeWarrantyTypeId(event);
                        }}
                        variant="outlined"
                      >
                        {WarrantyData.map(p => {
                          return (
                            <MenuItem key={p.WarrantyId} value={p.WarrantyId}>
                              {p.FieldText}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                    <Grid item xs={6} sm={6} lg={6}>
                      {/* TenantId 118 için Status, diğerleri için SerialNumber */}
                      {SessionUser.IsIhpTenant ? (
                        <TextField
                          size="small"
                          fullWidth
                          select
                          label={t('lblStatus')}
                          id="StatusId"
                          value={NewWorkCaseData ? NewWorkCaseData.StatusId : 1}
                          onChange={event =>
                            setNewWorkCaseData({
                              ...NewWorkCaseData,
                              StatusId: event.target.value
                            })
                          }
                          variant="outlined"
                        >
                          <MenuItem key={1} value={1}>
                            {t('lblNotAssigned')}
                          </MenuItem>
                        </TextField>
                      ) : (
                        <TextField
                          size="small"
                          fullWidth
                          label={t('lblSerialNumber')}
                          id="SerialNr"
                          value={NewWorkCaseData.SerialNr ? NewWorkCaseData.SerialNr : ''}
                          onChange={event =>
                            setNewWorkCaseData({
                              ...NewWorkCaseData,
                              SerialNr: event.target.value
                            })
                          }
                          variant="outlined"
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={localeMap[locale]}
                        >
                          <KeyboardDatePicker
                            color="primary"
                            fullWidth
                            disableFuture={true}
                            size="small"
                            disabled={warrantyDateDisable || assetChosen}
                            inputVariant="outlined"
                            id="WarrantyDate"
                            label={t('lblWarrantyDate')}
                            invalidDateMessage={t('hatali_tarih')}
                            maxDateMessage={t('maxDateMessage')}
                            minDateMessage={t('minDateMessage')}
                            format={'dd.MM.yyyy'}
                            variant="outlined"
                            value={
                              NewWorkCaseData
                                ? NewWorkCaseData.WarrantyDate
                                : ''
                            }
                            onChange={e => SetWarrantyDate(e)}
                            error={RequiredWorkCase && isWarrantyDateRequired() && !NewWorkCaseData.WarrantyDate}
                            helperText={
                              RequiredWorkCase && isWarrantyDateRequired() && !NewWorkCaseData.WarrantyDate
                                ? t('lblMustFieldControl')
                                : ''
                            }
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6}>
                      <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={localeMap[locale]}
                        >
                          <KeyboardDateTimePicker
                            color="primary"
                            fullWidth
                            size="small"
                            ampm={false}
                            disablePast
                            inputVariant="outlined"
                            id="WarrantyDate"
                            label={t('lblPrefferedDate')}
                            invalidDateMessage={t('hatali_tarih')}
                            format={'dd.MM.yyyy HH.mm'}
                            variant="outlined"
                            value={
                              NewWorkCaseData
                                ? NewWorkCaseData.AppointmentDate
                                : ''
                            }
                            onChange={e => setAppointmentData(e)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                size="small"
                label={t('lblNote') + ' *'}
                name="Comment"
                multiline
                rows={6}
                fullWidth
                error={
                  NewWorkCaseData?.Comment !== ''
                    ? false
                    : RequiredWorkCaseComment
                }
                value={NewWorkCaseData.Comment ? NewWorkCaseData.Comment : ''}
                onChange={event =>
                  setNewWorkCaseData({
                    ...NewWorkCaseData,
                    Comment: event.target.value
                  })
                }
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={() => SaveWorkCase()}
            disabled={isButtonDisabled}
            aria-label="save"
            component="span"
          >
            <SaveOutlinedIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={() => setNewWorkCasePopupClose()}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={AssetPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setAssetPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblAssets')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {Assets.map((row, index) => (
              <Grid item xs={12} sm={4} lg={4} key={index}>
                <Card className={classes.cardsAssetMax}>
                  <CardContent>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <img
                        alt="ProductGroup"
                        src={'/images/' + row.MainHierarchyId + '.png'}
                      />
                    </Box>
                  </CardContent>
                  <CardContent>
                    {/* LegalEntity bilgisini en üste ekle */}
                    {LegalEntityTenantIds.includes(SessionUser.TenantId) && row.LegalEntity && (
                      <Typography
                        variant="body1"
                        style={{
                          color: getLegalEntityColor(row.LegalEntity),
                          fontWeight: 'bold',
                          marginBottom: '10px',
                          textAlign: 'center'
                        }}
                      >
                        {highlightBeko(row.LegalEntity)}
                      </Typography>
                    )}
                    {row.RightToRepairEligible && (
                      <FormControlLabel
                        control={
                          <Switch
                            color="primary"
                            checked={Boolean(row.RightToRepairConsent)}
                            disabled={Boolean(row.RightToRepairConsent) || rightToRepairLoadingAsset === row}
                            onChange={() => ConfirmAssetRightToRepairConsent(row)}
                          />
                        }
                        label={t('lblRightToRepair', 'Right to Repair')}
                      />
                    )}
                    <DisplayField
                      label={t('lblProduct')}
                      value={
                        row.ProductCode + ' ' + row.Product + ' ' + row.Brand
                      }
                    />
                    <DisplayField
                      label={
                        t('lblProductionYear') +
                        '-' +
                        t('lblProductionMonth') +
                        '-' +
                        t('lblSerialNr')
                      }
                      value={
                        row.ProductionYear +
                        '-' +
                        row.ProductionMonth +
                        '-' +
                        row.SerialNr
                      }
                    />
                    <DisplayField
                      label={t('lblWarrany')}
                      value={row.Warranty + ' ' + row.WarrantyDate}
                    />
                    <DisplayField
                      label={t('lblRetailer')}
                      value={row.Dealer}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAssetPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={Boolean(rightToRepairConfirmationAsset)}
        onClose={() => setRightToRepairConfirmationAsset(null)}
        className={classes.rightToRepairConfirmModal}
        PaperProps={{ className: classes.rightToRepairConfirmPaper }}
        aria-labelledby="right-to-repair-confirmation-title"
        aria-describedby="right-to-repair-confirmation-message"
      >
        <DialogTitle disableTypography>
          <Typography id="right-to-repair-confirmation-title" className={classes.rightToRepairConfirmTitle}>
            {t('lblRightToRepairConsentTitle', 'Right to Repair Consent')}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="right-to-repair-confirmation-message" className={classes.rightToRepairConfirmMessage}>
            {t(
              'msgRightToRepairConsentIrreversible',
              'This action is irreversible. Once Right to Repair consent is given, it cannot be revoked.'
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button size="small" onClick={() => setRightToRepairConfirmationAsset(null)}>
            {t('Hayir', 'Cancel')}
          </Button>
          <Button
            size="small"
            color="primary"
            variant="contained"
            disableElevation
            onClick={() => {
              const asset = rightToRepairConfirmationAsset;
              setRightToRepairConfirmationAsset(null);
              SetAssetRightToRepairConsent(asset);
            }}
          >
            {t('Evet', 'Confirm')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={WorkCasePopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setWorkCasePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblWorkCase')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={12} sm={8} lg={8}>
              <SearchBar
                value={searched}
                onChange={searchVal => requestSearch(searchVal)}
                onCancelSearch={() => cancelSearch()}
                placeholder="Search by WorkCase ID, Status, Legal Entity..."
                style={{ margin: '0 auto', maxWidth: '100%', maxHeight: 37 }}
              />
            </Grid>
            <Grid item xs={12} sm={4} lg={4}>
              <FormControl fullWidth size="small" variant="outlined">
                <InputLabel id="legal-entity-select-label">Legal Entity</InputLabel>
                <Select
                  labelId="legal-entity-select-label"
                  id="legal-entity-select"
                  value={legalEntityFilter}
                  onChange={handleLegalEntityFilterChange}
                  label="Legal Entity"
                >
                  {LegalEntityTenantIds.includes(SessionUser.TenantId) && legalEntityOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {WorkCaseData.map((item, index) => (
              <Grid item xs={12} sm={3} lg={3} key={index}>
                <Card className={classes.cardsMax}>
                  <CardActionArea onClick={() => GetWorkCaseDetailOrder(item)}>
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {item.WorkCaseId} -{' '}
                        <Chip
                          style={{
                            color: (item.StatusId === 1 ? 'orange' : (item.StatusId === 2 ? 'black' : (item.StatusId === 3 ? 'green' : (item.StatusId === 4 ? 'red' : 'purple'))))
                          }}
                          icon={<BusinessCenterRoundedIcon />}
                          label={
                            item.Status + ' (' + item?.WorkOrders?.length + ')'
                          }
                        />
                      </Typography>
                      {/* LegalEntity bilgisini göster */}
                      {LegalEntityTenantIds.includes(SessionUser.TenantId) && item.LegalEntity && (
                        <Typography
                          variant="body2"
                          style={{
                            color: getLegalEntityColor(item.LegalEntity),
                            fontWeight: 'bold',
                            marginBottom: '8px'
                          }}
                        >
                          {highlightBeko(item.LegalEntity)}
                        </Typography>
                      )}
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {item.CallDate === undefined
                          ? ''
                          : Moment(item.CallDate).format('DD/MM/YYYY HH:mm') +
                          ' ' +
                          item.WarrantyType}
                        <br />
                        {item.Issue}
                        <br />
                        {item.ProductCode + ' ' + item.Product}
                        <br />
                        {item.Barcode ? t('Barcode') + ' : ' + item.Barcode : t('Barcode') + ' : '}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="small"
                      onClick={() => GetWorkCaseDetailOrder(item)}
                    >
                      {t('lblDetail')}
                    </Button>
                  </CardActions>
                  <br />
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setWorkCasePopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={WorkOrderPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setWorkOrderPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblWorkOrder')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {WorkOrderData.length !== 0 ? WorkOrderData.map((item, index) => (
              <Grid item xs={12} sm={3} lg={3} key={index}>
                <Card className={classes.cardsMax}>
                  <CardActionArea
                    onClick={event => SetWorkOrderDetail(event, item)}
                  >
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {item.WorkOrderId} -{' '}
                        <Chip
                          style={{
                            color: (item.StatusColor === 1 ? 'orange' :
                              (item.StatusColor === 2 ? 'black' :
                                (item.StatusColor === 3 || item.StatusColor === 5 ? 'green' :
                                  (item.StatusColor === 4 ? 'red' :
                                    'purple'))))
                          }}
                          icon={<NextWeekRoundedIcon />}
                          label={item.WorkOrderStatus}
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {item.WarrantyType}
                        <br />
                        {item.WorkOrderIssue}
                        <br />
                        {item.OpenDate === undefined
                          ? ''
                          : `${t('lblOpenDate')}: ${Moment(item.OpenDate).format('DD/MM/YYYY HH:mm')}`}
                        <br />
                        {`${t('lblServiceShop')}: ${item.ServiceShop}`}
                        <br />
                        {`${t('lblEmployee')}: ${item.Employee}`}
                        <br />
                        {item.AppointmentDate === undefined
                          ? ''
                          : `${t('lblAppointmentDate')}: ${Moment(item.AppointmentDate).format('DD/MM/YYYY HH:mm')} - ${Moment(item.AppointmentEndDate).format('HH:mm')}`}
                        <br />
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                  <CardActions>
                    <Button
                      size="small"
                      onClick={event => SetWorkOrderDetail(event, item)}
                    >
                      {t('lblDetail')}
                    </Button>
                  </CardActions>
                  <br />
                </Card>
              </Grid>
            ))
              : <Typography variant="h6" component="h2" gutterBottom>{t('lblDiffrentServiceWorkOrder')}</Typography>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setWorkCasePopup(true);
              setWorkOrderPopup(false);
            }}
            color="primary"
          >
            {t('lblBack')}
          </Button>
          <Button onClick={() => setWorkOrderPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={AddressPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setAddressPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblAddress')}</DialogTitle>
        <DialogContent>
          <Grid container spacing={1}>
            {formData.Addresses.map((row, index) => (
              <Grid item xs={12} sm={4} lg={4} key={index}>
                <Card className={classes.cardArddress}>
                  <CardHeader
                    action={
                      <div>
                        <IconButton aria-label="settings">
                          <MoreVertIcon
                            onClick={event =>
                              setAddressPopupEdit(event, row, index)
                            }
                          />
                        </IconButton>
                        <IconButton aria-label="delete">
                          <DeleteForeverOutlinedIcon
                            style={{ color: 'red' }}
                            onClick={event => DeleteAddress(row.AddressId)}
                          ></DeleteForeverOutlinedIcon>
                        </IconButton>
                      </div>
                    }
                    title={row.AddressType}
                    subheader={getAddressHeader(row)}
                  />
                  <CardContent>
                    <Typography variant="caption" gutterBottom={true}>
                      {SessionUser.TenantId != 71 ? t('lblAddress') + "/" + t('lblStreet') + "/" + t('lblApartment') + "/" + t('lblDoorNr') : t('lblAddress') + "/" + t('lblStreet') + "/" + t('lblDoorNr')}
                    </Typography>
                    <Typography variant="h6">
                      {row.AddressItem +
                        ' ' +
                        row.Street +
                        ' ' +
                        row.Apartment +
                        ' ' +
                        row.DoorNr}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {SessionUser.TenantId != 71 ? t('lblDistrict') + "/" + t('lblNeighborhood') : null}
                    </Typography>
                    <Typography variant="h6">
                      {row.District + ' ' + row.Neighborhood}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {SessionUser.TenantId != 71 ? t('lblRegion') + "/" + t('lblCity') : t('lblCity')}
                    </Typography>
                    <Typography variant="h6">
                      {row.Region + ' ' + row.City}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {t('lblPostCode')}
                    </Typography>
                    <Typography variant="h6">
                      {row.PostCode}
                    </Typography>
                    <Typography variant="caption" gutterBottom={true}>
                      {t('lblState') + "/" + t('lblCountry')}
                    </Typography>
                    <Typography variant="h6">
                      {row.State + ' ' + row.Country}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddressPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ConfirmTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {ConfirmDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary">{t('Evet')}</Button>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openChooseDate}
        onClose={() => setopenChooseDate(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{ConfirmTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BaslangiçTarihi"
                  label={t('BaslangicTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  maxDateMessage={t('maxDateMessage')}
                  minDateMessage={t('minDateMessage')}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  value={StartDate}
                  onChange={e => StartDatehandleChange(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                locale={localeMap[locale]}
              >
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BitisTarihi"
                  label={t('BitisTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  maxDateMessage={t('maxDateMessage')}
                  minDateMessage={t('minDateMessage')}
                  format={'dd.MM.yyyy'}
                  variant="outlined"
                  value={EndDate}
                  onChange={e => EndDatehandleChange(e)}
                  KeyboardButtonProps={{
                    'aria-label': 'change date'
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={e => handleRefreshDate(e)} color="primary">
            {t('Ok')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={GoogleAddressSearchPopup}
        onClose={() => setGoogleAddressSearchPopup(false)}
        fullWidth={true}
        maxWidth={'lg'}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {SessionUser.TenantCode == "gb" ? t('lblSearch') : t('lblGoogleMapAddressSearch')}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={10} sm={10} lg={10}>
              <TextField
                size="small"
                id="GoogleSearch"
                autoComplete="no"
                value={addressGoogleSearch}
                onChange={event => setaddressGoogleSearch(event.target.value)}
                fullWidth
                label={t('lblAddress')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={2} sm={2} lg={2} style={{ zIndex: 100 }}>
              {SessionUser.TenantCode == "gb" ?

                <SplitSearchButton
                  options={['Search', 'Google']}
                  selectedSearchEngineIndex={SessionUser.TenantCode == "gb" ? 0 : 1}
                  handleSearchEngineClick={handleSearchEngineClick}
                ></SplitSearchButton>
                :
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => SearchGoogleAddress()}
                  endIcon={<FcGoogle />}
                >
                  {t('Google') + ' ' + t('search')}
                </Button>}

            </Grid>
          </Grid>
        </DialogContent>
        <DialogContent dividers={scroll === 'paper'}>
          <Backdrop className={classes.backdrop} open={loading || loading2}>
            <CircularProgress color="inherit" />
          </Backdrop>
          {GoogleAddressSearchResult?.results?.length > 0 && (
            <TableContainer style={{ maxHeight: 600, minHeight: 600 }}>
              <Table size="small" stickyHeader aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{t('lblAdd')}</TableCell>
                    <TableCell align="left">{t('lblAddress')}</TableCell>
                    <TableCell align="left">{t('lblLatitude')}</TableCell>
                    <TableCell align="left">{t('lblLongitude')}</TableCell>
                    <TableCell align="left">{t('lblFind')}</TableCell>
                    <TableCell align="left">{t('lblType')}</TableCell>
                    <TableCell align="left">{t('lblIcon')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {GoogleAddressSearchResult?.results?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        <IconButton
                          onClick={() =>
                            AddAddress(
                              item.formatted_address,
                              item?.geometry?.location?.lat,
                              item?.geometry?.location?.lng,
                              item.place_id
                            )
                          }
                        >
                          <AddBoxIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">{item.formatted_address}</TableCell>
                      <TableCell align="left">
                        {item?.geometry?.location?.lat}
                      </TableCell>
                      <TableCell align="left">
                        {item?.geometry?.location?.lng}
                      </TableCell>
                      <TableCell align="left">
                        <IconButton
                          onClick={event =>
                            handleClickMap(
                              event,
                              item?.geometry?.location?.lat,
                              item?.geometry?.location?.lng
                            )
                          }
                        >
                          <LocationOnIcon style={{ color: 'red' }} />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">
                        {item?.types?.map((itemType, index) => (
                          <Chip
                            key={index}
                            icon={<MdPlace />}
                            label={itemType}
                            clickable
                            color="primary"
                            variant="outlined"
                          />
                        ))}
                      </TableCell>
                      <TableCell align="left">
                        <img
                          src={item.icon}
                          style={{ width: 22, height: 22 }}
                          name={item.name}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

          {ExperianAddressSearchResult?.length > 0 && (
            <TableContainer style={{ maxHeight: 600, minHeight: 600 }}>
              <Table size="small" stickyHeader aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">{t('lblAdd')}</TableCell>
                    <TableCell align="left">{t('lblAddress')}</TableCell>
                    <TableCell align="left">{t('lblPostCode')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {ExperianAddressSearchResult?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        <IconButton
                          onClick={() =>
                            AddExperianAddressWithGoogleResponse(
                              item.PartialAddress,
                              item.PostCode
                            )
                          }
                        >
                          <AddBoxIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell align="left">{item.PartialAddress}</TableCell>
                      <TableCell align="left">{item.PostCode}</TableCell>

                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}

        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setGoogleAddressSearchPopup(false)}
            color="primary"
          >
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={addressSearchPopup}
        onClose={() => setAddressSearchPopup(false)}
        maxWidth={'xl'}
        scroll={scroll}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Address Search</DialogTitle>
        <Divider />
        <DialogContent dividers={scroll === 'paper'}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={1} lg={1}></Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="Region"
                autoComplete="no"
                value={addressSearch.Region}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblRegion')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="City"
                autoComplete="no"
                value={addressSearch.City}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblCity')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="District"
                autoComplete="no"
                value={addressSearch.District}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblDistrict')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <TextField
                size="small"
                id="PostCode"
                autoComplete="no"
                value={addressSearch.PostCode}
                onChange={event => handleChangeAddressSearch(event)}
                fullWidth
                label={t('lblPostCode')}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={2} lg={2}>
              <Button
                variant="contained"
                color="primary"
                fullWidth
                onClick={SearchAddress}
                endIcon={<SearchIcon />}
              >
                {t('search')}
              </Button>
            </Grid>
            <Grid item xs={12} sm={1} lg={1}></Grid>
          </Grid>
        </DialogContent>
        <DialogContent dividers={scroll === 'paper'} style={{ minHeight: 500 }}>
          <DataGrid
            rows={addressSearchResult}
            columns={addressSearchResultColumns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            loading={loading2}
            density={'compact'}
            filter={false}
            autoPageSize={true}
            autoHeight={true}
            onSelectionChange={newSelection => {
              SetAdressWithSearchedResult(newSelection.rowIds[0]);
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAddressSearchPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openFeedbackPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setOpenFeedbackPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblFeedback')}</DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid container spacing={1}>
            {!feedbackDataList ? (
              <div />
            ) : (
              feedbackDataList.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index}>
                  <Card className={classes.cardsMaxF}>
                    <CardActionArea onClick={() => {
                      GetWorkCaseFeedback(item)
                      GetFeedbackDesc(item)
                    }} >
                      <CardContent className={classes.cardsContentMaxF}>
                        {/* LegalEntity bilgisini en üste ekle */}
                        {LegalEntityTenantIds.includes(SessionUser.TenantId) && item.LegalEntity && (
                          <Typography
                            variant="body1"
                            style={{
                              color: getLegalEntityColor(item.LegalEntity),
                              fontWeight: 'bold',
                              marginBottom: '10px',
                              textAlign: 'center'
                            }}
                          >
                            {highlightBeko(item.LegalEntity)}
                          </Typography>
                        )}
                        <Typography gutterBottom variant="h6" component="h1">
                          {item.WorkCaseId} -{' '}
                          <Chip
                            style={{
                              color: (item.StatusId === 1 ? 'orange' : (item.StatusId === 2 ? 'black' : (item.StatusId === 3 ? 'green' : (item.StatusId === 4 ? 'red' : 'purple'))))
                            }}
                            icon={<SettingsBackupRestoreIcon />}
                            label={item.Status}
                          />
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                          <br />
                          {t('lblOpenDate') + ': ' +
                            moment(item.OpenDate).format('DD.MM.YYYY  HH:mm')}
                          <br />
                          {t('lblCreateUser') + ': ' + item.CreateUser}
                          <br />
                          {item.FeedbackDescription
                            ? t('lblFeedbackDesc') + ': ' +
                            item.FeedbackDescription
                            : t('lblFeedbackDesc') + ': '}
                          <br />
                          {t('lblIssueType') + ': ' + item.IssueName}
                          <br />
                          {item.UpdateUser ? t('lblUpdateUser') + ': ' + item.UpdateUser : t('lblUpdateUser') + ': '}
                          <br />
                          {item.UpdateDate ? t('lblUpdateDate') + ': ' + moment(item.UpdateDate).format('DD.MM.YYYY  HH:mm') : t('lblUpdateDate') + ': '}
                          <br />
                          {t('lblNote') + ': ' + item.Comment}
                          < br />
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      {/* detay butonu */}
                      <Button
                        size="small"
                        onClick={() => {
                          GetWorkCaseFeedback(item)
                          GetFeedbackDesc(item)
                        }}
                      >
                        {t('lblDetail')}
                      </Button>
                      <IconButton
                        size="small"
                        onClick={() => SetOpenSinglePage(item)}
                        style={{
                          color: ('#white'),

                        }}
                      >
                        <EditIcon />
                      </IconButton>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
            {!npsLowScoreDataList ? (
              <div />
            ) : (
              npsLowScoreDataList.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index}>
                  <Card className={classes.cardsMaxF}>
                    <CardActionArea onClick={() => {
                      //GetWorkCaseFeedback(item)
                      //GetFeedbackDesc(item)
                    }} >
                      <CardContent className={classes.cardsContentMaxF}>
                        <Typography gutterBottom variant="h6" component="h1">
                          {item.WorkCaseId} -{' '}
                          <Chip
                            style={{
                              color: ('orange')
                            }}
                            icon={<SettingsBackupRestoreIcon />}
                            label={t('lblNotAssigned')}
                          />
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          component="p"
                        >
                          <br />
                          {t('lblOpenDate') + ': ' +
                            moment(item.OpenDate).format('DD.MM.YYYY  HH:mm')}
                          <br />
                          {t('lblReplyDate') + ': ' +
                            moment(item.ReplyDate).format('DD.MM.YYYY  HH:mm')}
                          <br />
                          {t('lblCreateUser') + ': ' + item.Creater}
                          <br />
                          {t('lblType') + ': ' + item.Type}
                          <br />
                          {t('lblFeedback') + ': ' + item.WorkOrderId}
                          <br />
                          {t('lblScala') + ': ' + item.Scala}
                          <br />
                          {t('lblFeedbackDescription') + ': ' + item.FeedbackDescription}
                          <br />
                          {t('lblIssueType') + ': ' + item.IssueType}
                          <br />
                          {t('lblUpdateUser')}
                          <br />
                          {t('lblUpdateDate')}
                          <br />
                          {t('lblNote') + ': ' + item.Comment}
                          < br />
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Button
                        size="small"
                        onClick={() => {
                          GetWorkCaseFeedback(item)
                          GetFeedbackDesc(item)
                        }}
                      >
                        {t('lblDetail')}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFeedbackPopup(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openFeedbackDetailPopUp}
        fullWidth={true}
        maxWidth={'sm'}
        onClose={() => setOpenFeedbackDetailPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }} >{t('Feedback History')} </DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid item xs={12} sm={12} lg={12}>
            {/* <SearchBar
                inputSizeSmall
                value={searched}
                onChange={searchVal => requestSearch(searchVal)}
                onCancelSearch={() => cancelSearch()}
                style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
              /> */}
          </Grid>
          <CardHeader title={`${t('lblWorkCaseID')}: ${feedback[0]?.WorkCaseId || feedbackList[0]?.WorkCaseId}`} />
          <Divider />
          <Card>
            <List className={classes.root}>
              {feedback?.map((row, index) => (
                <>
                  <ListItem key={row.index} alignItems="flex-start">
                    <ListItemText
                      primary={row.Owner}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {row.Status + ' — ' + row.Reply}
                          </Typography>
                          {' — ' + row.CreateDate}
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider variant="middle" component="li" />
                </>
              ))}
            </List>
            <CardContent>
              <Typography gutterBottom variant="h6" component="h1">
                {feedbackList[0]?.Owner}
              </Typography>
              <Typography
                variant="body2"
                color="textSecondary"
                component="p"
              >
                {feedbackList[0]?.FeedbackDescription + ' — ' + feedbackList[0]?.OpenDate}
              </Typography>
              <Button size="small" onClick={event => SetWorkOrderDetail(event, feedbackList[0])}>
                {t('lblDetail')}
              </Button>
            </CardContent>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenFeedbackDetailPopup(false);
            setOpenFeedbackPopup(true);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={SmsInformationPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setSmsInformationPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"
          style={{
            textAlign: 'left'
          }}
        >{t('lblSms')}</DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid container spacing={1}
            direction="row"
            justifyContent="center"
            alignItems="center">
            <Grid item xs={4} sm={4} lg={4}>
              {/* search olayı */}
              <SearchBar
                value={searched}
                onChange={searchVal => requestSmsSearch(searchVal)}
                onCancelSearch={() => cancelSmsSearch()}
                style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
              />
            </Grid>
            <Grid item xs={4} sm={4} lg={4}>
              {/* sms header */}
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{t('lblSmsHeader')}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={smsData}
                  label="Header"
                  onChange={(event) => {
                    setSmsData(event.target.value)
                  }
                  }
                >
                  {ManuelSmsData.map(p => {
                    return (
                      <MenuItem key={p.Id} value={p.Id}>
                        {p.Header}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={1} sm={1} lg={1} />
            <Grid item xs={2} sm={2} lg={2}>
              {/* telefon */}
              {formData?.Phones?.filter(x => x.PhoneId != 0).map((item) => (
                <FormControl component="fieldset" >
                  <FormGroup aria-label="position" row>
                    <FormControlLabel value="start" control={<PhoneIcon color='secondary' />} />
                    <FormControlLabel value="end" control={<Checkbox onChange={() => selectPhone(item)} />} label={'+' + item.Phone} labelPlacement="end" />
                  </FormGroup>
                </FormControl>
              ))}
            </Grid>
            <Grid item xs={1} sm={1} lg={1}>
              <DialogActions>
                <Button onClick={() => {
                  setSmsInformationPopup(false);
                  ConfirmSendSMS();
                }} color="primary">
                  {t('lblSend')}
                </Button>
              </DialogActions>
            </Grid>
            {!SmsInformationData ? (
              <Grid item xs={12} >

                <Typography gutterBottom variant="h6" component="h1" style={{ textAlign: 'center' }}>
                  {t('No Sms')}
                  {/* {t('lblNoSms')} */}
                  <IconButton
                    edge="end"
                  >
                    <FreeBreakfastIcon />
                  </IconButton>
                </Typography>

              </Grid>
            ) : (
              SmsInformationData.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index} >
                  <Card className={classes.cardsMaxF}>
                    <CardActionArea onClick={() => {

                    }} >

                      <CardContent >
                        <Typography gutterBottom variant="h6" component="h1">
                          <Chip
                            style={{
                              color: (item.SentDate ? 'green' : 'orange')//sentdate
                            }}
                            icon={<PermPhoneMsgIcon />}
                            label={moment(item.QDate).format('DD.MM.YYYY  HH:mm')}
                          />
                        </Typography>
                        <Typography
                          variant="body2"
                          color="primary"
                          component="p"
                        >


                          <br />
                          {item.SentDate ? t('lblSentDate') + ': ' + moment(item.SentDate).format('DD.MM.YYYY HH:mm') : t('lblSentDate') + ': ' + t('lblNotSend')}
                          <br />
                          {t('lblWorkOrderId') + ': ' + item.WorkOrderId}
                          <br />
                          {t('lblPhone') + ': ' + item.SendingAddress}
                          <br />
                          {t('lblServiceShopId') + item.ServiceShop}
                          <br />
                          {item.SendingMessage.length > 100 ? t('lblDetail') + ': ' + item.SendingMessage.substr(0, 100) + ' ...' : t('lblDetail') + ': ' + item.SendingMessage}
                          <br />
                          {/* {item.NpsScore ? t('lblScala') + ': ' + item.NpsScore : t('lblScala') + ': 0'}
                          <br />
                          SendingMessage limit
                          */}
                          <br />
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    {/* eklenecek yer */}
                    <CardActions>
                      {/* detay butonu */}
                      <Button
                        size="small"
                        onClick={() => {



                          GetConsumerSmsDetail(item);




                        }}








                      >
                        {t('lblDetail')}
                      </Button>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setSmsInformationPopup(false)
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Sms detail popup */}
      <Dialog
        open={openSmsDetailPopUp}
        fullWidth={true}
        maxWidth={'sm'}
        onClose={() => setOpenSmsDetailPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }} >{t('Sms Detail')} </DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid item xs={12} sm={12} lg={12}>

          </Grid>

          <CardHeader title={`${t('lblWorkOrderId')}: ${SmsDetailData[0]?.WorkOrderId}`} />
          <Divider />
          <Card>

            {!SmsDetailData ? (
              <Grid item xs={12} >

                <Typography gutterBottom variant="h6" component="h1" style={{ textAlign: 'center' }}>
                  {t('lblNoSms')}
                  <IconButton
                    edge="end"
                  >
                    <FreeBreakfastIcon />
                  </IconButton>
                </Typography>

              </Grid>
            ) : (
              SmsDetailData.map((item, index) => (
                <Grid item xs={12} sm={12} lg={12} key={index} >
                  <Card className={classes.cardsMaxF}>
                    <CardActionArea onClick={() => {

                    }} >

                      <CardContent >
                        <Typography gutterBottom variant="h6" component="h1">
                          <Chip
                            style={{
                              color: (item.SentDate ? 'green' : 'orange')//sentdate
                            }}
                            icon={<PermPhoneMsgIcon />}
                            label={moment(item.QDate).format('DD.MM.YYYY  HH:mm')}
                          />
                        </Typography>
                        <Typography
                          variant="body2"
                          color="primary"
                          component="p"
                        >

                          <br />
                          {item.SentDate ? t('lblSentDate') + ': ' + moment(item.SentDate).format('DD.MM.YYYY HH:mm') : t('lblSentDate') + ': ' + t('lblNotSend')}
                          <br />
                          {t('lblWorkOrderId') + ': ' + item.WorkOrderId}
                          <br />
                          {t('lblPhone') + ': ' + item.SendingAddress}
                          <br />
                          {t('lblServiceShopId') + item.ServiceShop}
                          <br />
                          {t('lblDetail') + ': ' + item.SendingMessage}
                          <br />
                          {/* {item.NpsScore ? t('lblScala') + ': ' + item.NpsScore : t('lblScala') + ': 0'}
                          <br />
                          SendingMessage limit
                          */}

                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    {/* eklenecek yer */}



                  </Card>
                </Grid>
              ))
            )}

          </Card>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setOpenSmsDetailPopup(false);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={singlePopUp}
        fullWidth
        maxWidth="sm"
        onClose={() => closeSinglePopUp()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ textAlign: 'center' }}
        >
          {' '}
          {InformationData[0]?.ContactName}
        </DialogTitle>
        <Container maxWidth="sm" spacing={1}>
          <Divider />
          <Card>
            <CardHeader title={`${t('lblWorkCaseId')}: ${singleWorkOrderId}`} />
            <Divider />

            <List className={classes.root}>
              {workCaseFeedBacks.map((row, index) => (
                <>
                  <ListItem key={row.index} alignItems="flex-start">
                    <ListItemText
                      primary={row.Owner}
                      secondary={
                        <React.Fragment>
                          <Typography
                            component="span"
                            variant="body2"
                            className={classes.inline}
                            color="textPrimary"
                          >
                            {row.Status + ' — ' + row.Reply}
                          </Typography>
                          {' — ' + row.CreateDate}
                        </React.Fragment>
                      }
                    />
                  </ListItem>
                  <Divider variant="middle" component="li" />
                </>
              ))}


            </List>

            <CardContent className={classes.cardscontent}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={8} lg={8}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    disableClearable
                    value={changeStatus || 0}
                    options={caseStatusList}
                    getOptionLabel={(option) => (option.FieldText ? option.FieldText : '')}
                    getOptionSelected={(option, value) => option.StatusId === value.StatusId}
                    renderInput={(params) => <TextField {...params} label={t('lblStatus')}
                      error={changeStatus?.FieldText ? false : Required} variant="outlined" />}
                    onChange={(event, value) => {
                      setChangeStatus(value);
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={4} lg={4}>
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={PotentialLiabiltiy === true || false}
                        onChange={event => setPotentialLiabiltiy(event.target.checked)}
                        name="PotentialLiabiltiy"
                      />
                    }
                    label={t('lblPotential')}
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TextField
                    size="small"
                    id="desc"
                    autoComplete="no"
                    multiline
                    error={rejectDescription?.length > 0 ? false : Required}
                    rows={10}
                    value={rejectDescription}
                    onChange={(event) => setRejectDescription(
                      event.target.value
                    )}
                    fullWidth
                    label={t('lblDescription')}
                    variant="outlined"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
          <Divider />
        </Container>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => SaveIssue([singleWorkOrderId])}
            aria-label="save"
            component="span"
            variant="contained"
            endIcon={<SaveIcon />}
          >
            {' '}
            {t('lblSave')}
          </Button>
          <Button
            color="primary"
            onClick={() => setSinglePopUp(false)}
            aria-label="close"
            component="span"
            variant="contained"
            endIcon={<CloseIcon />}
          >
            {' '}
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={InformationPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInformationPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"
          style={{
            textAlign: 'left'
          }}
        >{t('lblNPS')}</DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid container spacing={1}
            direction="row"
            justifyContent="center"
            alignItems="center">
            {!InformationData ? (
              <Grid item xs={12} >
                <Typography gutterBottom variant="h6" component="h1" style={{ textAlign: 'center' }}>
                  {t('lblNoNps')}
                  <IconButton
                    edge="end"
                  >
                    <FreeBreakfastIcon />
                  </IconButton>
                </Typography>
              </Grid>
            ) : (
              InformationData.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index} >
                  <Card className={classes.cardsMaxF}>
                    <CardActionArea onClick={() => getNpsDetail(item.AnswerHeaderId, item.WorkOrderId, item.ServiceShopId)}>
                      <CardContent className={classes.cardsContentMaxF}>
                        <Typography gutterBottom variant="h6" component="h1">
                          <Chip
                            style={{
                              color: ('red')
                            }}
                            icon={<QuestionAnswerIcon />}
                            label={moment(item.SurveyDate).format('DD.MM.YYYY  HH:mm')}
                          />
                        </Typography>
                        <Typography
                          variant="body2"
                          color="primary"
                          component="p"
                        >
                          <br />
                          {t('lblSurveyDate') + ': ' +
                            moment(item.SurveyDate).format('DD.MM.YYYY')}
                          <br />
                          {t('lblWorkOrderId') + ': ' + item.WorkOrderId}
                          <br />
                          {t('lblServiceShopId') + item.ServiceShopId}
                          <br />
                          {t('lblType') + ': ' + item.Type}
                          <br />
                          {t('lblSurveyDsc') + ': ' + item.SurveyDsc}
                          <br />
                          {item.NpsScore ? t('lblScala') + ': ' + item.NpsScore : t('lblScala') + ': 0'}
                          <br />
                          {item.LowReason ? t('lblLowReason') + ': ' + item.LowReason : ''}
                          <br />
                          <br />
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      {item.AnswerHeaderId === 0 ? '' :
                        <Button
                          size="small"
                          //variant="contained"
                          style={{
                            marginLeft: 75
                          }}
                          endIcon={<CreateIcon>{t('lblDetail')}</CreateIcon>}
                          onClick={() => {
                            setInformationDetailPopup(true)
                            setWorkOrderId(item.WorkOrderId)
                            setInfoServiceShopId(item.ServiceShopId)
                          }}
                        >
                          {t('lblDetail')}
                        </Button>
                      }
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setInformationPopup(false)
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={InformationDetailPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInformationDetailPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"
          style={{
            textAlign: 'center'
          }}
        >{t('lblNPS')}</DialogTitle>
        <DialogContent className={classes.backdrop}>
          <DialogContent>
            <InformationSurvey ReceiptNo={workOrderId} ServiceShopId={infoServiceShopId} />
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setInformationDetailPopup(false);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>


      <Dialog
        open={insertAssetPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInsertAssetPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title"
          style={{
            textAlign: 'center'
          }}
        >{t('lblAssetInsert')}</DialogTitle> */}
        <DialogContent className={classes.backdrop}>
          <AssertInsertDialog />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            setInsertAssetPopup(false);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={insertAssetDaysPopup}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setInsertAssetDaysPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className={classes.backdrop}>
          <AssertInsertDaysDialog WorkOrderId={savedWorkOrderId} closePopup={() => closeInserAssetDaysPopup()} />
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={() => {
            setInsertAssetPopup(false);
          }} color="secondary">
            {t('lblSave')}
          </Button>
          <Button onClick={() => {
            setInsertAssetPopup(false);
          }} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions> */}
      </Dialog>

      <Dialog
        fullScreen
        open={OmniChannelDialog}
        onClose={event => setOmniChannelDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t('lblOmniChannel')}</DialogTitle>
        <DialogContent>
          <OmniChannel />
        </DialogContent>
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setOmniChannelDialog(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
      </Dialog>

      {/*Email2Case Dialog*/}
      <EmailThreadDialog
        open={emailThreadDialogOpen}
        onClose={() => setEmailThreadDialogOpen(false)}
        consumerId={formData.ConsumerId}
      />

      {/*Value Proposition*/}
      <Dialog
        open={ValuePropositionDialog}
        onClose={event => setValuePropositionDialog(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        // maxWidth
        // fullWidth
        fullScreen
      >
        {/* <DialogTitle id="alert-dialog-title">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span>{t('lblValueProposition')}</span>
              <IconButton
                color="primary"
                onClick={event => setValuePropositionDialog(false)}
                aria-label="close"
                style={{ marginRight: '-12px' }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </DialogTitle> */}
        <DialogTitle id="alert-dialog-title">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <IconButton
              color="primary"
              onClick={handleCloseDialog}
              aria-label="close"
              style={{ position: 'absolute', right: 0 }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <ProductListPage consumerId={formData.ConsumerId} setValuePropositionDialog={setValuePropositionDialog} />
        </DialogContent>
      </Dialog>

      {/*MATERIAL ORDERS*/}
      <Dialog
        open={openMaterialOrdersPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        onClose={() => setOpenMaterialOrdersPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" style={{ display: 'flex', alignItems: 'center' }}>
          <span style={{ marginRight: 'auto' }}>{t('lblMaterialOrders')}</span>
          <Button
            style={{ borderRadius: '50%', backgroundColor: '#A9B388', width: '40px', height: '40px', minWidth: 'unset', marginLeft: '500px' }}
            onClick={() => {
              setOpenMaterialOrder(true)
            }}
          >
            <AddIcon style={{ fontSize: '24px', color: 'white' }} />
          </Button>
        </DialogTitle>
        <DialogContent className={classes.backdrop}>
          <Grid container spacing={1}>
            {!consumerMaterialOrders ? (
              <div />
            ) : (
              consumerMaterialOrders.map((item, index) => (
                <Grid item xs={12} sm={3} lg={3} key={index}>
                  <Card
                    className={classes.cardsMaxM}
                    onMouseEnter={() => setFabVisible(index)}
                    onMouseLeave={() => setFabVisible(null)}
                    onClick={() => GetMaterialOrderFromOrderId(item)}
                  >
                    <CardContent className={classes.cardsContentMax}>
                      <Typography gutterBottom variant="h6" component="h1">
                        {item.OrderId} -{' '}
                        <Chip
                          style={{
                            color: (item.StatusId === 1 ? 'green' : (item.StatusId === 2 ? 'red' : (item.StatusId === 3 ? 'purple' : 'gray')))
                          }}
                          icon={item.StatusId === 1 ? <ShoppingCartIcon style={{ color: 'green' }} /> : item.StatusId === 2 ? <CancelIcon style={{ color: 'red' }} /> : item.StatusId === 3 ? <SendIcon style={{ color: 'purple' }} /> : ''}
                          label={item.MaterialOrderStatus}
                        />
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        <br />
                        {t('lblOrderDate') + ': ' +
                          moment(item.OrderDate).format('DD.MM.YYYY')}
                        <br />
                        {t('lblWorkOrderId') + ': ' + item.WorkOrderId}
                        <br />
                        {t('lblSapNo') + ': ' + item.SapNo}
                        <br />
                        {t('lblServiceShop') + ': ' + item.ServiceShop}
                        < br />
                        {t('lblShipTo') + ': ' + item.ShipTo}
                        < br />
                        {t('lblDsc') + ': ' + item.Dsc}
                        < br />
                      </Typography>
                    </CardContent>
                    <CardActions>
                      <Fab
                        color="secondary"
                        size="small"
                        className={`${classes.fab} ${fabVisible === index ? classes.fabVisible : ''}`}
                      >
                        <ArrowRightAltIcon style={{ fontSize: '24px', verticalAlign: 'middle' }} />
                      </Fab>
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenMaterialOrdersPopUp(false)} color="primary">
            {t('lblClose')}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={SnackbarOpen} autoHideDuration={10000} onClose={handleClose2}>
        <Alert
          onClose={handleClose2}
          message={responseMessage.ErrorDescription}
          variant={uyariTip}
        />
      </Snackbar>

    </>
  );
}

AssignedJob.propTypes = {
  className: PropTypes.string
};

export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials,
  setTask
})(AssignedJob);
